import axios from 'axios'
import session from 'vue-cookies'
//const BASE_URL =  'https://b4pssbgsg8.execute-api.us-east-1.amazonaws.com/prod/races'
const BASE_URL =  'https://api.bertiebets.com/races'
const BASE_URL_V2 =  'https://api.bertiebets.com/v2/races'
var key = session.get('bertiebets.admin.key')
export async function getRaces(date) {
  var response = await axios.get(BASE_URL + "?date=" + date, {headers:{'x-api-key' : key}})
  if (response.status === 200) {
    return response.data
  }
}

export async function getRacesv2(date) {
  var response = await axios.get(BASE_URL_V2 + "?date=" + date, {headers:{'x-api-key' : key}})
  if (response.status === 200) {
    return response.data.sort((a,b) => b.time > a.time? 1:-1).sort((a,b) => a.location > b.location? 1:-1)
  }
  //return response
}

var mock = [
    {
        "raceType": "chase",
        "distance": "3m 60y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:26:43.195Z",
        "time": "13:00",
        "country": "GB",
        "class": "jumps_class_4",
        "skillWinner": "Head On",
        "going": "Good-good to soft in places",
        "trackType": [
            "galloping",
            "level"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 4882.883999999999,
        "experienceCategory": "standard",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 3,
        "_id": "21-Mar-2022_13:00_Southwell",
        "horses": [
            {
                "weightNumber": 166,
                "country": "IRE",
                "raceId": "21-Mar-2022_13:00_Southwell",
                "rating": {
                    "pi": 0.1678894062700486,
                    "tau": 5.277714775631359
                },
                "weight": "11-12",
                "equipment": "t",
                "accuracy": 2.1637891225217367,
                "jockey": "C J Todd",
                "url": "/form/horse/Head-On/IRE/3262255",
                "score": 0.052086546536361265,
                "skillObj": {
                    "mu": 30.66242507450638,
                    "sigma": 2.1637891225217367,
                    "maxSkill": 34.99000331954986,
                    "minSkill": 26.334846829462908,
                    "muHistory": [
                        {
                            "date": 20210822,
                            "skill": 36.3427692790222
                        },
                        {
                            "date": 20210913,
                            "skill": 39.08759148840271
                        },
                        {
                            "date": 20210923,
                            "skill": 32.32080148464532
                        },
                        {
                            "date": 20211105,
                            "skill": 34.755301443218
                        },
                        {
                            "date": 20211112,
                            "skill": 31.435662874060093
                        },
                        {
                            "date": 20220321,
                            "skill": 30.66242507450638
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "Ian Williams",
                "odds": "3/1",
                "skill": 31.435662874060093,
                "name": "Head On",
                "_id": "Head On_21-Mar-2022_13:00_Southwell",
                "position": 100,
                "age": "6",
                "oddsNumber": 3
            },
            {
                "weightNumber": 156,
                "country": "IRE",
                "raceId": "21-Mar-2022_13:00_Southwell",
                "rating": {
                    "pi": 1.080651725562305,
                    "tau": 33.23305362579541
                },
                "weight": "11-2",
                "equipment": "t",
                "accuracy": 0.945589555229966,
                "jockey": "Tabitha Worsley",
                "url": "/form/horse/Steel-Wave/IRE/2838248",
                "score": 0.05099124155729154,
                "skillObj": {
                    "mu": 30.632241863832995,
                    "sigma": 0.945589555229966,
                    "maxSkill": 32.523420974292925,
                    "minSkill": 28.741062753373065,
                    "muHistory": [
                        {
                            "date": 20180511,
                            "skill": 36.10230416429741
                        },
                        {
                            "date": 20180606,
                            "skill": 28.97599175576282
                        },
                        {
                            "date": 20180625,
                            "skill": 25.749080751896958
                        },
                        {
                            "date": 20180803,
                            "skill": 28.90218794970943
                        },
                        {
                            "date": 20180825,
                            "skill": 30.517460646236117
                        },
                        {
                            "date": 20180909,
                            "skill": 30.717567478342833
                        },
                        {
                            "date": 20181228,
                            "skill": 31.087713182321018
                        },
                        {
                            "date": 20190518,
                            "skill": 32.05218776662711
                        },
                        {
                            "date": 20190604,
                            "skill": 32.8898464489758
                        },
                        {
                            "date": 20190621,
                            "skill": 32.707285886303666
                        },
                        {
                            "date": 20190802,
                            "skill": 33.01142751232771
                        },
                        {
                            "date": 20190826,
                            "skill": 32.738972946955954
                        },
                        {
                            "date": 20191113,
                            "skill": 31.81117940062646
                        },
                        {
                            "date": 20210516,
                            "skill": 31.374231516603512
                        },
                        {
                            "date": 20210608,
                            "skill": 31.3896427384356
                        },
                        {
                            "date": 20210713,
                            "skill": 30.841692748716905
                        },
                        {
                            "date": 20210725,
                            "skill": 30.497061392030044
                        },
                        {
                            "date": 20210814,
                            "skill": 30.61831971953427
                        },
                        {
                            "date": 20210925,
                            "skill": 29.97060899964279
                        },
                        {
                            "date": 20211026,
                            "skill": 29.885090780796023
                        },
                        {
                            "date": 20211028,
                            "skill": 30.311621736131304
                        },
                        {
                            "date": 20211111,
                            "skill": 30.145296015238582
                        },
                        {
                            "date": 20211215,
                            "skill": 29.865422208588694
                        },
                        {
                            "date": 20220112,
                            "skill": 30.054357963721678
                        },
                        {
                            "date": 20220120,
                            "skill": 30.390622941169102
                        },
                        {
                            "date": 20220210,
                            "skill": 30.567532442102863
                        },
                        {
                            "date": 20220304,
                            "skill": 30.752788192239237
                        },
                        {
                            "date": 20220321,
                            "skill": 30.632241863832995
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "G D Hanmer",
                "odds": "13/8",
                "skill": 30.752788192239237,
                "name": "Steel Wave",
                "_id": "Steel Wave_21-Mar-2022_13:00_Southwell",
                "position": 100,
                "age": "12",
                "oddsNumber": 1.625
            },
            {
                "weightNumber": 166,
                "raceId": "21-Mar-2022_13:00_Southwell",
                "rating": {
                    "pi": 0.20668310358438968,
                    "tau": 6.234833886104262
                },
                "weight": "11-12",
                "accuracy": 1.9891178422334492,
                "jockey": "Adam Wedge",
                "url": "/form/horse/Percussion/GB/3304389",
                "score": 0.04761497566241129,
                "skillObj": {
                    "mu": 29.767685163057067,
                    "sigma": 1.9891178422334492,
                    "maxSkill": 33.74592084752396,
                    "minSkill": 25.789449478590168,
                    "muHistory": [
                        {
                            "date": 20210713,
                            "skill": 32.168353222930456
                        },
                        {
                            "date": 20211130,
                            "skill": 30.319219072923012
                        },
                        {
                            "date": 20211226,
                            "skill": 32.618046658267446
                        },
                        {
                            "date": 20220125,
                            "skill": 32.64340379848275
                        },
                        {
                            "date": 20220228,
                            "skill": 30.166151842976124
                        },
                        {
                            "date": 20220321,
                            "skill": 29.767685163057067
                        }
                    ]
                },
                "trainer": "L J Morgan",
                "odds": "4/1",
                "skill": 30.166151842976124,
                "name": "Percussion",
                "_id": "Percussion_21-Mar-2022_13:00_Southwell",
                "position": 100,
                "age": "7",
                "oddsNumber": 4
            },
            {
                "weightNumber": 162,
                "country": "FR",
                "raceId": "21-Mar-2022_13:00_Southwell",
                "rating": {
                    "pi": 0.40406526513566826,
                    "tau": 11.37843059647196
                },
                "weight": "11-8",
                "accuracy": 1.4931122605193565,
                "jockey": "Tom Cannon",
                "url": "/form/horse/Peur-De-Rien/FR/2998737",
                "score": -1,
                "skillObj": {
                    "mu": 28.170456810122698,
                    "sigma": 1.4931122605193565,
                    "maxSkill": 31.156681331161412,
                    "minSkill": 25.184232289083983,
                    "muHistory": [
                        {
                            "date": 20200902,
                            "skill": 36.469835479267765
                        },
                        {
                            "date": 20201013,
                            "skill": 24.850805310119956
                        },
                        {
                            "date": 20201106,
                            "skill": 23.544491480785357
                        },
                        {
                            "date": 20201211,
                            "skill": 26.48275942740361
                        },
                        {
                            "date": 20210320,
                            "skill": 28.873177617773155
                        },
                        {
                            "date": 20210421,
                            "skill": 29.421883088640246
                        },
                        {
                            "date": 20210517,
                            "skill": 29.85493872964957
                        },
                        {
                            "date": 20211112,
                            "skill": 29.864861365481993
                        },
                        {
                            "date": 20211214,
                            "skill": 29.060017930451703
                        },
                        {
                            "date": 20220123,
                            "skill": 28.15988301457082
                        },
                        {
                            "date": 20220321,
                            "skill": 28.170456810122698
                        }
                    ]
                },
                "trainer": "O Sherwood",
                "odds": "7/1",
                "skill": 28.15988301457082,
                "name": "Peur De Rien",
                "_id": "Peur De Rien_21-Mar-2022_13:00_Southwell",
                "position": 100,
                "age": "9",
                "oddsNumber": 7
            },
            {
                "weightNumber": 164,
                "country": "IRE",
                "raceId": "21-Mar-2022_13:00_Southwell",
                "rating": {
                    "pi": 0.28825354862225633,
                    "tau": 7.152026352424996
                },
                "weight": "11-10",
                "equipment": "t",
                "accuracy": 1.7305029498775952,
                "jockey": "Kielan Woods",
                "url": "/form/horse/Dont-Ask/IRE/2968053",
                "score": 0.04749482229233932,
                "skillObj": {
                    "mu": 25.38975005222934,
                    "sigma": 1.7305029498775952,
                    "maxSkill": 28.850755951984528,
                    "minSkill": 21.92874415247415,
                    "muHistory": [
                        {
                            "date": 20191211,
                            "skill": 23.55070091537991
                        },
                        {
                            "date": 20191226,
                            "skill": 22.236137534706625
                        },
                        {
                            "date": 20210504,
                            "skill": 26.223117584994252
                        },
                        {
                            "date": 20210725,
                            "skill": 26.948113808750108
                        },
                        {
                            "date": 20210823,
                            "skill": 25.270784872231705
                        },
                        {
                            "date": 20211212,
                            "skill": 25.43073492804335
                        },
                        {
                            "date": 20220123,
                            "skill": 24.81158128532674
                        },
                        {
                            "date": 20220321,
                            "skill": 25.38975005222934
                        }
                    ]
                },
                "trainer": "A M Hales",
                "skill": 24.81158128532674,
                "name": "Don't Ask",
                "_id": "Don't Ask_21-Mar-2022_13:00_Southwell",
                "position": 100,
                "age": "9"
            },
            {
                "weightNumber": 146,
                "country": "IRE",
                "raceId": "21-Mar-2022_13:00_Southwell",
                "rating": {
                    "pi": 0.35708422897287906,
                    "tau": 8.85715822078852
                },
                "weight": "10-6",
                "equipment": "t",
                "accuracy": 1.576768930608025,
                "jockey": "S Bowen",
                "url": "/form/horse/Coole-Lion/IRE/3071923",
                "score": -1,
                "skillObj": {
                    "mu": 25.283105776147856,
                    "sigma": 1.576768930608025,
                    "maxSkill": 28.436643637363908,
                    "minSkill": 22.129567914931805,
                    "muHistory": [
                        {
                            "date": 20191228,
                            "skill": 18.12350630727615
                        },
                        {
                            "date": 20200204,
                            "skill": 19.946420851276635
                        },
                        {
                            "date": 20200714,
                            "skill": 26.78902936956266
                        },
                        {
                            "date": 20200824,
                            "skill": 30.04852275118336
                        },
                        {
                            "date": 20210929,
                            "skill": 27.803920548147573
                        },
                        {
                            "date": 20211109,
                            "skill": 27.046390127207218
                        },
                        {
                            "date": 20211212,
                            "skill": 25.790105512500155
                        },
                        {
                            "date": 20211226,
                            "skill": 25.215517942101837
                        },
                        {
                            "date": 20220210,
                            "skill": 24.80411483381763
                        },
                        {
                            "date": 20220321,
                            "skill": 25.283105776147856
                        }
                    ]
                },
                "trainer": "Mrs Caroline Bailey",
                "odds": "14/1",
                "skill": 24.80411483381763,
                "name": "Coole Lion",
                "_id": "Coole Lion_21-Mar-2022_13:00_Southwell",
                "position": 100,
                "age": "8",
                "oddsNumber": 14
            }
        ],
        "id": "#20220321#21-Mar-2022_13:00_Southwell",
        "classNumber": 4,
        "weather": "Sunny spells",
        "postNumber": 1,
        "predictedWinner": "Head On",
        "location": "Southwell",
        "winnerPrizeMoney": "£8,169",
        "skillWinnerOdds": 3,
        "distanceCategory": "3miler",
        "runners": 6,
        "raceText": "Cazoo Handicap Chase",
        "isHandicap": true,
        "type": "jumps",
        "tagVersion": 42
    },
    {
        "raceType": "chase",
        "distance": "1m 7f 182y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:26:45.041Z",
        "time": "13:35",
        "country": "GB",
        "class": "jumps_class_4",
        "skillWinner": "Minella Hub",
        "going": "Good-good to soft in places",
        "trackType": [
            "galloping",
            "level"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 3183.9367999999995,
        "experienceCategory": "standard",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 3.5,
        "_id": "21-Mar-2022_13:35_Southwell",
        "horses": [
            {
                "weightNumber": 171,
                "country": "IRE",
                "raceId": "21-Mar-2022_13:35_Southwell",
                "rating": {
                    "pi": 0.03559650849107509,
                    "tau": 1.28191674672629
                },
                "weight": "12-3",
                "accuracy": 3.5657812509039877,
                "jockey": "Harry Bannister",
                "url": "/form/horse/Minella-Hub/IRE/3151423",
                "score": 0.06485447294836032,
                "skillObj": {
                    "mu": 33.31555020592927,
                    "sigma": 3.5657812509039877,
                    "maxSkill": 40.44711270773725,
                    "minSkill": 26.183987704121293,
                    "muHistory": [
                        {
                            "date": 20220228,
                            "skill": 36.01242933833518
                        },
                        {
                            "date": 20220321,
                            "skill": 33.31555020592927
                        }
                    ]
                },
                "trainer": "P G Murphy",
                "odds": "6/4",
                "skill": 36.01242933833518,
                "name": "Minella Hub",
                "_id": "Minella Hub_21-Mar-2022_13:35_Southwell",
                "position": 100,
                "age": "7",
                "oddsNumber": 1.5
            },
            {
                "weightNumber": 166,
                "country": "IRE",
                "raceId": "21-Mar-2022_13:35_Southwell",
                "rating": {
                    "pi": 0.30630536654024343,
                    "tau": 10.323457642356754
                },
                "weight": "11-12",
                "equipment": "t",
                "accuracy": 1.6983503494910563,
                "jockey": "C J Todd",
                "url": "/form/horse/Out-On-The-Tear/IRE/3135862",
                "score": -1,
                "skillObj": {
                    "mu": 33.37427551675144,
                    "sigma": 1.6983503494910563,
                    "maxSkill": 36.770976215733555,
                    "minSkill": 29.977574817769327,
                    "muHistory": [
                        {
                            "date": 20201120,
                            "skill": 33.645773400071114
                        },
                        {
                            "date": 20201215,
                            "skill": 37.55753548162478
                        },
                        {
                            "date": 20210103,
                            "skill": 36.577891860486105
                        },
                        {
                            "date": 20211020,
                            "skill": 35.196019568254975
                        },
                        {
                            "date": 20211127,
                            "skill": 33.54222058341356
                        },
                        {
                            "date": 20211203,
                            "skill": 32.7414308575031
                        },
                        {
                            "date": 20211214,
                            "skill": 33.43208557775746
                        },
                        {
                            "date": 20220108,
                            "skill": 33.70315629452226
                        },
                        {
                            "date": 20220321,
                            "skill": 33.37427551675144
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "S Allwood",
                "odds": "7/1",
                "skill": 33.70315629452226,
                "name": "Out On The Tear",
                "_id": "Out On The Tear_21-Mar-2022_13:35_Southwell",
                "position": 100,
                "age": "8",
                "oddsNumber": 7
            },
            {
                "weightNumber": 170,
                "country": "IRE",
                "raceId": "21-Mar-2022_13:35_Southwell",
                "rating": {
                    "pi": 0.292414095161616,
                    "tau": 9.372659440757639
                },
                "weight": "12-2",
                "equipment": "t",
                "accuracy": 1.733623752177579,
                "jockey": "Harry Skelton",
                "url": "/form/horse/Across-The-Line/IRE/3175263",
                "score": 0.0661446944990986,
                "skillObj": {
                    "mu": 31.98677930749232,
                    "sigma": 1.733623752177579,
                    "maxSkill": 35.45402681184748,
                    "minSkill": 28.519531803137163,
                    "muHistory": [
                        {
                            "date": 20211013,
                            "skill": 29.316452457287046
                        },
                        {
                            "date": 20211020,
                            "skill": 30.041104601941438
                        },
                        {
                            "date": 20211112,
                            "skill": 32.28463974404054
                        },
                        {
                            "date": 20211130,
                            "skill": 33.59713135147132
                        },
                        {
                            "date": 20211229,
                            "skill": 31.346346932185387
                        },
                        {
                            "date": 20220115,
                            "skill": 31.659336217985796
                        },
                        {
                            "date": 20220211,
                            "skill": 31.379631147188764
                        },
                        {
                            "date": 20220304,
                            "skill": 32.05269375122773
                        },
                        {
                            "date": 20220321,
                            "skill": 31.98677930749232
                        }
                    ]
                },
                "trainer": "D Skelton",
                "odds": "7/2",
                "skill": 32.05269375122773,
                "name": "Across The Line",
                "_id": "Across The Line_21-Mar-2022_13:35_Southwell",
                "position": 100,
                "age": "7",
                "oddsNumber": 3.5
            },
            {
                "weightNumber": 160,
                "country": "IRE",
                "raceId": "21-Mar-2022_13:35_Southwell",
                "rating": {
                    "pi": 0.056881730757125284,
                    "tau": 1.7597243513036078
                },
                "weight": "11-6",
                "equipment": "p",
                "accuracy": 3.168352473521299,
                "jockey": "Adam Wedge",
                "url": "/form/horse/Clear-The-Runway/IRE/3178353",
                "score": 0.0552223546520341,
                "skillObj": {
                    "mu": 31.28458872406536,
                    "sigma": 3.168352473521299,
                    "maxSkill": 37.62129367110796,
                    "minSkill": 24.947883777022763,
                    "muHistory": [
                        {
                            "date": 20220302,
                            "skill": 30.936547251301352
                        },
                        {
                            "date": 20220321,
                            "skill": 31.28458872406536
                        }
                    ]
                },
                "trainer": "L J Morgan",
                "odds": "2/1",
                "skill": 30.936547251301352,
                "name": "Clear The Runway",
                "_id": "Clear The Runway_21-Mar-2022_13:35_Southwell",
                "position": 100,
                "age": "6",
                "oddsNumber": 2
            },
            {
                "weightNumber": 141,
                "country": "IRE",
                "raceId": "21-Mar-2022_13:35_Southwell",
                "rating": {
                    "pi": 0.4355721921666016,
                    "tau": 12.090426094248091
                },
                "weight": "10-1",
                "equipment": "p",
                "accuracy": 1.4503716035748964,
                "jockey": "Miss Roisin Leech",
                "url": "/form/horse/Old-Harry-Rocks/IRE/2942707",
                "score": -1,
                "skillObj": {
                    "mu": 28.208790086754192,
                    "sigma": 1.4503716035748964,
                    "maxSkill": 31.109533293903986,
                    "minSkill": 25.308046879604397,
                    "muHistory": [
                        {
                            "date": 20190420,
                            "skill": 31.579983046937357
                        },
                        {
                            "date": 20190618,
                            "skill": 24.018887202023013
                        },
                        {
                            "date": 20190625,
                            "skill": 27.069626455375765
                        },
                        {
                            "date": 20190705,
                            "skill": 28.032662206065513
                        },
                        {
                            "date": 20201210,
                            "skill": 26.928865994782097
                        },
                        {
                            "date": 20201231,
                            "skill": 26.274086980589487
                        },
                        {
                            "date": 20210403,
                            "skill": 27.63714269040642
                        },
                        {
                            "date": 20210510,
                            "skill": 28.275470254018384
                        },
                        {
                            "date": 20210530,
                            "skill": 27.92705723743415
                        },
                        {
                            "date": 20210621,
                            "skill": 27.398620906389883
                        },
                        {
                            "date": 20220228,
                            "skill": 27.757571102297632
                        },
                        {
                            "date": 20220321,
                            "skill": 28.208790086754192
                        }
                    ]
                },
                "jockeyClaiming": 7,
                "trainer": "Mrs S Leech",
                "odds": "33/1",
                "skill": 27.757571102297632,
                "name": "Old Harry Rocks",
                "_id": "Old Harry Rocks_21-Mar-2022_13:35_Southwell",
                "position": 100,
                "age": "10",
                "oddsNumber": 33
            }
        ],
        "id": "#20220321#21-Mar-2022_13:35_Southwell",
        "classNumber": 4,
        "weather": "Sunny spells",
        "postNumber": 2,
        "predictedWinner": "Across The Line",
        "location": "Southwell",
        "winnerPrizeMoney": "£8,169",
        "skillWinnerOdds": 1.5,
        "distanceCategory": "2miler",
        "runners": 5,
        "raceText": "Download The At The Races App Handicap Chase",
        "isHandicap": true,
        "type": "jumps",
        "tagVersion": 42
    },
    {
        "raceType": "chase",
        "distance": "1m 7f 149y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:25:17.314Z",
        "time": "13:45",
        "country": "GB",
        "class": "jumps_class_5",
        "skillWinner": "Ambion Hill",
        "going": "Good to soft-soft in places",
        "trackType": [
            "tight",
            "level"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 3153.7616,
        "experienceCategory": "novice",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 3,
        "_id": "21-Mar-2022_13:45_Wincanton",
        "horses": [
            {
                "weightNumber": 166,
                "country": "IRE",
                "raceId": "21-Mar-2022_13:45_Wincanton",
                "rating": {
                    "pi": 0.05035023520522994,
                    "tau": 1.7421122627492933
                },
                "weight": "11-12",
                "accuracy": 3.261560960618331,
                "jockey": "Brendan Powell",
                "url": "/form/horse/Ambion-Hill/IRE/3076803",
                "score": 0.052829546886470895,
                "skillObj": {
                    "mu": 30.85291516562259,
                    "sigma": 3.261560960618331,
                    "maxSkill": 37.376037086859256,
                    "minSkill": 24.32979324438593,
                    "muHistory": [
                        {
                            "date": 20211206,
                            "skill": 34.599883310343266
                        },
                        {
                            "date": 20220321,
                            "skill": 30.85291516562259
                        }
                    ]
                },
                "trainer": "C L Tizzard",
                "odds": "7/2",
                "skill": 34.599883310343266,
                "name": "Ambion Hill",
                "_id": "Ambion Hill_21-Mar-2022_13:45_Wincanton",
                "position": 100,
                "age": "7",
                "oddsNumber": 3.5
            },
            {
                "weightNumber": 163,
                "country": "IRE",
                "raceId": "21-Mar-2022_13:45_Wincanton",
                "rating": {
                    "pi": 0.0902656632661915,
                    "tau": 2.680977631029595
                },
                "weight": "11-9",
                "equipment": "h",
                "accuracy": 2.739446379444577,
                "jockey": "Lorcan Williams",
                "url": "/form/horse/Doyannie/IRE/3021460",
                "score": 0.0530219827851738,
                "skillObj": {
                    "mu": 28.871460532441944,
                    "sigma": 2.739446379444577,
                    "maxSkill": 34.350353291331096,
                    "minSkill": 23.39256777355279,
                    "muHistory": [
                        {
                            "date": 20211116,
                            "skill": 23.91751090166405
                        },
                        {
                            "date": 20220118,
                            "skill": 29.700968607780013
                        },
                        {
                            "date": 20220321,
                            "skill": 28.871460532441944
                        }
                    ]
                },
                "trainer": "Jack Barber",
                "odds": "11/4",
                "skill": 29.700968607780013,
                "name": "Doyannie",
                "_id": "Doyannie_21-Mar-2022_13:45_Wincanton",
                "position": 100,
                "age": "8",
                "oddsNumber": 2.75
            },
            {
                "weightNumber": 161,
                "country": "FR",
                "raceId": "21-Mar-2022_13:45_Wincanton",
                "rating": {
                    "pi": 0.2827964695137662,
                    "tau": 8.177965812101643
                },
                "weight": "11-7",
                "equipment": "t",
                "accuracy": 1.75525806312395,
                "jockey": "Ben Godfrey",
                "url": "/form/horse/Eros/FR/3011082",
                "score": 0.049017221438692776,
                "skillObj": {
                    "mu": 28.686377026129,
                    "sigma": 1.75525806312395,
                    "maxSkill": 32.1968931523769,
                    "minSkill": 25.1758608998811,
                    "muHistory": [
                        {
                            "date": 20211107,
                            "skill": 26.13671558528165
                        },
                        {
                            "date": 20211210,
                            "skill": 25.487477655785927
                        },
                        {
                            "date": 20211231,
                            "skill": 26.5650248096464
                        },
                        {
                            "date": 20220118,
                            "skill": 28.017839977033848
                        },
                        {
                            "date": 20220208,
                            "skill": 27.790278432098006
                        },
                        {
                            "date": 20220302,
                            "skill": 28.91820335014313
                        },
                        {
                            "date": 20220321,
                            "skill": 28.686377026129
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "Kayley Woollacott",
                "odds": "5/2",
                "skill": 28.91820335014313,
                "name": "Eros",
                "_id": "Eros_21-Mar-2022_13:45_Wincanton",
                "position": 100,
                "age": "8",
                "oddsNumber": 2.5
            },
            {
                "weightNumber": 162,
                "country": "FR",
                "raceId": "21-Mar-2022_13:45_Wincanton",
                "rating": {
                    "pi": 0.16403552387674403,
                    "tau": 4.098354262185164
                },
                "weight": "11-8",
                "equipment": "t",
                "accuracy": 2.202770718805997,
                "jockey": "Chester Williams",
                "url": "/form/horse/Folly-Gate/FR/3141409",
                "score": 0.05306896409074956,
                "skillObj": {
                    "mu": 25.652431524651092,
                    "sigma": 2.202770718805997,
                    "maxSkill": 30.057972962263086,
                    "minSkill": 21.246890087039098,
                    "muHistory": [
                        {
                            "date": 20201028,
                            "skill": 20.413405476776482
                        },
                        {
                            "date": 20201122,
                            "skill": 21.318781258690795
                        },
                        {
                            "date": 20211231,
                            "skill": 25.30404221510592
                        },
                        {
                            "date": 20220208,
                            "skill": 24.984553134140988
                        },
                        {
                            "date": 20220321,
                            "skill": 25.652431524651092
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "Mrs J Williams",
                "odds": "3/1",
                "skill": 24.984553134140988,
                "name": "Folly Gate",
                "_id": "Folly Gate_21-Mar-2022_13:45_Wincanton",
                "position": 100,
                "age": "7",
                "oddsNumber": 3
            },
            {
                "weightNumber": 151,
                "country": "FR",
                "raceId": "21-Mar-2022_13:45_Wincanton",
                "rating": {
                    "pi": 0.27407893298517433,
                    "tau": 6.442244209379665
                },
                "weight": "10-11",
                "equipment": "t",
                "accuracy": 1.7798363320578647,
                "jockey": "James Best",
                "url": "/form/horse/Forget-You-Not/FR/3140824",
                "score": -1,
                "skillObj": {
                    "mu": 24.201701603761663,
                    "sigma": 1.7798363320578647,
                    "maxSkill": 27.761374267877393,
                    "minSkill": 20.642028939645932,
                    "muHistory": [
                        {
                            "date": 20201027,
                            "skill": 19.622378600317248
                        },
                        {
                            "date": 20201231,
                            "skill": 19.43897455598633
                        },
                        {
                            "date": 20210419,
                            "skill": 21.22360627764121
                        },
                        {
                            "date": 20211003,
                            "skill": 21.49570257625369
                        },
                        {
                            "date": 20211019,
                            "skill": 24.071996664722572
                        },
                        {
                            "date": 20211112,
                            "skill": 23.505068920157186
                        },
                        {
                            "date": 20220321,
                            "skill": 24.201701603761663
                        }
                    ]
                },
                "trainer": "Miss J Plessis",
                "odds": "12/1",
                "skill": 23.505068920157186,
                "name": "Forget You Not",
                "_id": "Forget You Not_21-Mar-2022_13:45_Wincanton",
                "position": 100,
                "age": "7",
                "oddsNumber": 12
            },
            {
                "weightNumber": 140,
                "country": "IRE",
                "raceId": "21-Mar-2022_13:45_Wincanton",
                "rating": {
                    "pi": 0.014399999999999998,
                    "tau": 0.35999999999999993
                },
                "weight": "10-0",
                "equipment": "p",
                "accuracy": 4.1383907084170435,
                "jockey": "David Noonan",
                "url": "/form/horse/Stinggrey/IRE/3359949",
                "score": -1,
                "skillObj": {
                    "mu": 27.00397756222756,
                    "sigma": 4.1383907084170435,
                    "maxSkill": 35.280758979061645,
                    "minSkill": 18.727196145393474,
                    "muHistory": [
                        {
                            "date": 20220321,
                            "skill": 27.00397756222756
                        }
                    ]
                },
                "trainer": "Maxwell Young",
                "odds": "50/1",
                "skill": 0,
                "name": "Stinggrey",
                "_id": "Stinggrey_21-Mar-2022_13:45_Wincanton",
                "position": 100,
                "age": "9",
                "oddsNumber": 50
            }
        ],
        "id": "#20220321#21-Mar-2022_13:45_Wincanton",
        "classNumber": 5,
        "weather": "Sunny spells",
        "postNumber": 1,
        "predictedWinner": "Folly Gate",
        "location": "Wincanton",
        "winnerPrizeMoney": "£3,158",
        "skillWinnerOdds": 3.5,
        "distanceCategory": "2miler",
        "runners": 6,
        "raceText": "Racing TV Extra Novices' Handicap Chase",
        "isHandicap": true,
        "type": "jumps",
        "tagVersion": 42
    },
    {
        "raceType": "hurdle",
        "distance": "2m 4f 114y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:25:13.123Z",
        "time": "13:55",
        "country": "GB",
        "class": "jumps_class_4",
        "skillWinner": "Joyful Kit",
        "going": "Good-good to soft in places",
        "trackType": [
            "tight",
            "undulating"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 4127.5936,
        "experienceCategory": "novice",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 4.5,
        "_id": "21-Mar-2022_13:55_Plumpton",
        "horses": [
            {
                "weightNumber": 152,
                "country": "IRE",
                "raceId": "21-Mar-2022_13:55_Plumpton",
                "rating": {
                    "pi": 0.1762457750430503,
                    "tau": 3.9574578388360884
                },
                "weight": "10-12",
                "accuracy": 2.209962497549743,
                "jockey": "James Bowen",
                "url": "/form/horse/Joyful-Kit/IRE/3266561",
                "score": 0.04819692848635498,
                "skillObj": {
                    "mu": 21.95238491524425,
                    "sigma": 2.209962497549743,
                    "maxSkill": 26.372309910343734,
                    "minSkill": 17.532459920144763,
                    "muHistory": [
                        {
                            "date": 20211101,
                            "skill": 25.72560344994895
                        },
                        {
                            "date": 20211117,
                            "skill": 24.972542195752105
                        },
                        {
                            "date": 20211207,
                            "skill": 25.49868421719658
                        },
                        {
                            "date": 20220110,
                            "skill": 22.4541997552533
                        },
                        {
                            "date": 20220321,
                            "skill": 21.95238491524425
                        }
                    ]
                },
                "trainer": "T Lawes",
                "odds": "11/4",
                "skill": 22.4541997552533,
                "name": "Joyful Kit",
                "_id": "Joyful Kit_21-Mar-2022_13:55_Plumpton",
                "position": 100,
                "age": "6",
                "oddsNumber": 2.75
            },
            {
                "weightNumber": 152,
                "raceId": "21-Mar-2022_13:55_Plumpton",
                "rating": {
                    "pi": 0.0385661314093557,
                    "tau": 0.3746819776222983
                },
                "weight": "10-12",
                "accuracy": 3.7395222440128317,
                "jockey": "Caoilin Quinn",
                "url": "/form/horse/Isle-Of-Rona/GB/3346586",
                "score": -1,
                "skillObj": {
                    "mu": 16.10580761516999,
                    "sigma": 3.7395222440128317,
                    "maxSkill": 23.584852103195654,
                    "minSkill": 8.626763127144326,
                    "muHistory": [
                        {
                            "date": 20220227,
                            "skill": 9.715311438559398
                        },
                        {
                            "date": 20220321,
                            "skill": 16.10580761516999
                        }
                    ]
                },
                "jockeyClaiming": 7,
                "trainer": "W Greatrex",
                "odds": "7/1",
                "skill": 9.715311438559398,
                "name": "Isle Of Rona",
                "_id": "Isle Of Rona_21-Mar-2022_13:55_Plumpton",
                "position": 100,
                "age": "5",
                "oddsNumber": 7
            },
            {
                "weightNumber": 152,
                "country": "IRE",
                "raceId": "21-Mar-2022_13:55_Plumpton",
                "rating": {
                    "pi": 0.014399999999999998,
                    "tau": 0.35999999999999993
                },
                "weight": "10-12",
                "accuracy": 4.5165010134688925,
                "jockey": "Thomas Bellamy",
                "url": "/form/horse/Lady-Wilberry/GB/3276595",
                "score": 0.059094106758608746,
                "skillObj": {
                    "mu": 21.35801357419224,
                    "sigma": 4.5165010134688925,
                    "maxSkill": 30.39101560113002,
                    "minSkill": 12.325011547254453,
                    "muHistory": [
                        {
                            "date": 20220321,
                            "skill": 21.35801357419224
                        }
                    ]
                },
                "trainer": "Keiran Burke",
                "odds": "9/2",
                "skill": 0,
                "name": "Lady Wilberry",
                "_id": "Lady Wilberry_21-Mar-2022_13:55_Plumpton",
                "position": 100,
                "age": "5",
                "oddsNumber": 4.5
            },
            {
                "weightNumber": 152,
                "country": "IRE",
                "raceId": "21-Mar-2022_13:55_Plumpton",
                "rating": {
                    "pi": 0.014399999999999998,
                    "tau": 0.35999999999999993
                },
                "weight": "10-12",
                "accuracy": 4.5065416260823,
                "jockey": "Nico de Boinville",
                "url": "/form/horse/Fishcake/IRE/3383962",
                "score": 0.055060094451743605,
                "skillObj": {
                    "mu": 21.350337828095164,
                    "sigma": 4.5065416260823,
                    "maxSkill": 30.363421080259762,
                    "minSkill": 12.337254575930563,
                    "muHistory": [
                        {
                            "date": 20220321,
                            "skill": 21.350337828095164
                        }
                    ]
                },
                "trainer": "N J Henderson",
                "odds": "11/8",
                "skill": 0,
                "name": "Fishcake",
                "_id": "Fishcake_21-Mar-2022_13:55_Plumpton",
                "position": 100,
                "age": "5",
                "oddsNumber": 1.375
            },
            {
                "weightNumber": 152,
                "country": "FR",
                "raceId": "21-Mar-2022_13:55_Plumpton",
                "rating": {
                    "pi": 0.014399999999999998,
                    "tau": 0.35999999999999993
                },
                "weight": "10-12",
                "accuracy": 4.513543683407626,
                "jockey": "J E Moore",
                "url": "/form/horse/Valencia-Borget/FR/3345693",
                "score": -1,
                "skillObj": {
                    "mu": 21.314433154325094,
                    "sigma": 4.513543683407626,
                    "maxSkill": 30.341520521140346,
                    "minSkill": 12.287345787509842,
                    "muHistory": [
                        {
                            "date": 20220321,
                            "skill": 21.314433154325094
                        }
                    ]
                },
                "trainer": "Mrs S J Humphrey",
                "odds": "8/1",
                "skill": 0,
                "name": "Valencia Borget",
                "_id": "Valencia Borget_21-Mar-2022_13:55_Plumpton",
                "position": 100,
                "age": "5",
                "oddsNumber": 8
            }
        ],
        "id": "#20220321#21-Mar-2022_13:55_Plumpton",
        "classNumber": 4,
        "weather": "Sunny spells",
        "postNumber": 1,
        "shouldBet": true,
        "predictedWinner": "Lady Wilberry",
        "location": "Plumpton",
        "winnerPrizeMoney": "£4,357",
        "skillWinnerOdds": 2.75,
        "distanceCategory": "2.5miler",
        "runners": 5,
        "raceText": "Sky Sports Everyone Loves A Local Mares' Novices' Hurdle",
        "isHandicap": false,
        "type": "jumps",
        "tagVersion": 42
    },
    {
        "raceType": "nh_flat",
        "distance": "1m 7f 182y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:26:49.213Z",
        "time": "14:10",
        "country": "GB",
        "class": "jumps_class_5",
        "skillWinner": "Fancy Stuff",
        "going": "Good-good to soft in places",
        "trackType": [
            "galloping",
            "level"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 3183.9367999999995,
        "experienceCategory": "standard",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 3,
        "_id": "21-Mar-2022_14:10_Southwell",
        "horses": [
            {
                "weightNumber": 161,
                "country": "IRE",
                "raceId": "21-Mar-2022_14:10_Southwell",
                "rating": {
                    "pi": 0.03320239073879132,
                    "tau": 1.265484174525842
                },
                "weight": "11-7",
                "accuracy": 3.582861707299283,
                "jockey": "Harry Skelton",
                "url": "/form/horse/Fancy-Stuff/IRE/3295386",
                "score": 0.0674672050907543,
                "skillObj": {
                    "mu": 32.682428098846614,
                    "sigma": 3.582861707299283,
                    "maxSkill": 39.84815151344518,
                    "minSkill": 25.516704684248047,
                    "muHistory": [
                        {
                            "date": 20211206,
                            "skill": 38.1142485937719
                        },
                        {
                            "date": 20220321,
                            "skill": 32.682428098846614
                        }
                    ]
                },
                "trainer": "D Skelton",
                "odds": "3/1",
                "skill": 38.1142485937719,
                "name": "Fancy Stuff",
                "_id": "Fancy Stuff_21-Mar-2022_14:10_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 3
            },
            {
                "weightNumber": 144,
                "country": "IRE",
                "raceId": "21-Mar-2022_14:10_Southwell",
                "rating": {
                    "pi": 0.1313440194567144,
                    "tau": 4.999158029933907
                },
                "weight": "10-4",
                "accuracy": 2.391158771021739,
                "jockey": "Jack Quinlan",
                "url": "/form/horse/Pure-Theatre/IRE/3397939",
                "score": -1,
                "skillObj": {
                    "mu": 35.47988126615158,
                    "sigma": 2.391158771021739,
                    "maxSkill": 40.26219880819506,
                    "minSkill": 30.6975637241081,
                    "muHistory": [
                        {
                            "date": 20040726,
                            "skill": 39.125265056749726
                        },
                        {
                            "date": 20041008,
                            "skill": 43.22426606046887
                        },
                        {
                            "date": 20060408,
                            "skill": 38.06155811747047
                        },
                        {
                            "date": 20220321,
                            "skill": 35.47988126615158
                        }
                    ]
                },
                "trainer": "D E Cantillon",
                "odds": "16/1",
                "skill": 38.06155811747047,
                "name": "Pure Theatre",
                "_id": "Pure Theatre_21-Mar-2022_14:10_Southwell",
                "position": 100,
                "age": "4",
                "oddsNumber": 16
            },
            {
                "weightNumber": 144,
                "raceId": "21-Mar-2022_14:10_Southwell",
                "rating": {
                    "pi": 0.09030902308046929,
                    "tau": 2.81622640370043
                },
                "weight": "10-4",
                "equipment": "t",
                "accuracy": 2.716764814726344,
                "jockey": "C J Todd",
                "url": "/form/horse/Kimberley-Eve/GB/3364741",
                "score": 0.04532822684464287,
                "skillObj": {
                    "mu": 30.501510907683397,
                    "sigma": 2.716764814726344,
                    "maxSkill": 35.93504053713608,
                    "minSkill": 25.067981278230707,
                    "muHistory": [
                        {
                            "date": 20211202,
                            "skill": 32.389504442385594
                        },
                        {
                            "date": 20220101,
                            "skill": 31.18433028769505
                        },
                        {
                            "date": 20220321,
                            "skill": 30.501510907683397
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "Ian Williams",
                "odds": "8/1",
                "skill": 31.18433028769505,
                "name": "Kimberley Eve",
                "_id": "Kimberley Eve_21-Mar-2022_14:10_Southwell",
                "position": 100,
                "age": "4",
                "oddsNumber": 8
            },
            {
                "weightNumber": 154,
                "country": "FR",
                "raceId": "21-Mar-2022_14:10_Southwell",
                "rating": {
                    "pi": 0.05165026277977469,
                    "tau": 1.6055603455935987
                },
                "weight": "11-0",
                "accuracy": 3.2111222374425683,
                "jockey": "Mr B Brackenbury",
                "url": "/form/horse/Criquette/FR/3353106",
                "score": 0.05065517037447538,
                "skillObj": {
                    "mu": 30.236923059282148,
                    "sigma": 3.2111222374425683,
                    "maxSkill": 36.65916753416728,
                    "minSkill": 23.81467858439701,
                    "muHistory": [
                        {
                            "date": 20220308,
                            "skill": 31.085230920108835
                        },
                        {
                            "date": 20220321,
                            "skill": 30.236923059282148
                        }
                    ]
                },
                "jockeyClaiming": 7,
                "trainer": "A M Hales",
                "odds": "4/1",
                "skill": 31.085230920108835,
                "name": "Criquette",
                "_id": "Criquette_21-Mar-2022_14:10_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 4
            },
            {
                "weightNumber": 154,
                "country": "FR",
                "raceId": "21-Mar-2022_14:10_Southwell",
                "rating": {
                    "pi": 0.055160683624839967,
                    "tau": 1.5794507260933721
                },
                "weight": "11-0",
                "accuracy": 3.1590001630947504,
                "jockey": "P J Brennan",
                "url": "/form/horse/Horizon-Dove/FR/3378868",
                "score": 0.054518024097559396,
                "skillObj": {
                    "mu": 29.074023169949466,
                    "sigma": 3.1590001630947504,
                    "maxSkill": 35.39202349613897,
                    "minSkill": 22.756022843759965,
                    "muHistory": [
                        {
                            "date": 20220208,
                            "skill": 28.633632186931667
                        },
                        {
                            "date": 20220321,
                            "skill": 29.074023169949466
                        }
                    ]
                },
                "trainer": "F O'Brien",
                "odds": "6/1",
                "skill": 28.633632186931667,
                "name": "Horizon Dove",
                "_id": "Horizon Dove_21-Mar-2022_14:10_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 6
            },
            {
                "weightNumber": 154,
                "country": "IRE",
                "raceId": "21-Mar-2022_14:10_Southwell",
                "rating": {
                    "pi": 0.04702127442504246,
                    "tau": 0.9449281187601096
                },
                "weight": "11-0",
                "accuracy": 3.2867396189943237,
                "jockey": "Charlie Price",
                "url": "/form/horse/Ginderella/IRE/3387071",
                "score": -1,
                "skillObj": {
                    "mu": 25.20954690835322,
                    "sigma": 3.2867396189943237,
                    "maxSkill": 31.783026146341868,
                    "minSkill": 18.636067670364575,
                    "muHistory": [
                        {
                            "date": 20220213,
                            "skill": 20.09575729952701
                        },
                        {
                            "date": 20220321,
                            "skill": 25.20954690835322
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "Mitchell Hunt",
                "odds": "33/1",
                "skill": 20.09575729952701,
                "name": "Ginderella",
                "_id": "Ginderella_21-Mar-2022_14:10_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 33
            },
            {
                "weightNumber": 154,
                "raceId": "21-Mar-2022_14:10_Southwell",
                "rating": {
                    "pi": 0.014399999999999998,
                    "tau": 0.35999999999999993
                },
                "weight": "11-0",
                "accuracy": 4.085753889430578,
                "jockey": "Tom Cannon",
                "url": "/form/horse/Nothingtochance/GB/3399628",
                "score": 0.05782584167942246,
                "skillObj": {
                    "mu": 28.615351242323815,
                    "sigma": 4.085753889430578,
                    "maxSkill": 36.786859021184966,
                    "minSkill": 20.44384346346266,
                    "muHistory": [
                        {
                            "date": 20220321,
                            "skill": 28.615351242323815
                        }
                    ]
                },
                "trainer": "A King",
                "odds": "7/1",
                "skill": 0,
                "name": "Nothingtochance",
                "_id": "Nothingtochance_21-Mar-2022_14:10_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 7
            },
            {
                "weightNumber": 144,
                "raceId": "21-Mar-2022_14:10_Southwell",
                "rating": {
                    "pi": 0.014399999999999998,
                    "tau": 0.35999999999999993
                },
                "weight": "10-4",
                "accuracy": 4.064159503707057,
                "jockey": "Jamie Hamilton",
                "url": "/form/horse/Crafty-Lass/GB/3399623",
                "score": 0.04669699928182753,
                "skillObj": {
                    "mu": 28.559560744805307,
                    "sigma": 4.064159503707057,
                    "maxSkill": 36.687879752219416,
                    "minSkill": 20.431241737391193,
                    "muHistory": [
                        {
                            "date": 20220321,
                            "skill": 28.559560744805307
                        }
                    ]
                },
                "trainer": "T D Easterby",
                "odds": "12/1",
                "skill": 0,
                "name": "Crafty Lass",
                "_id": "Crafty Lass_21-Mar-2022_14:10_Southwell",
                "position": 100,
                "age": "4",
                "oddsNumber": 12
            },
            {
                "weightNumber": 154,
                "raceId": "21-Mar-2022_14:10_Southwell",
                "rating": {
                    "pi": 0.014399999999999998,
                    "tau": 0.35999999999999993
                },
                "weight": "11-0",
                "accuracy": 4.06182835192023,
                "jockey": "Harry Bannister",
                "url": "/form/horse/Minis-Dream/GB/3386186",
                "score": 0.0446419039290499,
                "skillObj": {
                    "mu": 28.522103267986612,
                    "sigma": 4.06182835192023,
                    "maxSkill": 36.645759971827076,
                    "minSkill": 20.398446564146152,
                    "muHistory": [
                        {
                            "date": 20220321,
                            "skill": 28.522103267986612
                        }
                    ]
                },
                "trainer": "Richard Bandey",
                "skill": 0,
                "name": "Mini's Dream",
                "_id": "Mini's Dream_21-Mar-2022_14:10_Southwell",
                "position": 100,
                "age": "5"
            },
            {
                "weightNumber": 154,
                "raceId": "21-Mar-2022_14:10_Southwell",
                "rating": {
                    "pi": 0.014399999999999998,
                    "tau": 0.35999999999999993
                },
                "weight": "11-0",
                "accuracy": 4.06815053762859,
                "jockey": "Joe Williamson",
                "url": "/form/horse/Green-Oaks-Top-Cat/GB/3399625",
                "score": -1,
                "skillObj": {
                    "mu": 28.525840886554704,
                    "sigma": 4.06815053762859,
                    "maxSkill": 36.662141961811884,
                    "minSkill": 20.389539811297524,
                    "muHistory": [
                        {
                            "date": 20220321,
                            "skill": 28.525840886554704
                        }
                    ]
                },
                "jockeyClaiming": 5,
                "trainer": "P A Kirby",
                "odds": "25/1",
                "skill": 0,
                "name": "Green Oaks Top Cat",
                "_id": "Green Oaks Top Cat_21-Mar-2022_14:10_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 25
            },
            {
                "weightNumber": 154,
                "raceId": "21-Mar-2022_14:10_Southwell",
                "rating": {
                    "pi": 0.014399999999999998,
                    "tau": 0.35999999999999993
                },
                "weight": "11-0",
                "accuracy": 4.073775137007419,
                "jockey": "R P McLernon",
                "url": "/form/horse/Illusive-Appeal/GB/3399626",
                "score": -1,
                "skillObj": {
                    "mu": 28.55281873956871,
                    "sigma": 4.073775137007419,
                    "maxSkill": 36.70036901358355,
                    "minSkill": 20.405268465553874,
                    "muHistory": [
                        {
                            "date": 20220321,
                            "skill": 28.55281873956871
                        }
                    ]
                },
                "trainer": "M Scudamore",
                "odds": "16/1",
                "skill": 0,
                "name": "Illusive Appeal",
                "_id": "Illusive Appeal_21-Mar-2022_14:10_Southwell",
                "position": 100,
                "age": "6",
                "oddsNumber": 16
            },
            {
                "weightNumber": 154,
                "country": "IRE",
                "raceId": "21-Mar-2022_14:10_Southwell",
                "rating": {
                    "pi": 0.014399999999999998,
                    "tau": 0.35999999999999993
                },
                "weight": "11-0",
                "accuracy": 4.080519284692524,
                "jockey": "Paul O'Brien",
                "url": "/form/horse/Indelible-Spin/IRE/3399627",
                "score": -1,
                "skillObj": {
                    "mu": 28.587263071788563,
                    "sigma": 4.080519284692524,
                    "maxSkill": 36.74830164117361,
                    "minSkill": 20.426224502403514,
                    "muHistory": [
                        {
                            "date": 20220321,
                            "skill": 28.587263071788563
                        }
                    ]
                },
                "trainer": "C E Longsdon",
                "odds": "14/1",
                "skill": 0,
                "name": "Indelible Spin",
                "_id": "Indelible Spin_21-Mar-2022_14:10_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 14
            },
            {
                "weightNumber": 154,
                "raceId": "21-Mar-2022_14:10_Southwell",
                "rating": {
                    "pi": 0.014399999999999998,
                    "tau": 0.35999999999999993
                },
                "weight": "11-0",
                "accuracy": 4.088422759235483,
                "jockey": "Alex Edwards",
                "url": "/form/horse/Magical-Maggie/GB/3276597",
                "score": -1,
                "skillObj": {
                    "mu": 28.62921389286304,
                    "sigma": 4.088422759235483,
                    "maxSkill": 36.806059411334004,
                    "minSkill": 20.452368374392073,
                    "muHistory": [
                        {
                            "date": 20220321,
                            "skill": 28.62921389286304
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "A Ralph",
                "odds": "20/1",
                "skill": 0,
                "name": "Magical Maggie",
                "_id": "Magical Maggie_21-Mar-2022_14:10_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 20
            }
        ],
        "id": "#20220321#21-Mar-2022_14:10_Southwell",
        "classNumber": 5,
        "weather": "Sunny spells",
        "postNumber": 3,
        "predictedWinner": "Fancy Stuff",
        "location": "Southwell",
        "winnerPrizeMoney": "£2,614",
        "skillWinnerOdds": 3,
        "distanceCategory": "2miler",
        "runners": 13,
        "raceText": "Sky Sports Racing Sky 415 Mares' Open NH Flat Race",
        "isHandicap": false,
        "type": "jumps",
        "tagVersion": 42
    },
    {
        "raceType": "hurdle",
        "distance": "2m 3f 166y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:25:15.192Z",
        "time": "14:20",
        "country": "GB",
        "class": "jumps_class_3",
        "skillWinner": "Reserve Tank",
        "going": "Good to soft-soft in places",
        "trackType": [
            "tight",
            "level"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 3973.9743999999996,
        "experienceCategory": "standard",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 2.25,
        "_id": "21-Mar-2022_14:20_Wincanton",
        "horses": [
            {
                "weightNumber": 175,
                "country": "IRE",
                "raceId": "21-Mar-2022_14:20_Wincanton",
                "rating": {
                    "pi": 0.5808085578961174,
                    "tau": 20.586706476181106
                },
                "weight": "12-7",
                "accuracy": 1.2654356193531804,
                "jockey": "Brendan Powell",
                "url": "/form/horse/Reserve-Tank/IRE/3046377",
                "score": -1,
                "skillObj": {
                    "mu": 35.15509697703601,
                    "sigma": 1.2654356193531804,
                    "maxSkill": 37.68596821574237,
                    "minSkill": 32.62422573832965,
                    "muHistory": [
                        {
                            "date": 20181013,
                            "skill": 28.751677931684306
                        },
                        {
                            "date": 20181108,
                            "skill": 28.19779238097997
                        },
                        {
                            "date": 20190215,
                            "skill": 32.5127398549829
                        },
                        {
                            "date": 20190316,
                            "skill": 34.38305905089132
                        },
                        {
                            "date": 20190406,
                            "skill": 37.60953684494979
                        },
                        {
                            "date": 20190503,
                            "skill": 40.390738154770936
                        },
                        {
                            "date": 20210228,
                            "skill": 39.49644128772613
                        },
                        {
                            "date": 20210318,
                            "skill": 38.8714175676505
                        },
                        {
                            "date": 20210410,
                            "skill": 37.43751498008707
                        },
                        {
                            "date": 20210501,
                            "skill": 36.866206056315335
                        },
                        {
                            "date": 20210512,
                            "skill": 36.30919078861663
                        },
                        {
                            "date": 20210522,
                            "skill": 36.50527009707197
                        },
                        {
                            "date": 20220122,
                            "skill": 35.92536080399206
                        },
                        {
                            "date": 20220219,
                            "skill": 35.44490899161857
                        },
                        {
                            "date": 20220321,
                            "skill": 35.15509697703601
                        }
                    ]
                },
                "trainer": "C L Tizzard",
                "odds": "10/1",
                "skill": 35.44490899161857,
                "name": "Reserve Tank",
                "_id": "Reserve Tank_21-Mar-2022_14:20_Wincanton",
                "position": 100,
                "age": "8",
                "oddsNumber": 10
            },
            {
                "weightNumber": 166,
                "country": "IRE",
                "raceId": "21-Mar-2022_14:20_Wincanton",
                "rating": {
                    "pi": 0.08992599066646273,
                    "tau": 3.0535938229853508
                },
                "weight": "11-12",
                "accuracy": 2.705286039012529,
                "jockey": "Rex Dingle",
                "url": "/form/horse/Ballyblack/IRE/3232133",
                "score": 0.05512481145539413,
                "skillObj": {
                    "mu": 33.26414068299039,
                    "sigma": 2.705286039012529,
                    "maxSkill": 38.67471276101544,
                    "minSkill": 27.85356860496533,
                    "muHistory": [
                        {
                            "date": 20211230,
                            "skill": 35.72029560534075
                        },
                        {
                            "date": 20220219,
                            "skill": 33.956743766228726
                        },
                        {
                            "date": 20220321,
                            "skill": 33.26414068299039
                        }
                    ]
                },
                "trainer": "J Scott",
                "odds": "5/2",
                "skill": 33.956743766228726,
                "name": "Ballyblack",
                "_id": "Ballyblack_21-Mar-2022_14:20_Wincanton",
                "position": 100,
                "age": "6",
                "oddsNumber": 2.5
            },
            {
                "weightNumber": 158,
                "country": "IRE",
                "raceId": "21-Mar-2022_14:20_Wincanton",
                "rating": {
                    "pi": 0.35451424822197003,
                    "tau": 11.945959537577142
                },
                "weight": "11-4",
                "equipment": "t",
                "accuracy": 1.5813093203402977,
                "jockey": "H Cobden",
                "url": "/form/horse/Birds-Of-Prey/IRE/2926726",
                "score": -1,
                "skillObj": {
                    "mu": 33.48997032106255,
                    "sigma": 1.5813093203402977,
                    "maxSkill": 36.65258896174315,
                    "minSkill": 30.327351680381955,
                    "muHistory": [
                        {
                            "date": 20181213,
                            "skill": 31.653220724083976
                        },
                        {
                            "date": 20181230,
                            "skill": 33.20565992029769
                        },
                        {
                            "date": 20190127,
                            "skill": 32.41659366821647
                        },
                        {
                            "date": 20190319,
                            "skill": 33.92283006009361
                        },
                        {
                            "date": 20190404,
                            "skill": 35.12312648785348
                        },
                        {
                            "date": 20190427,
                            "skill": 35.39093281725227
                        },
                        {
                            "date": 20191212,
                            "skill": 35.77101068297892
                        },
                        {
                            "date": 20211216,
                            "skill": 34.56471174899268
                        },
                        {
                            "date": 20220110,
                            "skill": 33.696697939478824
                        },
                        {
                            "date": 20220321,
                            "skill": 33.48997032106255
                        }
                    ]
                },
                "trainer": "P F Nicholls",
                "odds": "15/2",
                "skill": 33.696697939478824,
                "name": "Birds Of Prey",
                "_id": "Birds Of Prey_21-Mar-2022_14:20_Wincanton",
                "position": 100,
                "age": "8",
                "oddsNumber": 7.5
            },
            {
                "weightNumber": 166,
                "country": "FR",
                "raceId": "21-Mar-2022_14:20_Wincanton",
                "rating": {
                    "pi": 0.4817560404076809,
                    "tau": 15.725542262172745
                },
                "weight": "11-12",
                "accuracy": 1.3786320746936,
                "jockey": "T J O'Brien",
                "url": "/form/horse/Guernesey/FR/3135165",
                "score": 0.0562467338316715,
                "skillObj": {
                    "mu": 32.58780013434817,
                    "sigma": 1.3786320746936,
                    "maxSkill": 35.34506428373537,
                    "minSkill": 29.83053598496097,
                    "muHistory": [
                        {
                            "date": 20200122,
                            "skill": 26.392750942939777
                        },
                        {
                            "date": 20201004,
                            "skill": 24.647489423468606
                        },
                        {
                            "date": 20201215,
                            "skill": 28.074850988957305
                        },
                        {
                            "date": 20210215,
                            "skill": 30.58396425828804
                        },
                        {
                            "date": 20210305,
                            "skill": 29.702077089670457
                        },
                        {
                            "date": 20210908,
                            "skill": 28.200749725164037
                        },
                        {
                            "date": 20211007,
                            "skill": 29.84641633683868
                        },
                        {
                            "date": 20211117,
                            "skill": 30.468718793620866
                        },
                        {
                            "date": 20211125,
                            "skill": 30.654842868291496
                        },
                        {
                            "date": 20211209,
                            "skill": 31.801839431463385
                        },
                        {
                            "date": 20211216,
                            "skill": 32.6421278472506
                        },
                        {
                            "date": 20220321,
                            "skill": 32.58780013434817
                        }
                    ]
                },
                "trainer": "P J Hobbs",
                "odds": "11/4",
                "skill": 32.6421278472506,
                "name": "Guernesey",
                "_id": "Guernesey_21-Mar-2022_14:20_Wincanton",
                "position": 100,
                "age": "6",
                "oddsNumber": 2.75
            },
            {
                "weightNumber": 162,
                "country": "IRE",
                "raceId": "21-Mar-2022_14:20_Wincanton",
                "rating": {
                    "pi": 0.8629720769764927,
                    "tau": 27.206531248008996
                },
                "weight": "11-8",
                "equipment": "b",
                "accuracy": 1.052101291967282,
                "jockey": "Alan Johns",
                "url": "/form/horse/River-Bray/IRE/2959944",
                "score": -1,
                "skillObj": {
                    "mu": 31.571281121393394,
                    "sigma": 1.052101291967282,
                    "maxSkill": 33.675483705327956,
                    "minSkill": 29.46707853745883,
                    "muHistory": [
                        {
                            "date": 20171103,
                            "skill": 24.589132504459872
                        },
                        {
                            "date": 20171205,
                            "skill": 26.10910571870161
                        },
                        {
                            "date": 20171230,
                            "skill": 28.89557359483887
                        },
                        {
                            "date": 20181007,
                            "skill": 30.048533271319045
                        },
                        {
                            "date": 20181114,
                            "skill": 30.73428706162034
                        },
                        {
                            "date": 20181127,
                            "skill": 29.60703429815982
                        },
                        {
                            "date": 20190216,
                            "skill": 30.72605415046362
                        },
                        {
                            "date": 20190304,
                            "skill": 29.862971586327706
                        },
                        {
                            "date": 20190420,
                            "skill": 30.630756601595433
                        },
                        {
                            "date": 20191205,
                            "skill": 31.20007615741719
                        },
                        {
                            "date": 20200107,
                            "skill": 32.13682874699988
                        },
                        {
                            "date": 20200130,
                            "skill": 31.615546500423957
                        },
                        {
                            "date": 20200309,
                            "skill": 32.41690437218155
                        },
                        {
                            "date": 20201010,
                            "skill": 32.32081439228345
                        },
                        {
                            "date": 20201115,
                            "skill": 31.573909879255634
                        },
                        {
                            "date": 20201203,
                            "skill": 32.03362256301069
                        },
                        {
                            "date": 20201227,
                            "skill": 31.980761436664565
                        },
                        {
                            "date": 20210121,
                            "skill": 32.07131230462518
                        },
                        {
                            "date": 20210223,
                            "skill": 31.92133465675411
                        },
                        {
                            "date": 20210331,
                            "skill": 31.703194097831467
                        },
                        {
                            "date": 20211110,
                            "skill": 31.24831649922855
                        },
                        {
                            "date": 20220122,
                            "skill": 31.52654874226029
                        },
                        {
                            "date": 20220321,
                            "skill": 31.571281121393394
                        }
                    ]
                },
                "trainer": "V R A Dartnall",
                "odds": "16/1",
                "skill": 31.52654874226029,
                "name": "River Bray",
                "_id": "River Bray_21-Mar-2022_14:20_Wincanton",
                "position": 100,
                "age": "9",
                "oddsNumber": 16
            },
            {
                "weightNumber": 154,
                "country": "IRE",
                "raceId": "21-Mar-2022_14:20_Wincanton",
                "rating": {
                    "pi": 0.40674381617633665,
                    "tau": 10.704624093115287
                },
                "weight": "11-0",
                "accuracy": 1.4886179494860359,
                "jockey": "Nick Scholfield",
                "url": "/form/horse/Electric-Annie/IRE/3164991",
                "score": 0.05705896262980179,
                "skillObj": {
                    "mu": 27.034606464541564,
                    "sigma": 1.4886179494860359,
                    "maxSkill": 30.011842363513637,
                    "minSkill": 24.057370565569492,
                    "muHistory": [
                        {
                            "date": 20201226,
                            "skill": 22.588076009179527
                        },
                        {
                            "date": 20210119,
                            "skill": 23.03176884386344
                        },
                        {
                            "date": 20210204,
                            "skill": 24.37957106875214
                        },
                        {
                            "date": 20210225,
                            "skill": 24.19720597259587
                        },
                        {
                            "date": 20210317,
                            "skill": 21.902364056920888
                        },
                        {
                            "date": 20211018,
                            "skill": 20.37744928710028
                        },
                        {
                            "date": 20211111,
                            "skill": 22.679516568606967
                        },
                        {
                            "date": 20211214,
                            "skill": 24.582257401947835
                        },
                        {
                            "date": 20220126,
                            "skill": 26.317853320416518
                        },
                        {
                            "date": 20220321,
                            "skill": 27.034606464541564
                        }
                    ]
                },
                "trainer": "Jack Barber",
                "odds": "9/4",
                "skill": 26.317853320416518,
                "name": "Electric Annie",
                "_id": "Electric Annie_21-Mar-2022_14:20_Wincanton",
                "position": 100,
                "age": "7",
                "oddsNumber": 2.25
            }
        ],
        "id": "#20220321#21-Mar-2022_14:20_Wincanton",
        "classNumber": 3,
        "weather": "Sunny spells",
        "postNumber": 2,
        "predictedWinner": "Electric Annie",
        "location": "Wincanton",
        "winnerPrizeMoney": "£7,243",
        "skillWinnerOdds": 10,
        "distanceCategory": "2.5miler",
        "runners": 6,
        "raceText": "Racing TV Extra 4 Screens Live Handicap Hurdle",
        "isHandicap": true,
        "type": "jumps",
        "tagVersion": 42
    },
    {
        "raceType": "hurdle",
        "distance": "2m 4f 88y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:26:52.223Z",
        "time": "14:45",
        "country": "GB",
        "class": "jumps_class_5",
        "skillWinner": "Doyen La Lutte",
        "going": "Good-good to soft in places",
        "trackType": [
            "galloping",
            "level"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 4103.8192,
        "experienceCategory": "novice",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 6,
        "_id": "21-Mar-2022_14:45_Southwell",
        "horses": [
            {
                "weightNumber": 165,
                "country": "IRE",
                "raceId": "21-Mar-2022_14:45_Southwell",
                "rating": {
                    "pi": 0.18615262006381228,
                    "tau": 5.509427215995574
                },
                "weight": "11-11",
                "equipment": "p",
                "accuracy": 2.0630997844422123,
                "jockey": "Fergus Gillard",
                "url": "/form/horse/Doyen-La-Lutte/IRE/3243545",
                "score": 0.047561055264326364,
                "skillObj": {
                    "mu": 28.704155356181584,
                    "sigma": 2.0630997844422123,
                    "maxSkill": 32.83035492506601,
                    "minSkill": 24.57795578729716,
                    "muHistory": [
                        {
                            "date": 20211110,
                            "skill": 31.83537585821049
                        },
                        {
                            "date": 20211125,
                            "skill": 32.13191661875798
                        },
                        {
                            "date": 20211226,
                            "skill": 28.611847023275974
                        },
                        {
                            "date": 20220310,
                            "skill": 29.59629154887515
                        },
                        {
                            "date": 20220321,
                            "skill": 28.704155356181584
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "D Pipe",
                "odds": "10/3",
                "skill": 29.59629154887515,
                "name": "Doyen La Lutte",
                "_id": "Doyen La Lutte_21-Mar-2022_14:45_Southwell",
                "position": 100,
                "age": "6",
                "oddsNumber": 3.3333333333333335
            },
            {
                "weightNumber": 149,
                "raceId": "21-Mar-2022_14:45_Southwell",
                "rating": {
                    "pi": 0.24010006481707807,
                    "tau": 7.003539500714566
                },
                "weight": "10-9",
                "equipment": "p",
                "accuracy": 1.8636885798188187,
                "jockey": "Tabitha Worsley",
                "url": "/form/horse/The-Yellow-Mini/GB/3204953",
                "score": -1,
                "skillObj": {
                    "mu": 28.502782789639628,
                    "sigma": 1.8636885798188187,
                    "maxSkill": 32.230159949277265,
                    "minSkill": 24.77540563000199,
                    "muHistory": [
                        {
                            "date": 20210905,
                            "skill": 36.40477542507784
                        },
                        {
                            "date": 20210919,
                            "skill": 37.71529524973284
                        },
                        {
                            "date": 20211001,
                            "skill": 37.02750251996879
                        },
                        {
                            "date": 20211027,
                            "skill": 33.643499435476215
                        },
                        {
                            "date": 20211114,
                            "skill": 32.83623950381593
                        },
                        {
                            "date": 20211123,
                            "skill": 31.18358989089987
                        },
                        {
                            "date": 20220209,
                            "skill": 29.169252853181284
                        },
                        {
                            "date": 20220321,
                            "skill": 28.502782789639628
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "M Wigham",
                "odds": "14/1",
                "skill": 29.169252853181284,
                "name": "The Yellow Mini",
                "_id": "The Yellow Mini_21-Mar-2022_14:45_Southwell",
                "position": 100,
                "age": "4",
                "oddsNumber": 14
            },
            {
                "weightNumber": 166,
                "country": "IRE",
                "raceId": "21-Mar-2022_14:45_Southwell",
                "rating": {
                    "pi": 0.303273764466374,
                    "tau": 8.42778847840159
                },
                "weight": "11-12",
                "accuracy": 1.6881911511053338,
                "jockey": "Harry Skelton",
                "url": "/form/horse/Whispering-Gypsy/IRE/3213718",
                "score": 0.05073967616293101,
                "skillObj": {
                    "mu": 27.477649430986297,
                    "sigma": 1.6881911511053338,
                    "maxSkill": 30.854031733196965,
                    "minSkill": 24.10126712877563,
                    "muHistory": [
                        {
                            "date": 20210310,
                            "skill": 20.40119539471595
                        },
                        {
                            "date": 20210409,
                            "skill": 24.3633430584068
                        },
                        {
                            "date": 20210930,
                            "skill": 27.487656628562405
                        },
                        {
                            "date": 20211016,
                            "skill": 27.679309298291667
                        },
                        {
                            "date": 20211111,
                            "skill": 28.403116879645008
                        },
                        {
                            "date": 20211122,
                            "skill": 28.761387049540136
                        },
                        {
                            "date": 20211226,
                            "skill": 27.789375362655335
                        },
                        {
                            "date": 20220321,
                            "skill": 27.477649430986297
                        }
                    ]
                },
                "trainer": "D Skelton",
                "odds": "6/1",
                "skill": 27.789375362655335,
                "name": "Whispering Gypsy",
                "_id": "Whispering Gypsy_21-Mar-2022_14:45_Southwell",
                "position": 100,
                "age": "7",
                "oddsNumber": 6
            },
            {
                "weightNumber": 159,
                "country": "IRE",
                "raceId": "21-Mar-2022_14:45_Southwell",
                "rating": {
                    "pi": 0.08410473596511224,
                    "tau": 2.206248153553006
                },
                "weight": "11-5",
                "equipment": "t",
                "accuracy": 2.7371561130909146,
                "jockey": "C J Todd",
                "url": "/form/horse/Starlyte/IRE/3244845",
                "score": 0.0417301882085742,
                "skillObj": {
                    "mu": 26.042996438484323,
                    "sigma": 2.7371561130909146,
                    "maxSkill": 31.517308664666153,
                    "minSkill": 20.568684212302493,
                    "muHistory": [
                        {
                            "date": 20220103,
                            "skill": 28.62121877350272
                        },
                        {
                            "date": 20220305,
                            "skill": 26.232151236622236
                        },
                        {
                            "date": 20220321,
                            "skill": 26.042996438484323
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "Ian Williams",
                "odds": "13/2",
                "skill": 26.232151236622236,
                "name": "Starlyte",
                "_id": "Starlyte_21-Mar-2022_14:45_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 6.5
            },
            {
                "weightNumber": 166,
                "country": "FR",
                "raceId": "21-Mar-2022_14:45_Southwell",
                "rating": {
                    "pi": 0.1329890206741128,
                    "tau": 3.445634043813109
                },
                "weight": "11-12",
                "accuracy": 2.3432611816256994,
                "jockey": "Alfie Jordan",
                "url": "/form/horse/Jersey-Lady/FR/3227414",
                "score": 0.045075808948974644,
                "skillObj": {
                    "mu": 25.875012048058373,
                    "sigma": 2.3432611816256994,
                    "maxSkill": 30.561534411309772,
                    "minSkill": 21.188489684806974,
                    "muHistory": [
                        {
                            "date": 20211012,
                            "skill": 31.28625463287724
                        },
                        {
                            "date": 20211118,
                            "skill": 29.893642769826883
                        },
                        {
                            "date": 20211211,
                            "skill": 28.930482835405822
                        },
                        {
                            "date": 20220120,
                            "skill": 25.90916172137678
                        },
                        {
                            "date": 20220321,
                            "skill": 25.875012048058373
                        }
                    ]
                },
                "jockeyClaiming": 10,
                "trainer": "O Sherwood",
                "odds": "8/1",
                "skill": 25.90916172137678,
                "name": "Jersey Lady",
                "_id": "Jersey Lady_21-Mar-2022_14:45_Southwell",
                "position": 100,
                "age": "6",
                "oddsNumber": 8
            },
            {
                "weightNumber": 141,
                "raceId": "21-Mar-2022_14:45_Southwell",
                "rating": {
                    "pi": 0.49744204802925673,
                    "tau": 12.53643148146912
                },
                "weight": "10-1",
                "equipment": "p",
                "accuracy": 1.3551189487565223,
                "jockey": "J Kington",
                "url": "/form/horse/Zaras-Universe/GB/3151089",
                "score": 0.03751940128916079,
                "skillObj": {
                    "mu": 25.25520763020092,
                    "sigma": 1.3551189487565223,
                    "maxSkill": 27.965445527713968,
                    "minSkill": 22.544969732687875,
                    "muHistory": [
                        {
                            "date": 20210308,
                            "skill": 23.34421686487396
                        },
                        {
                            "date": 20210331,
                            "skill": 21.44894126864725
                        },
                        {
                            "date": 20210419,
                            "skill": 22.727122725034786
                        },
                        {
                            "date": 20210618,
                            "skill": 24.302338375692962
                        },
                        {
                            "date": 20210704,
                            "skill": 23.716714257592937
                        },
                        {
                            "date": 20210814,
                            "skill": 24.58175271718895
                        },
                        {
                            "date": 20210922,
                            "skill": 24.269784390996147
                        },
                        {
                            "date": 20211001,
                            "skill": 24.617809679576723
                        },
                        {
                            "date": 20211109,
                            "skill": 24.244942430602705
                        },
                        {
                            "date": 20211212,
                            "skill": 24.805848813727536
                        },
                        {
                            "date": 20211226,
                            "skill": 25.201792914642787
                        },
                        {
                            "date": 20220321,
                            "skill": 25.25520763020092
                        }
                    ]
                },
                "trainer": "A Crook",
                "skill": 25.201792914642787,
                "name": "Zara's Universe",
                "_id": "Zara's Universe_21-Mar-2022_14:45_Southwell",
                "position": 100,
                "age": "6"
            },
            {
                "weightNumber": 143,
                "raceId": "21-Mar-2022_14:45_Southwell",
                "rating": {
                    "pi": 0.5471192604498638,
                    "tau": 13.376764083372851
                },
                "weight": "10-3",
                "equipment": "b",
                "accuracy": 1.2974438047142354,
                "jockey": "Benjamin Poste",
                "url": "/form/horse/Mossing/GB/3024372",
                "score": 0.04170607381395358,
                "skillObj": {
                    "mu": 24.57229592409717,
                    "sigma": 1.2974438047142354,
                    "maxSkill": 27.16718353352564,
                    "minSkill": 21.977408314668697,
                    "muHistory": [
                        {
                            "date": 20181211,
                            "skill": 24.62161701204444
                        },
                        {
                            "date": 20190121,
                            "skill": 24.364681396457506
                        },
                        {
                            "date": 20190303,
                            "skill": 24.747557720150816
                        },
                        {
                            "date": 20190322,
                            "skill": 26.01102419452646
                        },
                        {
                            "date": 20190506,
                            "skill": 25.17769862999153
                        },
                        {
                            "date": 20210501,
                            "skill": 24.508328293952594
                        },
                        {
                            "date": 20210525,
                            "skill": 25.34659526688051
                        },
                        {
                            "date": 20210621,
                            "skill": 24.594858423043842
                        },
                        {
                            "date": 20211113,
                            "skill": 24.092092661006745
                        },
                        {
                            "date": 20211219,
                            "skill": 24.349724586368772
                        },
                        {
                            "date": 20220103,
                            "skill": 24.06929934629306
                        },
                        {
                            "date": 20220227,
                            "skill": 24.449448320232648
                        },
                        {
                            "date": 20220321,
                            "skill": 24.57229592409717
                        }
                    ]
                },
                "trainer": "H J Evans",
                "odds": "7/1",
                "skill": 24.449448320232648,
                "name": "Mossing",
                "_id": "Mossing_21-Mar-2022_14:45_Southwell",
                "position": 100,
                "age": "10",
                "oddsNumber": 7
            },
            {
                "weightNumber": 154,
                "raceId": "21-Mar-2022_14:45_Southwell",
                "rating": {
                    "pi": 0.5571009394965227,
                    "tau": 13.253148609241645
                },
                "weight": "11-0",
                "accuracy": 1.2872195621029163,
                "jockey": "Harry Bannister",
                "url": "/form/horse/Flintara/GB/3145245",
                "score": 0.04815870293494374,
                "skillObj": {
                    "mu": 23.980660631060626,
                    "sigma": 1.2872195621029163,
                    "maxSkill": 26.555099755266458,
                    "minSkill": 21.406221506854795,
                    "muHistory": [
                        {
                            "date": 20191210,
                            "skill": 14.964755136844495
                        },
                        {
                            "date": 20191228,
                            "skill": 13.337413638972263
                        },
                        {
                            "date": 20200126,
                            "skill": 15.478835353867257
                        },
                        {
                            "date": 20201013,
                            "skill": 18.5864206322497
                        },
                        {
                            "date": 20201208,
                            "skill": 19.82276276901066
                        },
                        {
                            "date": 20210128,
                            "skill": 20.351513790148573
                        },
                        {
                            "date": 20210301,
                            "skill": 20.081515435945292
                        },
                        {
                            "date": 20210505,
                            "skill": 21.518804336126887
                        },
                        {
                            "date": 20210608,
                            "skill": 22.225465004558384
                        },
                        {
                            "date": 20211207,
                            "skill": 22.282650205873825
                        },
                        {
                            "date": 20220122,
                            "skill": 22.940370807438335
                        },
                        {
                            "date": 20220212,
                            "skill": 23.789492477286277
                        },
                        {
                            "date": 20220321,
                            "skill": 23.980660631060626
                        }
                    ]
                },
                "trainer": "Richard Bandey",
                "odds": "7/2",
                "skill": 23.789492477286277,
                "name": "Flintara",
                "_id": "Flintara_21-Mar-2022_14:45_Southwell",
                "position": 100,
                "age": "7",
                "oddsNumber": 3.5
            },
            {
                "weightNumber": 166,
                "country": "IRE",
                "raceId": "21-Mar-2022_14:45_Southwell",
                "rating": {
                    "pi": 0.09059428545936717,
                    "tau": 1.7084269102773693
                },
                "weight": "11-12",
                "equipment": "t",
                "accuracy": 2.678079549741151,
                "jockey": "Charlie Hammond",
                "url": "/form/horse/Alchemystique/IRE/3244840",
                "score": -1,
                "skillObj": {
                    "mu": 21.518360312174,
                    "sigma": 2.678079549741151,
                    "maxSkill": 26.8745194116563,
                    "minSkill": 16.1622012126917,
                    "muHistory": [
                        {
                            "date": 20211130,
                            "skill": 36.153497092388214
                        },
                        {
                            "date": 20220210,
                            "skill": 23.01503250463466
                        },
                        {
                            "date": 20220307,
                            "skill": 18.857998621156113
                        },
                        {
                            "date": 20220321,
                            "skill": 21.518360312174
                        }
                    ]
                },
                "trainer": "Steph Hollinshead",
                "odds": "10/1",
                "skill": 18.857998621156113,
                "name": "Alchemystique",
                "_id": "Alchemystique_21-Mar-2022_14:45_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 10
            }
        ],
        "id": "#20220321#21-Mar-2022_14:45_Southwell",
        "classNumber": 5,
        "weather": "Sunny spells",
        "postNumber": 4,
        "predictedWinner": "Whispering Gypsy",
        "location": "Southwell",
        "winnerPrizeMoney": "£5,446",
        "skillWinnerOdds": 3.3333333333333335,
        "distanceCategory": "2.5miler",
        "runners": 9,
        "raceText": "Jigsaw Sports Branding Mares' Novices' Handicap Hurdle",
        "isHandicap": true,
        "type": "jumps",
        "tagVersion": 42
    },
    {
        "raceType": "chase",
        "distance": "1m 7f 149y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:25:29.788Z",
        "time": "14:55",
        "country": "GB",
        "class": "jumps_class_3",
        "skillWinner": "Financier",
        "going": "Good to soft-soft in places",
        "trackType": [
            "tight",
            "level"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 3153.7616,
        "experienceCategory": "standard",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 2.25,
        "_id": "21-Mar-2022_14:55_Wincanton",
        "horses": [
            {
                "weightNumber": 165,
                "raceId": "21-Mar-2022_14:55_Wincanton",
                "rating": {
                    "pi": 0.33345545870756593,
                    "tau": 10.077157431476076
                },
                "weight": "11-11",
                "equipment": "t",
                "accuracy": 1.6371699810760785,
                "jockey": "Richard Patrick",
                "url": "/form/horse/Financier/GB/3065760",
                "score": -1,
                "skillObj": {
                    "mu": 30.149800745045177,
                    "sigma": 1.6371699810760785,
                    "maxSkill": 33.42414070719733,
                    "minSkill": 26.87546078289302,
                    "muHistory": [
                        {
                            "date": 20200205,
                            "skill": 35.82255769902146
                        },
                        {
                            "date": 20200309,
                            "skill": 32.03505896886505
                        },
                        {
                            "date": 20201109,
                            "skill": 34.53825290241227
                        },
                        {
                            "date": 20201127,
                            "skill": 30.744267820921632
                        },
                        {
                            "date": 20210112,
                            "skill": 30.272492548006003
                        },
                        {
                            "date": 20210313,
                            "skill": 32.450984195409106
                        },
                        {
                            "date": 20211218,
                            "skill": 32.236730365500016
                        },
                        {
                            "date": 20220121,
                            "skill": 30.659084581926173
                        },
                        {
                            "date": 20220312,
                            "skill": 30.220400261354097
                        },
                        {
                            "date": 20220321,
                            "skill": 30.149800745045177
                        }
                    ]
                },
                "trainer": "Miss Kerry Lee",
                "odds": "11/2",
                "skill": 30.220400261354097,
                "name": "Financier",
                "_id": "Financier_21-Mar-2022_14:55_Wincanton",
                "position": 100,
                "age": "9",
                "oddsNumber": 5.5
            },
            {
                "weightNumber": 159,
                "country": "IRE",
                "raceId": "21-Mar-2022_14:55_Wincanton",
                "rating": {
                    "pi": 0.38586221634702994,
                    "tau": 11.609327640571088
                },
                "weight": "11-5",
                "equipment": "t",
                "accuracy": 1.5331871835725268,
                "jockey": "Nick Scholfield",
                "url": "/form/horse/The-Russian-Doyen/IRE/2996338",
                "score": 0.06066744535100285,
                "skillObj": {
                    "mu": 30.041282384374895,
                    "sigma": 1.5331871835725268,
                    "maxSkill": 33.10765675151995,
                    "minSkill": 26.974908017229843,
                    "muHistory": [
                        {
                            "date": 20181114,
                            "skill": 35.297239009620064
                        },
                        {
                            "date": 20181215,
                            "skill": 27.343174763133785
                        },
                        {
                            "date": 20190116,
                            "skill": 31.02644612491632
                        },
                        {
                            "date": 20190312,
                            "skill": 34.30347580227876
                        },
                        {
                            "date": 20201114,
                            "skill": 33.86238580693848
                        },
                        {
                            "date": 20201128,
                            "skill": 32.55960460431276
                        },
                        {
                            "date": 20210306,
                            "skill": 30.53823852192848
                        },
                        {
                            "date": 20210403,
                            "skill": 30.066412580478776
                        },
                        {
                            "date": 20211204,
                            "skill": 29.538443534658917
                        },
                        {
                            "date": 20211229,
                            "skill": 30.08671787167183
                        },
                        {
                            "date": 20220321,
                            "skill": 30.041282384374895
                        }
                    ]
                },
                "trainer": "J Scott",
                "odds": "6/4",
                "skill": 30.08671787167183,
                "name": "The Russian Doyen",
                "_id": "The Russian Doyen_21-Mar-2022_14:55_Wincanton",
                "position": 100,
                "age": "9",
                "oddsNumber": 1.5
            },
            {
                "weightNumber": 165,
                "country": "FR",
                "raceId": "21-Mar-2022_14:55_Wincanton",
                "rating": {
                    "pi": 0.20534188749197113,
                    "tau": 6.036779603492696
                },
                "weight": "11-11",
                "accuracy": 2.0171504297783884,
                "jockey": "D A Jacob",
                "url": "/form/horse/Torpillo/FR/3062424",
                "score": 0.07421121640688141,
                "skillObj": {
                    "mu": 29.470784889522506,
                    "sigma": 2.0171504297783884,
                    "maxSkill": 33.505085749079285,
                    "minSkill": 25.43648402996573,
                    "muHistory": [
                        {
                            "date": 20191120,
                            "skill": 35.44933860858811
                        },
                        {
                            "date": 20191207,
                            "skill": 30.714832871703788
                        },
                        {
                            "date": 20200208,
                            "skill": 28.816268908087807
                        },
                        {
                            "date": 20200310,
                            "skill": 29.45203371099397
                        },
                        {
                            "date": 20211211,
                            "skill": 27.681695650385905
                        },
                        {
                            "date": 20220217,
                            "skill": 29.398675921534686
                        },
                        {
                            "date": 20220321,
                            "skill": 29.470784889522506
                        }
                    ]
                },
                "trainer": "N A Twiston-Davies",
                "odds": "9/4",
                "skill": 29.398675921534686,
                "name": "Torpillo",
                "_id": "Torpillo_21-Mar-2022_14:55_Wincanton",
                "position": 100,
                "age": "7",
                "oddsNumber": 2.25
            },
            {
                "weightNumber": 154,
                "country": "FR",
                "raceId": "21-Mar-2022_14:55_Wincanton",
                "rating": {
                    "pi": 0.2180759709764329,
                    "tau": 6.358072383653903
                },
                "weight": "11-0",
                "equipment": "t",
                "accuracy": 1.9661169441593567,
                "jockey": "H Cobden",
                "url": "/form/horse/Glajou/FR/3129290",
                "score": 0.07098356276903513,
                "skillObj": {
                    "mu": 29.27557078146782,
                    "sigma": 1.9661169441593567,
                    "maxSkill": 33.20780466978653,
                    "minSkill": 25.343336893149107,
                    "muHistory": [
                        {
                            "date": 20201109,
                            "skill": 30.26080034441395
                        },
                        {
                            "date": 20201201,
                            "skill": 33.06248690637866
                        },
                        {
                            "date": 20201210,
                            "skill": 32.95527550044771
                        },
                        {
                            "date": 20210109,
                            "skill": 31.005394757745737
                        },
                        {
                            "date": 20210308,
                            "skill": 29.491139117249702
                        },
                        {
                            "date": 20211209,
                            "skill": 29.15530929513096
                        },
                        {
                            "date": 20220321,
                            "skill": 29.27557078146782
                        }
                    ]
                },
                "trainer": "P F Nicholls",
                "odds": "7/2",
                "skill": 29.15530929513096,
                "name": "Glajou",
                "_id": "Glajou_21-Mar-2022_14:55_Wincanton",
                "position": 100,
                "age": "6",
                "oddsNumber": 3.5
            }
        ],
        "id": "#20220321#21-Mar-2022_14:55_Wincanton",
        "classNumber": 3,
        "weather": "Sunny spells",
        "postNumber": 3,
        "predictedWinner": "Torpillo",
        "location": "Wincanton",
        "winnerPrizeMoney": "£7,951",
        "skillWinnerOdds": 5.5,
        "distanceCategory": "2miler",
        "runners": 4,
        "raceText": "Racecourse Live Streams On RacingTV Extra Handicap Chase",
        "isHandicap": true,
        "type": "jumps",
        "tagVersion": 42
    },
    {
        "raceType": "hurdle",
        "distance": "3m 217y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:25:31.529Z",
        "time": "15:05",
        "country": "GB",
        "class": "jumps_class_4",
        "skillWinner": "Morfee",
        "going": "Good-good to soft in places",
        "trackType": [
            "tight",
            "undulating"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 5026.444799999999,
        "experienceCategory": "novice",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 0.9090909090909091,
        "_id": "21-Mar-2022_15:05_Plumpton",
        "horses": [
            {
                "weightNumber": 160,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:05_Plumpton",
                "rating": {
                    "pi": 0.11057205264598391,
                    "tau": 3.335548992078528
                },
                "weight": "11-6",
                "accuracy": 2.5640278441842974,
                "jockey": "M G Nolan",
                "url": "/form/horse/Morfee/IRE/3267856",
                "score": 0.04637668904567962,
                "skillObj": {
                    "mu": 29.125448213633536,
                    "sigma": 2.5640278441842974,
                    "maxSkill": 34.25350390200213,
                    "minSkill": 23.997392525264942,
                    "muHistory": [
                        {
                            "date": 20210214,
                            "skill": 26.97150024547457
                        },
                        {
                            "date": 20210312,
                            "skill": 31.638332356688686
                        },
                        {
                            "date": 20210416,
                            "skill": 30.166293491519788
                        },
                        {
                            "date": 20220321,
                            "skill": 29.125448213633536
                        }
                    ]
                },
                "trainer": "J W Mullins",
                "odds": "7/2",
                "skill": 30.166293491519788,
                "name": "Morfee",
                "_id": "Morfee_21-Mar-2022_15:05_Plumpton",
                "position": 100,
                "age": "6",
                "oddsNumber": 3.5
            },
            {
                "weightNumber": 161,
                "country": "GER",
                "raceId": "21-Mar-2022_15:05_Plumpton",
                "rating": {
                    "pi": 0.2542867870191438,
                    "tau": 7.63767303494274
                },
                "weight": "11-7",
                "accuracy": 1.8430272798435257,
                "jockey": "Joshua Moore",
                "url": "/form/horse/Legal-Rights/GER/3219828",
                "score": 0.05797274672186118,
                "skillObj": {
                    "mu": 29.510062993910978,
                    "sigma": 1.8430272798435257,
                    "maxSkill": 33.19611755359803,
                    "minSkill": 25.824008434223927,
                    "muHistory": [
                        {
                            "date": 20210320,
                            "skill": 16.430783775184207
                        },
                        {
                            "date": 20210330,
                            "skill": 19.014795456642656
                        },
                        {
                            "date": 20211116,
                            "skill": 22.708300067170544
                        },
                        {
                            "date": 20211207,
                            "skill": 22.615770236335393
                        },
                        {
                            "date": 20211226,
                            "skill": 25.580519390599633
                        },
                        {
                            "date": 20220104,
                            "skill": 28.12882149419385
                        },
                        {
                            "date": 20220227,
                            "skill": 30.03566612514453
                        },
                        {
                            "date": 20220321,
                            "skill": 29.510062993910978
                        }
                    ]
                },
                "trainer": "G L Moore",
                "odds": "10/11",
                "skill": 30.03566612514453,
                "name": "Legal Rights",
                "_id": "Legal Rights_21-Mar-2022_15:05_Plumpton",
                "position": 100,
                "age": "5",
                "oddsNumber": 0.9090909090909091
            },
            {
                "weightNumber": 166,
                "raceId": "21-Mar-2022_15:05_Plumpton",
                "rating": {
                    "pi": 0.10699892003617267,
                    "tau": 3.1553682900606583
                },
                "weight": "11-12",
                "accuracy": 2.5948300098335393,
                "jockey": "J E Moore",
                "url": "/form/horse/Tigerten/GB/3118149",
                "score": 0.05164391095748061,
                "skillObj": {
                    "mu": 28.677321086625653,
                    "sigma": 2.5948300098335393,
                    "maxSkill": 33.866981106292734,
                    "minSkill": 23.487661066958573,
                    "muHistory": [
                        {
                            "date": 20220119,
                            "skill": 24.106671494058414
                        },
                        {
                            "date": 20220211,
                            "skill": 28.79190816390321
                        },
                        {
                            "date": 20220303,
                            "skill": 29.489720914883407
                        },
                        {
                            "date": 20220321,
                            "skill": 28.677321086625653
                        }
                    ]
                },
                "trainer": "D G Bridgwater",
                "odds": "3/1",
                "skill": 29.489720914883407,
                "name": "Tigerten",
                "_id": "Tigerten_21-Mar-2022_15:05_Plumpton",
                "position": 100,
                "age": "5",
                "oddsNumber": 3
            },
            {
                "weightNumber": 154,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:05_Plumpton",
                "rating": {
                    "pi": 0.25685155444068125,
                    "tau": 6.450128791225015
                },
                "weight": "11-0",
                "equipment": "t",
                "accuracy": 1.8345414752525053,
                "jockey": "N F Houlihan",
                "url": "/form/horse/Aikenbreakinheart/IRE/3247705",
                "score": -1,
                "skillObj": {
                    "mu": 25.470972163195835,
                    "sigma": 1.8345414752525053,
                    "maxSkill": 29.140055113700846,
                    "minSkill": 21.801889212690824,
                    "muHistory": [
                        {
                            "date": 20210709,
                            "skill": 25.289947941738617
                        },
                        {
                            "date": 20210919,
                            "skill": 28.52371631233117
                        },
                        {
                            "date": 20211003,
                            "skill": 27.024455474020638
                        },
                        {
                            "date": 20211024,
                            "skill": 27.979578793527253
                        },
                        {
                            "date": 20220119,
                            "skill": 25.688395142879976
                        },
                        {
                            "date": 20220211,
                            "skill": 25.112282482661183
                        },
                        {
                            "date": 20220321,
                            "skill": 25.470972163195835
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "R Rowe",
                "odds": "16/1",
                "skill": 25.112282482661183,
                "name": "Aikenbreakinheart",
                "_id": "Aikenbreakinheart_21-Mar-2022_15:05_Plumpton",
                "position": 100,
                "age": "7",
                "oddsNumber": 16
            },
            {
                "weightNumber": 161,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:05_Plumpton",
                "rating": {
                    "pi": 0.03357955742606958,
                    "tau": 0.5222077819013866
                },
                "weight": "11-7",
                "accuracy": 3.6288196172827836,
                "jockey": "M Goldstein",
                "url": "/form/horse/Martin-Spirit/IRE/3180857",
                "score": -1,
                "skillObj": {
                    "mu": 22.798940892441745,
                    "sigma": 3.6288196172827836,
                    "maxSkill": 30.05658012700731,
                    "minSkill": 15.54130165787618,
                    "muHistory": [
                        {
                            "date": 20220227,
                            "skill": 15.551359872776919
                        },
                        {
                            "date": 20220321,
                            "skill": 22.798940892441745
                        }
                    ]
                },
                "trainer": "P Butler",
                "odds": "20/1",
                "skill": 15.551359872776919,
                "name": "Martin Spirit",
                "_id": "Martin Spirit_21-Mar-2022_15:05_Plumpton",
                "position": 100,
                "age": "5",
                "oddsNumber": 20
            }
        ],
        "id": "#20220321#21-Mar-2022_15:05_Plumpton",
        "classNumber": 4,
        "weather": "Sunny spells",
        "postNumber": 3,
        "predictedWinner": "Legal Rights",
        "location": "Plumpton",
        "winnerPrizeMoney": "£5,283",
        "skillWinnerOdds": 3.5,
        "distanceCategory": "3miler",
        "runners": 5,
        "raceText": "Sky Sports Publicans Day Out Novices' Handicap Hurdle",
        "isHandicap": true,
        "type": "jumps",
        "tagVersion": 42
    },
    {
        "raceType": "hurdle",
        "distance": "1m 7f 182y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:26:54.752Z",
        "time": "15:20",
        "country": "GB",
        "class": "jumps_class_4",
        "skillWinner": "Fortunedefortunata",
        "going": "Good-good to soft in places",
        "trackType": [
            "galloping",
            "level"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 3183.9367999999995,
        "experienceCategory": "novice",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 2.25,
        "_id": "21-Mar-2022_15:20_Southwell",
        "horses": [
            {
                "weightNumber": 164,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:20_Southwell",
                "rating": {
                    "pi": 0.03529912759127682,
                    "tau": 1.2754283579023569
                },
                "weight": "11-10",
                "accuracy": 3.6246209000717764,
                "jockey": "Tom Cannon",
                "url": "/form/horse/Fortunedefortunata/IRE/3385722",
                "score": 0.0665585100615825,
                "skillObj": {
                    "mu": 30.938828779813008,
                    "sigma": 3.6246209000717764,
                    "maxSkill": 38.18807057995656,
                    "minSkill": 23.689586979669457,
                    "muHistory": [
                        {
                            "date": 20220209,
                            "skill": 36.132007925814655
                        },
                        {
                            "date": 20220321,
                            "skill": 30.938828779813008
                        }
                    ]
                },
                "trainer": "D G Bridgwater",
                "odds": "4/1",
                "skill": 36.132007925814655,
                "name": "Fortunedefortunata",
                "_id": "Fortunedefortunata_21-Mar-2022_15:20_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 4
            },
            {
                "weightNumber": 157,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:20_Southwell",
                "rating": {
                    "pi": 0.09852014194193535,
                    "tau": 3.0710310908560725
                },
                "weight": "11-3",
                "accuracy": 2.690607468405604,
                "jockey": "Harry Skelton",
                "url": "/form/horse/Boombawn/IRE/3299729",
                "score": 0.06308799315139905,
                "skillObj": {
                    "mu": 29.89735652472469,
                    "sigma": 2.690607468405604,
                    "maxSkill": 35.2785714615359,
                    "minSkill": 24.51614158791348,
                    "muHistory": [
                        {
                            "date": 20211104,
                            "skill": 27.80143371901584
                        },
                        {
                            "date": 20211126,
                            "skill": 31.08151334008267
                        },
                        {
                            "date": 20220304,
                            "skill": 31.171606438265595
                        },
                        {
                            "date": 20220321,
                            "skill": 29.89735652472469
                        }
                    ]
                },
                "trainer": "D Skelton",
                "odds": "10/11",
                "skill": 31.171606438265595,
                "name": "Boombawn",
                "_id": "Boombawn_21-Mar-2022_15:20_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 0.9090909090909091
            },
            {
                "weightNumber": 154,
                "raceId": "21-Mar-2022_15:20_Southwell",
                "rating": {
                    "pi": 0.05988931163818161,
                    "tau": 1.7087622952093315
                },
                "weight": "11-0",
                "accuracy": 3.1662084189500717,
                "jockey": "Aidan Coleman",
                "url": "/form/horse/Parliament-Hill/GB/3237615",
                "score": 0.06740599524155788,
                "skillObj": {
                    "mu": 28.154037170140796,
                    "sigma": 3.1662084189500717,
                    "maxSkill": 34.48645400804094,
                    "minSkill": 21.821620332240652,
                    "muHistory": [
                        {
                            "date": 20211128,
                            "skill": 37.4793111945266
                        },
                        {
                            "date": 20220114,
                            "skill": 28.532007606511435
                        },
                        {
                            "date": 20220321,
                            "skill": 28.154037170140796
                        }
                    ]
                },
                "trainer": "Olly Murphy",
                "odds": "9/4",
                "skill": 28.532007606511435,
                "name": "Parliament Hill",
                "_id": "Parliament Hill_21-Mar-2022_15:20_Southwell",
                "position": 100,
                "age": "4",
                "oddsNumber": 2.25
            },
            {
                "weightNumber": 157,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:20_Southwell",
                "rating": {
                    "pi": 0.051055993133638525,
                    "tau": 1.4294090895794043
                },
                "weight": "11-3",
                "accuracy": 3.308005618470551,
                "jockey": "David Bass",
                "url": "/form/horse/Herecomeshogan/IRE/3299730",
                "score": -1,
                "skillObj": {
                    "mu": 27.81262207598654,
                    "sigma": 3.308005618470551,
                    "maxSkill": 34.428633312927644,
                    "minSkill": 21.196610839045437,
                    "muHistory": [
                        {
                            "date": 20220301,
                            "skill": 27.99689129223167
                        },
                        {
                            "date": 20220321,
                            "skill": 27.81262207598654
                        }
                    ]
                },
                "trainer": "M Keighley",
                "odds": "20/1",
                "skill": 27.99689129223167,
                "name": "Herecomeshogan",
                "_id": "Herecomeshogan_21-Mar-2022_15:20_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 20
            },
            {
                "weightNumber": 147,
                "raceId": "21-Mar-2022_15:20_Southwell",
                "rating": {
                    "pi": 0.05646277348474256,
                    "tau": 1.0070313936120128
                },
                "weight": "10-7",
                "accuracy": 3.2136996438675474,
                "jockey": "Charlie Hammond",
                "url": "/form/horse/Codebook/GB/3199529",
                "score": -1,
                "skillObj": {
                    "mu": 22.796970584271456,
                    "sigma": 3.2136996438675474,
                    "maxSkill": 29.22436987200655,
                    "minSkill": 16.36957129653636,
                    "muHistory": [
                        {
                            "date": 20220302,
                            "skill": 17.83531575692317
                        },
                        {
                            "date": 20220321,
                            "skill": 22.796970584271456
                        }
                    ]
                },
                "trainer": "Joe Ponting",
                "odds": "100/1",
                "skill": 17.83531575692317,
                "name": "Codebook",
                "_id": "Codebook_21-Mar-2022_15:20_Southwell",
                "position": 100,
                "age": "4",
                "oddsNumber": 100
            },
            {
                "weightNumber": 157,
                "raceId": "21-Mar-2022_15:20_Southwell",
                "rating": {
                    "pi": 0.014399999999999998,
                    "tau": 0.35999999999999993
                },
                "weight": "11-3",
                "equipment": "h",
                "accuracy": 4.234352530258071,
                "jockey": "C Gethings",
                "url": "/form/horse/Maillot-Blanc/GB/3397365",
                "score": -1,
                "skillObj": {
                    "mu": 27.11062248920124,
                    "sigma": 4.234352530258071,
                    "maxSkill": 35.579327549717384,
                    "minSkill": 18.641917428685097,
                    "muHistory": [
                        {
                            "date": 20220321,
                            "skill": 27.11062248920124
                        }
                    ]
                },
                "trainer": "Mrs S Leech",
                "odds": "50/1",
                "skill": 0,
                "name": "Maillot Blanc",
                "_id": "Maillot Blanc_21-Mar-2022_15:20_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 50
            },
            {
                "weightNumber": 150,
                "raceId": "21-Mar-2022_15:20_Southwell",
                "rating": {
                    "pi": 0.014399999999999998,
                    "tau": 0.35999999999999993
                },
                "weight": "10-10",
                "accuracy": 4.246131589199903,
                "jockey": "S Bowen",
                "url": "/form/horse/Windy-Cove/GB/3163055",
                "score": -1,
                "skillObj": {
                    "mu": 27.10618265424259,
                    "sigma": 4.246131589199903,
                    "maxSkill": 35.5984458326424,
                    "minSkill": 18.613919475842785,
                    "muHistory": [
                        {
                            "date": 20220321,
                            "skill": 27.10618265424259
                        }
                    ]
                },
                "trainer": "M Keighley",
                "odds": "25/1",
                "skill": 0,
                "name": "Windy Cove",
                "_id": "Windy Cove_21-Mar-2022_15:20_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 25
            }
        ],
        "id": "#20220321#21-Mar-2022_15:20_Southwell",
        "classNumber": 4,
        "weather": "Sunny spells",
        "postNumber": 5,
        "predictedWinner": "Parliament Hill",
        "location": "Southwell",
        "winnerPrizeMoney": "£5,827",
        "skillWinnerOdds": 4,
        "distanceCategory": "2miler",
        "runners": 7,
        "raceText": "Cazoo Novices' Hurdle",
        "isHandicap": false,
        "type": "jumps",
        "tagVersion": 42
    },
    {
        "raceType": "hurdle",
        "distance": "1m 7f 50y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:25:40.186Z",
        "time": "15:30",
        "country": "GB",
        "class": "jumps_class_4",
        "skillWinner": "Norton Hill",
        "going": "Good to soft-soft in places",
        "trackType": [
            "tight",
            "level"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 3063.2359999999994,
        "experienceCategory": "maiden",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 2.25,
        "_id": "21-Mar-2022_15:30_Wincanton",
        "horses": [
            {
                "weightNumber": 160,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:30_Wincanton",
                "rating": {
                    "pi": 0.09297760922463846,
                    "tau": 3.044147356951851
                },
                "weight": "11-6",
                "accuracy": 2.66059221888659,
                "jockey": "Nick Scholfield",
                "url": "/form/horse/Norton-Hill/IRE/3278177",
                "score": 0.06015618449176977,
                "skillObj": {
                    "mu": 28.97263203111832,
                    "sigma": 2.66059221888659,
                    "maxSkill": 34.2938164688915,
                    "minSkill": 23.65144759334514,
                    "muHistory": [
                        {
                            "date": 20211214,
                            "skill": 34.49816380939545
                        },
                        {
                            "date": 20220208,
                            "skill": 32.74064995150651
                        },
                        {
                            "date": 20220321,
                            "skill": 28.97263203111832
                        }
                    ]
                },
                "trainer": "Jack Barber",
                "odds": "9/2",
                "skill": 32.74064995150651,
                "name": "Norton Hill",
                "_id": "Norton Hill_21-Mar-2022_15:30_Wincanton",
                "position": 100,
                "age": "6",
                "oddsNumber": 4.5
            },
            {
                "weightNumber": 160,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:30_Wincanton",
                "rating": {
                    "pi": 0.14947170108063856,
                    "tau": 4.445019298826825
                },
                "weight": "11-6",
                "equipment": "t",
                "accuracy": 2.2514437719856035,
                "jockey": "Brendan Powell",
                "url": "/form/horse/Name-In-Lights/IRE/3254367",
                "score": 0.06256102675606488,
                "skillObj": {
                    "mu": 27.85168766079866,
                    "sigma": 2.2514437719856035,
                    "maxSkill": 32.354575204769866,
                    "minSkill": 23.348800116827455,
                    "muHistory": [
                        {
                            "date": 20211107,
                            "skill": 33.62599743619592
                        },
                        {
                            "date": 20211204,
                            "skill": 27.770469795262542
                        },
                        {
                            "date": 20220120,
                            "skill": 28.846500191775075
                        },
                        {
                            "date": 20220302,
                            "skill": 29.738199717341672
                        },
                        {
                            "date": 20220321,
                            "skill": 27.85168766079866
                        }
                    ]
                },
                "trainer": "C L Tizzard",
                "odds": "4/1",
                "skill": 29.738199717341672,
                "name": "Name In Lights",
                "_id": "Name In Lights_21-Mar-2022_15:30_Wincanton",
                "position": 100,
                "age": "6",
                "oddsNumber": 4
            },
            {
                "weightNumber": 160,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:30_Wincanton",
                "rating": {
                    "pi": 0.02794690812036023,
                    "tau": 0.7186195902972374
                },
                "weight": "11-6",
                "accuracy": 3.6330910760015476,
                "jockey": "H Cobden",
                "url": "/form/horse/Petrossian/IRE/3238625",
                "score": 0.07141310647529425,
                "skillObj": {
                    "mu": 23.87708049004242,
                    "sigma": 3.6330910760015476,
                    "maxSkill": 31.143262642045514,
                    "minSkill": 16.610898338039327,
                    "muHistory": [
                        {
                            "date": 20211122,
                            "skill": 25.71374218580193
                        },
                        {
                            "date": 20220321,
                            "skill": 23.87708049004242
                        }
                    ]
                },
                "trainer": "P F Nicholls",
                "odds": "9/4",
                "skill": 25.71374218580193,
                "name": "Petrossian",
                "_id": "Petrossian_21-Mar-2022_15:30_Wincanton",
                "position": 100,
                "age": "6",
                "oddsNumber": 2.25
            },
            {
                "weightNumber": 160,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:30_Wincanton",
                "rating": {
                    "pi": 0.10299163790129746,
                    "tau": 2.457929004165793
                },
                "weight": "11-6",
                "equipment": "t",
                "accuracy": 2.5763747673465733,
                "jockey": "T Scudamore",
                "url": "/form/horse/Pachacuti/IRE/3365657",
                "score": 0.06389689208449452,
                "skillObj": {
                    "mu": 23.546462572996983,
                    "sigma": 2.5763747673465733,
                    "maxSkill": 28.69921210769013,
                    "minSkill": 18.393713038303837,
                    "muHistory": [
                        {
                            "date": 20220106,
                            "skill": 22.60442021614517
                        },
                        {
                            "date": 20220213,
                            "skill": 23.865325906568856
                        },
                        {
                            "date": 20220321,
                            "skill": 23.546462572996983
                        }
                    ]
                },
                "trainer": "D Pipe",
                "odds": "6/1",
                "skill": 23.865325906568856,
                "name": "Pachacuti",
                "_id": "Pachacuti_21-Mar-2022_15:30_Wincanton",
                "position": 100,
                "age": "5",
                "oddsNumber": 6
            },
            {
                "weightNumber": 160,
                "raceId": "21-Mar-2022_15:30_Wincanton",
                "rating": {
                    "pi": 0.0921292620686654,
                    "tau": 2.016954661554254
                },
                "weight": "11-6",
                "accuracy": 2.6764391110204464,
                "jockey": "Rex Dingle",
                "url": "/form/horse/Phoenix-Risen/GB/3352523",
                "score": -1,
                "skillObj": {
                    "mu": 22.02346319441451,
                    "sigma": 2.6764391110204464,
                    "maxSkill": 27.376341416455404,
                    "minSkill": 16.670584972373618,
                    "muHistory": [
                        {
                            "date": 20220208,
                            "skill": 24.45997143530542
                        },
                        {
                            "date": 20220303,
                            "skill": 21.892660553939812
                        },
                        {
                            "date": 20220321,
                            "skill": 22.02346319441451
                        }
                    ]
                },
                "trainer": "J Scott",
                "odds": "33/1",
                "skill": 21.892660553939812,
                "name": "Phoenix Risen",
                "_id": "Phoenix Risen_21-Mar-2022_15:30_Wincanton",
                "position": 100,
                "age": "5",
                "oddsNumber": 33
            },
            {
                "weightNumber": 160,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:30_Wincanton",
                "rating": {
                    "pi": 0.1090429440243593,
                    "tau": 2.212103067927541
                },
                "weight": "11-6",
                "accuracy": 2.5204332931763362,
                "jockey": "Mr Peter Summers",
                "url": "/form/horse/Bally-Dun/IRE/3164980",
                "score": -1,
                "skillObj": {
                    "mu": 21.06457882005881,
                    "sigma": 2.5204332931763362,
                    "maxSkill": 26.105445406411484,
                    "minSkill": 16.023712233706135,
                    "muHistory": [
                        {
                            "date": 20201029,
                            "skill": 20.99375664273225
                        },
                        {
                            "date": 20210419,
                            "skill": 20.286531033437388
                        },
                        {
                            "date": 20220321,
                            "skill": 21.06457882005881
                        }
                    ]
                },
                "jockeyClaiming": 7,
                "trainer": "Ryan Chapman",
                "odds": "100/1",
                "skill": 20.286531033437388,
                "name": "Bally Dun",
                "_id": "Bally Dun_21-Mar-2022_15:30_Wincanton",
                "position": 100,
                "age": "7",
                "oddsNumber": 100
            },
            {
                "weightNumber": 160,
                "country": "FR",
                "raceId": "21-Mar-2022_15:30_Wincanton",
                "rating": {
                    "pi": 0.09796824962811686,
                    "tau": 1.955881044857231
                },
                "weight": "11-6",
                "equipment": "p",
                "accuracy": 2.6139397048400546,
                "jockey": "Bryony Frost",
                "url": "/form/horse/Huflower/FR/3260756",
                "score": 0.059049169683893565,
                "skillObj": {
                    "mu": 21.001699419679095,
                    "sigma": 2.6139397048400546,
                    "maxSkill": 26.229578829359205,
                    "minSkill": 15.773820009998985,
                    "muHistory": [
                        {
                            "date": 20211102,
                            "skill": 28.155169448607932
                        },
                        {
                            "date": 20211214,
                            "skill": 19.964437991713325
                        },
                        {
                            "date": 20220321,
                            "skill": 21.001699419679095
                        }
                    ]
                },
                "trainer": "P F Nicholls",
                "odds": "9/2",
                "skill": 19.964437991713325,
                "name": "Huflower",
                "_id": "Huflower_21-Mar-2022_15:30_Wincanton",
                "position": 100,
                "age": "5",
                "oddsNumber": 4.5
            },
            {
                "weightNumber": 160,
                "raceId": "21-Mar-2022_15:30_Wincanton",
                "rating": {
                    "pi": 0.05266735166236223,
                    "tau": 0.9360430464915459
                },
                "weight": "11-6",
                "accuracy": 3.147048080122286,
                "jockey": "Thomas Doggrell",
                "url": "/form/horse/Crosspoint/GB/3396124",
                "score": -1,
                "skillObj": {
                    "mu": 20.12917427846052,
                    "sigma": 3.147048080122286,
                    "maxSkill": 26.423270438705092,
                    "minSkill": 13.83507811821595,
                    "muHistory": [
                        {
                            "date": 20220310,
                            "skill": 17.772738080553083
                        },
                        {
                            "date": 20220321,
                            "skill": 20.12917427846052
                        }
                    ]
                },
                "jockeyClaiming": 7,
                "trainer": "Dr J R J Naylor",
                "odds": "200/1",
                "skill": 17.772738080553083,
                "name": "Crosspoint",
                "_id": "Crosspoint_21-Mar-2022_15:30_Wincanton",
                "position": 100,
                "age": "9",
                "oddsNumber": 200
            },
            {
                "weightNumber": 160,
                "raceId": "21-Mar-2022_15:30_Wincanton",
                "rating": {
                    "pi": 0.031282162595842336,
                    "tau": 0.42735707717023624
                },
                "weight": "11-6",
                "accuracy": 3.560792670774025,
                "jockey": "Daniel Sansom",
                "url": "/form/horse/The-Big-Red-One/GB/3371134",
                "score": -1,
                "skillObj": {
                    "mu": 19.199581937933537,
                    "sigma": 3.560792670774025,
                    "maxSkill": 26.321167279481585,
                    "minSkill": 12.077996596385487,
                    "muHistory": [
                        {
                            "date": 20220207,
                            "skill": 13.661366149507694
                        },
                        {
                            "date": 20220321,
                            "skill": 19.199581937933537
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "J W Mullins",
                "odds": "50/1",
                "skill": 13.661366149507694,
                "name": "The Big Red One",
                "_id": "The Big Red One_21-Mar-2022_15:30_Wincanton",
                "position": 100,
                "age": "5",
                "oddsNumber": 50
            },
            {
                "weightNumber": 160,
                "raceId": "21-Mar-2022_15:30_Wincanton",
                "rating": {
                    "pi": 0.07392036635718953,
                    "tau": 0.8727524504020435
                },
                "weight": "11-6",
                "accuracy": 2.8597779258167506,
                "jockey": "James Best",
                "url": "/form/horse/Blakey-Bear/GB/3300047",
                "score": -1,
                "skillObj": {
                    "mu": 16.41593795995729,
                    "sigma": 2.8597779258167506,
                    "maxSkill": 22.13549381159079,
                    "minSkill": 10.696382108323789,
                    "muHistory": [
                        {
                            "date": 20211221,
                            "skill": 18.917737525021955
                        },
                        {
                            "date": 20220118,
                            "skill": 11.806657534472016
                        },
                        {
                            "date": 20220321,
                            "skill": 16.41593795995729
                        }
                    ]
                },
                "trainer": "N P Mulholland",
                "odds": "100/1",
                "skill": 11.806657534472016,
                "name": "Blakey Bear",
                "_id": "Blakey Bear_21-Mar-2022_15:30_Wincanton",
                "position": 100,
                "age": "6",
                "oddsNumber": 100
            },
            {
                "weightNumber": 160,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:30_Wincanton",
                "rating": {
                    "pi": 0.014399999999999998,
                    "tau": 0.35999999999999993
                },
                "weight": "11-6",
                "accuracy": 3.9695866106214117,
                "jockey": "Jonjo O'Neill Jr.",
                "url": "/form/horse/Biowavego/IRE/3390145",
                "score": 0.058326266772992304,
                "skillObj": {
                    "mu": 23.1223155313699,
                    "sigma": 3.9695866106214117,
                    "maxSkill": 31.061488752612725,
                    "minSkill": 15.183142310127076,
                    "muHistory": [
                        {
                            "date": 20220321,
                            "skill": 23.1223155313699
                        }
                    ]
                },
                "trainer": "Jonjo O'Neill",
                "odds": "13/2",
                "skill": 0,
                "name": "Biowavego",
                "_id": "Biowavego_21-Mar-2022_15:30_Wincanton",
                "position": 100,
                "age": "5",
                "oddsNumber": 6.5
            },
            {
                "weightNumber": 160,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:30_Wincanton",
                "rating": {
                    "pi": 0.014399999999999998,
                    "tau": 0.35999999999999993
                },
                "weight": "11-6",
                "accuracy": 3.971810093380807,
                "jockey": "J J Burke",
                "url": "/form/horse/Big-Bill-Newman/IRE/3370599",
                "score": -1,
                "skillObj": {
                    "mu": 22.94787717854513,
                    "sigma": 3.971810093380807,
                    "maxSkill": 30.891497365306744,
                    "minSkill": 15.004256991783517,
                    "muHistory": [
                        {
                            "date": 20220321,
                            "skill": 22.94787717854513
                        }
                    ]
                },
                "trainer": "Mrs Dunn",
                "odds": "20/1",
                "skill": 0,
                "name": "Big Bill Newman",
                "_id": "Big Bill Newman_21-Mar-2022_15:30_Wincanton",
                "position": 100,
                "age": "7",
                "oddsNumber": 20
            },
            {
                "weightNumber": 160,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:30_Wincanton",
                "rating": {
                    "pi": 0.014399999999999998,
                    "tau": 0.35999999999999993
                },
                "weight": "11-6",
                "accuracy": 3.9880681978451644,
                "jockey": "T J O'Brien",
                "url": "/form/horse/Instant-Gambler/IRE/3305598",
                "score": -1,
                "skillObj": {
                    "mu": 22.808492888649084,
                    "sigma": 3.9880681978451644,
                    "maxSkill": 30.784629284339413,
                    "minSkill": 14.832356492958755,
                    "muHistory": [
                        {
                            "date": 20220321,
                            "skill": 22.808492888649084
                        }
                    ]
                },
                "trainer": "Mrs Dunn",
                "odds": "66/1",
                "skill": 0,
                "name": "Instant Gambler",
                "_id": "Instant Gambler_21-Mar-2022_15:30_Wincanton",
                "position": 100,
                "age": "6",
                "oddsNumber": 66
            },
            {
                "weightNumber": 153,
                "raceId": "21-Mar-2022_15:30_Wincanton",
                "rating": {
                    "pi": 0.014399999999999998,
                    "tau": 0.35999999999999993
                },
                "weight": "10-13",
                "equipment": "h",
                "accuracy": 4.021456803434679,
                "jockey": "David Noonan",
                "url": "/form/horse/What-A-Pleasure/GB/3236459",
                "score": -1,
                "skillObj": {
                    "mu": 22.77001278528675,
                    "sigma": 4.021456803434679,
                    "maxSkill": 30.812926392156108,
                    "minSkill": 14.72709917841739,
                    "muHistory": [
                        {
                            "date": 20220321,
                            "skill": 22.77001278528675
                        }
                    ]
                },
                "trainer": "C J Down",
                "odds": "66/1",
                "skill": 0,
                "name": "What A Pleasure",
                "_id": "What A Pleasure_21-Mar-2022_15:30_Wincanton",
                "position": 100,
                "age": "6",
                "oddsNumber": 66
            }
        ],
        "id": "#20220321#21-Mar-2022_15:30_Wincanton",
        "classNumber": 4,
        "weather": "Sunny spells",
        "postNumber": 4,
        "shouldBet": true,
        "predictedWinner": "Petrossian",
        "location": "Wincanton",
        "winnerPrizeMoney": "£4,084",
        "skillWinnerOdds": 4.5,
        "distanceCategory": "2miler",
        "runners": 14,
        "raceText": "Use The racingtv.com Tracker Maiden Hurdle",
        "isHandicap": false,
        "type": "jumps",
        "tagVersion": 42
    },
    {
        "raceType": "chase",
        "distance": "3m 1f 152y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:25:04.869Z",
        "time": "15:40",
        "country": "GB",
        "class": "jumps_class_3",
        "skillWinner": "Captain Tommy",
        "going": "Good-good to soft in places",
        "trackType": [
            "tight",
            "undulating"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 5168.176799999999,
        "experienceCategory": "standard",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 2,
        "_id": "21-Mar-2022_15:40_Plumpton",
        "horses": [
            {
                "weightNumber": 159,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:40_Plumpton",
                "rating": {
                    "pi": 0.761633221092125,
                    "tau": 25.067253057978366
                },
                "weight": "11-5",
                "accuracy": 1.115469516825797,
                "jockey": "J E Moore",
                "url": "/form/horse/Captain-Tommy/IRE/3025742",
                "score": 0.05416753195336598,
                "skillObj": {
                    "mu": 32.6875817171593,
                    "sigma": 1.115469516825797,
                    "maxSkill": 34.91852075081089,
                    "minSkill": 30.456642683507702,
                    "muHistory": [
                        {
                            "date": 20200821,
                            "skill": 24.248463263683696
                        },
                        {
                            "date": 20200909,
                            "skill": 25.275800850529542
                        },
                        {
                            "date": 20200929,
                            "skill": 30.358456283786765
                        },
                        {
                            "date": 20201015,
                            "skill": 29.079459241712257
                        },
                        {
                            "date": 20201111,
                            "skill": 31.38969199586186
                        },
                        {
                            "date": 20201205,
                            "skill": 31.51761664931857
                        },
                        {
                            "date": 20201227,
                            "skill": 31.070215290129802
                        },
                        {
                            "date": 20201229,
                            "skill": 30.566980397119384
                        },
                        {
                            "date": 20210501,
                            "skill": 31.980922498357984
                        },
                        {
                            "date": 20210530,
                            "skill": 33.08113348562368
                        },
                        {
                            "date": 20211016,
                            "skill": 33.09394625061822
                        },
                        {
                            "date": 20211110,
                            "skill": 33.293764587234755
                        },
                        {
                            "date": 20211202,
                            "skill": 32.821496699366236
                        },
                        {
                            "date": 20211216,
                            "skill": 33.15349646256072
                        },
                        {
                            "date": 20220101,
                            "skill": 33.05173837750172
                        },
                        {
                            "date": 20220115,
                            "skill": 32.66634709872564
                        },
                        {
                            "date": 20220217,
                            "skill": 32.91249956512375
                        },
                        {
                            "date": 20220321,
                            "skill": 32.6875817171593
                        }
                    ]
                },
                "trainer": "D G Bridgwater",
                "odds": "11/4",
                "skill": 32.91249956512375,
                "name": "Captain Tommy",
                "_id": "Captain Tommy_21-Mar-2022_15:40_Plumpton",
                "position": 100,
                "age": "8",
                "oddsNumber": 2.75
            },
            {
                "weightNumber": 154,
                "raceId": "21-Mar-2022_15:40_Plumpton",
                "rating": {
                    "pi": 0.5657665131530176,
                    "tau": 17.560476031767514
                },
                "weight": "11-0",
                "equipment": "p",
                "accuracy": 1.2805580520797881,
                "jockey": "James Bowen",
                "url": "/form/horse/Friends-Dont-Ask/GB/3115495",
                "score": 0.05367807641228519,
                "skillObj": {
                    "mu": 30.91677240780651,
                    "sigma": 1.2805580520797881,
                    "maxSkill": 33.477888511966086,
                    "minSkill": 28.35565630364693,
                    "muHistory": [
                        {
                            "date": 20200730,
                            "skill": 24.90128641993769
                        },
                        {
                            "date": 20200818,
                            "skill": 25.895252089817596
                        },
                        {
                            "date": 20201007,
                            "skill": 27.636070952240555
                        },
                        {
                            "date": 20201101,
                            "skill": 27.10695943097845
                        },
                        {
                            "date": 20201130,
                            "skill": 29.400375944527262
                        },
                        {
                            "date": 20210227,
                            "skill": 28.979323721773063
                        },
                        {
                            "date": 20210329,
                            "skill": 29.76359902785483
                        },
                        {
                            "date": 20210504,
                            "skill": 30.674436497002382
                        },
                        {
                            "date": 20210530,
                            "skill": 31.131509829780097
                        },
                        {
                            "date": 20210702,
                            "skill": 31.89387815262093
                        },
                        {
                            "date": 20210725,
                            "skill": 31.65851021368763
                        },
                        {
                            "date": 20210908,
                            "skill": 32.396784345260784
                        },
                        {
                            "date": 20211014,
                            "skill": 31.52070901998417
                        },
                        {
                            "date": 20211112,
                            "skill": 31.038380009277954
                        },
                        {
                            "date": 20220321,
                            "skill": 30.91677240780651
                        }
                    ]
                },
                "trainer": "Martin Smith",
                "skill": 31.038380009277954,
                "name": "Friends Don't Ask",
                "_id": "Friends Don't Ask_21-Mar-2022_15:40_Plumpton",
                "position": 100,
                "age": "7"
            },
            {
                "weightNumber": 163,
                "country": "FR",
                "raceId": "21-Mar-2022_15:40_Plumpton",
                "rating": {
                    "pi": 0.877585285451454,
                    "tau": 27.03548490338388
                },
                "weight": "11-9",
                "accuracy": 1.0434639486281079,
                "jockey": "M G Nolan",
                "url": "/form/horse/I-See-You-Well/FR/2947925",
                "score": 0.05034041289898631,
                "skillObj": {
                    "mu": 30.73887544208549,
                    "sigma": 1.0434639486281079,
                    "maxSkill": 32.825803339341704,
                    "minSkill": 28.651947544829273,
                    "muHistory": [
                        {
                            "date": 20171013,
                            "skill": 22.030811596392716
                        },
                        {
                            "date": 20171104,
                            "skill": 25.753368515309777
                        },
                        {
                            "date": 20171123,
                            "skill": 27.018019164951074
                        },
                        {
                            "date": 20171222,
                            "skill": 27.950944290675316
                        },
                        {
                            "date": 20180507,
                            "skill": 27.498628538456586
                        },
                        {
                            "date": 20180605,
                            "skill": 29.965073212735525
                        },
                        {
                            "date": 20180619,
                            "skill": 30.509941346861925
                        },
                        {
                            "date": 20181121,
                            "skill": 30.361811991597186
                        },
                        {
                            "date": 20181217,
                            "skill": 31.1957812989403
                        },
                        {
                            "date": 20190106,
                            "skill": 30.022236835047575
                        },
                        {
                            "date": 20190222,
                            "skill": 29.591385227668887
                        },
                        {
                            "date": 20190420,
                            "skill": 29.409177157929957
                        },
                        {
                            "date": 20191205,
                            "skill": 29.75752888011071
                        },
                        {
                            "date": 20201226,
                            "skill": 29.62433284040952
                        },
                        {
                            "date": 20210125,
                            "skill": 29.648578343529866
                        },
                        {
                            "date": 20210220,
                            "skill": 29.862956581509206
                        },
                        {
                            "date": 20210325,
                            "skill": 29.83828499208027
                        },
                        {
                            "date": 20210411,
                            "skill": 30.347917046619244
                        },
                        {
                            "date": 20211121,
                            "skill": 30.212502318352676
                        },
                        {
                            "date": 20211213,
                            "skill": 30.698009166142747
                        },
                        {
                            "date": 20220102,
                            "skill": 30.649053369565056
                        },
                        {
                            "date": 20220219,
                            "skill": 30.806675261739475
                        },
                        {
                            "date": 20220321,
                            "skill": 30.73887544208549
                        }
                    ]
                },
                "trainer": "J W Mullins",
                "odds": "9/2",
                "skill": 30.806675261739475,
                "name": "I See You Well",
                "_id": "I See You Well_21-Mar-2022_15:40_Plumpton",
                "position": 100,
                "age": "9",
                "oddsNumber": 4.5
            },
            {
                "weightNumber": 154,
                "raceId": "21-Mar-2022_15:40_Plumpton",
                "rating": {
                    "pi": 0.8123797314687097,
                    "tau": 23.8655984074777
                },
                "weight": "11-0",
                "equipment": "t",
                "accuracy": 1.0825023809254735,
                "jockey": "Thomas Bellamy",
                "url": "/form/horse/Flying-Verse/GB/2974035",
                "score": -1,
                "skillObj": {
                    "mu": 29.397762917536628,
                    "sigma": 1.0825023809254735,
                    "maxSkill": 31.562767679387576,
                    "minSkill": 27.23275815568568,
                    "muHistory": [
                        {
                            "date": 20190712,
                            "skill": 20.47197699276383
                        },
                        {
                            "date": 20190729,
                            "skill": 29.7621475252826
                        },
                        {
                            "date": 20190829,
                            "skill": 25.642754882919185
                        },
                        {
                            "date": 20191007,
                            "skill": 28.777376473522473
                        },
                        {
                            "date": 20200228,
                            "skill": 28.16421487677401
                        },
                        {
                            "date": 20200317,
                            "skill": 27.869666982818742
                        },
                        {
                            "date": 20200708,
                            "skill": 29.099902241590925
                        },
                        {
                            "date": 20200724,
                            "skill": 29.97570207443274
                        },
                        {
                            "date": 20200828,
                            "skill": 30.248769723757476
                        },
                        {
                            "date": 20200909,
                            "skill": 30.2449316023864
                        },
                        {
                            "date": 20201015,
                            "skill": 29.468747687858723
                        },
                        {
                            "date": 20201020,
                            "skill": 29.01787120681443
                        },
                        {
                            "date": 20210504,
                            "skill": 29.87175126057201
                        },
                        {
                            "date": 20210522,
                            "skill": 29.76002851982373
                        },
                        {
                            "date": 20210611,
                            "skill": 29.009611954540425
                        },
                        {
                            "date": 20210705,
                            "skill": 29.098789844889545
                        },
                        {
                            "date": 20210824,
                            "skill": 29.856467303952467
                        },
                        {
                            "date": 20211003,
                            "skill": 30.155321810881567
                        },
                        {
                            "date": 20211014,
                            "skill": 30.23952748091964
                        },
                        {
                            "date": 20211105,
                            "skill": 29.76837490853274
                        },
                        {
                            "date": 20211113,
                            "skill": 29.377392717972963
                        },
                        {
                            "date": 20220321,
                            "skill": 29.397762917536628
                        }
                    ]
                },
                "trainer": "David Dennis",
                "odds": "8/1",
                "skill": 29.377392717972963,
                "name": "Flying Verse",
                "_id": "Flying Verse_21-Mar-2022_15:40_Plumpton",
                "position": 100,
                "age": "10",
                "oddsNumber": 8
            },
            {
                "weightNumber": 155,
                "country": "FR",
                "raceId": "21-Mar-2022_15:40_Plumpton",
                "rating": {
                    "pi": 0.5223585435831262,
                    "tau": 13.918609546456523
                },
                "weight": "11-1",
                "equipment": "v",
                "accuracy": 1.3289384764583558,
                "jockey": "Joshua Moore",
                "url": "/form/horse/Eragon-De-Chanay/FR/2993966",
                "score": 0.055067575757506385,
                "skillObj": {
                    "mu": 26.950049643123574,
                    "sigma": 1.3289384764583558,
                    "maxSkill": 29.607926596040286,
                    "minSkill": 24.29217269020686,
                    "muHistory": [
                        {
                            "date": 20191009,
                            "skill": 24.49387892177225
                        },
                        {
                            "date": 20191206,
                            "skill": 20.088912037726686
                        },
                        {
                            "date": 20201019,
                            "skill": 22.949633631575487
                        },
                        {
                            "date": 20201108,
                            "skill": 21.96713389624183
                        },
                        {
                            "date": 20201215,
                            "skill": 23.752730963692958
                        },
                        {
                            "date": 20210121,
                            "skill": 23.882698124397642
                        },
                        {
                            "date": 20210218,
                            "skill": 25.344846958127828
                        },
                        {
                            "date": 20210325,
                            "skill": 24.766589804214163
                        },
                        {
                            "date": 20211106,
                            "skill": 24.542764323470642
                        },
                        {
                            "date": 20211125,
                            "skill": 25.048530938638265
                        },
                        {
                            "date": 20211213,
                            "skill": 24.510616113954768
                        },
                        {
                            "date": 20220102,
                            "skill": 25.372381649503748
                        },
                        {
                            "date": 20220120,
                            "skill": 26.43505974574505
                        },
                        {
                            "date": 20220211,
                            "skill": 26.645700960458335
                        },
                        {
                            "date": 20220321,
                            "skill": 26.950049643123574
                        }
                    ]
                },
                "trainer": "G L Moore",
                "odds": "2/1",
                "skill": 26.645700960458335,
                "name": "Eragon De Chanay",
                "_id": "Eragon De Chanay_21-Mar-2022_15:40_Plumpton",
                "position": 100,
                "age": "8",
                "oddsNumber": 2
            },
            {
                "weightNumber": 160,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:40_Plumpton",
                "rating": {
                    "pi": 0.060542223384441235,
                    "tau": 1.5445081499322144
                },
                "weight": "11-6",
                "equipment": "t",
                "accuracy": 3.0520206445109093,
                "jockey": "Caoilin Quinn",
                "url": "/form/horse/Drumlee-Watar/IRE/3025747",
                "score": -1,
                "skillObj": {
                    "mu": 27.547311775065097,
                    "sigma": 3.0520206445109093,
                    "maxSkill": 33.65135306408692,
                    "minSkill": 21.44327048604328,
                    "muHistory": [
                        {
                            "date": 20220111,
                            "skill": 25.511255840814364
                        },
                        {
                            "date": 20220321,
                            "skill": 27.547311775065097
                        }
                    ]
                },
                "jockeyClaiming": 7,
                "trainer": "W Greatrex",
                "odds": "10/1",
                "skill": 25.511255840814364,
                "name": "Drumlee Watar",
                "_id": "Drumlee Watar_21-Mar-2022_15:40_Plumpton",
                "position": 100,
                "age": "9",
                "oddsNumber": 10
            }
        ],
        "id": "#20220321#21-Mar-2022_15:40_Plumpton",
        "classNumber": 3,
        "weather": "Sunny spells",
        "postNumber": 4,
        "predictedWinner": "Eragon De Chanay",
        "location": "Plumpton",
        "winnerPrizeMoney": "£8,496",
        "skillWinnerOdds": 2.75,
        "distanceCategory": "3miler",
        "runners": 6,
        "raceText": "Watch Sky Sports At Your Local Handicap Chase",
        "isHandicap": true,
        "type": "jumps",
        "tagVersion": 42
    },
    {
        "raceType": "hurdle",
        "distance": "2m 4f 88y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:26:58.713Z",
        "time": "15:55",
        "country": "GB",
        "class": "jumps_class_4",
        "skillWinner": "Ballinslea Bridge",
        "going": "Good-good to soft in places",
        "trackType": [
            "galloping",
            "level"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 4103.8192,
        "experienceCategory": "standard",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 4,
        "_id": "21-Mar-2022_15:55_Southwell",
        "horses": [
            {
                "weightNumber": 166,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:55_Southwell",
                "rating": {
                    "pi": 0.16565545134763004,
                    "tau": 5.144636724107836
                },
                "weight": "11-12",
                "accuracy": 2.152776852380348,
                "jockey": "Mr Alex Chadwick",
                "url": "/form/horse/Ballinslea-Bridge/IRE/2924823",
                "score": -1,
                "skillObj": {
                    "mu": 30.01844464290595,
                    "sigma": 2.152776852380348,
                    "maxSkill": 34.323998347666645,
                    "minSkill": 25.712890938145257,
                    "muHistory": [
                        {
                            "date": 20171204,
                            "skill": 27.343395103556738
                        },
                        {
                            "date": 20171226,
                            "skill": 30.025802526595385
                        },
                        {
                            "date": 20180117,
                            "skill": 33.43855550145161
                        },
                        {
                            "date": 20180219,
                            "skill": 35.08319817740541
                        },
                        {
                            "date": 20211112,
                            "skill": 31.05624766499082
                        },
                        {
                            "date": 20220321,
                            "skill": 30.01844464290595
                        }
                    ]
                },
                "jockeyClaiming": 7,
                "trainer": "R Dickin",
                "odds": "50/1",
                "skill": 31.05624766499082,
                "name": "Ballinslea Bridge",
                "_id": "Ballinslea Bridge_21-Mar-2022_15:55_Southwell",
                "position": 100,
                "age": "10",
                "oddsNumber": 50
            },
            {
                "weightNumber": 165,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:55_Southwell",
                "rating": {
                    "pi": 0.6426161145424832,
                    "tau": 19.58529154100202
                },
                "weight": "11-11",
                "accuracy": 1.2034105624158455,
                "jockey": "Luca Morgan",
                "url": "/form/horse/Apple-Rock/IRE/3059688",
                "score": 0.053803693187117446,
                "skillObj": {
                    "mu": 30.199728308355606,
                    "sigma": 1.2034105624158455,
                    "maxSkill": 32.6065494331873,
                    "minSkill": 27.792907183523916,
                    "muHistory": [
                        {
                            "date": 20191231,
                            "skill": 23.163852078474758
                        },
                        {
                            "date": 20200131,
                            "skill": 26.807073076534817
                        },
                        {
                            "date": 20200229,
                            "skill": 25.793340918502285
                        },
                        {
                            "date": 20201022,
                            "skill": 29.208671915250317
                        },
                        {
                            "date": 20201030,
                            "skill": 28.263635396512466
                        },
                        {
                            "date": 20201120,
                            "skill": 28.175984190603657
                        },
                        {
                            "date": 20210111,
                            "skill": 29.765860599487205
                        },
                        {
                            "date": 20210216,
                            "skill": 31.361681168153122
                        },
                        {
                            "date": 20210312,
                            "skill": 30.82183351919525
                        },
                        {
                            "date": 20210414,
                            "skill": 31.576898687530296
                        },
                        {
                            "date": 20211112,
                            "skill": 31.81700439851838
                        },
                        {
                            "date": 20211202,
                            "skill": 31.435895692573993
                        },
                        {
                            "date": 20220108,
                            "skill": 31.000561269023223
                        },
                        {
                            "date": 20220208,
                            "skill": 30.381941785118265
                        },
                        {
                            "date": 20220227,
                            "skill": 30.477436058300466
                        },
                        {
                            "date": 20220321,
                            "skill": 30.199728308355606
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "Ben Pauling",
                "odds": "6/1",
                "skill": 30.477436058300466,
                "name": "Apple Rock",
                "_id": "Apple Rock_21-Mar-2022_15:55_Southwell",
                "position": 100,
                "age": "8",
                "oddsNumber": 6
            },
            {
                "weightNumber": 166,
                "country": "USA",
                "raceId": "21-Mar-2022_15:55_Southwell",
                "rating": {
                    "pi": 0.22467901679993293,
                    "tau": 6.780915351462866
                },
                "weight": "11-12",
                "accuracy": 1.9070767352042297,
                "jockey": "Jack Tudor",
                "url": "/form/horse/London-Eye/USA/3043526",
                "score": 0.04549780230427613,
                "skillObj": {
                    "mu": 29.533098464592115,
                    "sigma": 1.9070767352042297,
                    "maxSkill": 33.34725193500057,
                    "minSkill": 25.718944994183655,
                    "muHistory": [
                        {
                            "date": 20210715,
                            "skill": 26.826384807923024
                        },
                        {
                            "date": 20210901,
                            "skill": 32.45150974801491
                        },
                        {
                            "date": 20210924,
                            "skill": 31.368188933609613
                        },
                        {
                            "date": 20211020,
                            "skill": 32.313507935598935
                        },
                        {
                            "date": 20211226,
                            "skill": 30.180456760236677
                        },
                        {
                            "date": 20220321,
                            "skill": 29.533098464592115
                        }
                    ]
                },
                "trainer": "C A Dwyer",
                "odds": "12/1",
                "skill": 30.180456760236677,
                "name": "London Eye",
                "_id": "London Eye_21-Mar-2022_15:55_Southwell",
                "position": 100,
                "age": "6",
                "oddsNumber": 12
            },
            {
                "weightNumber": 167,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:55_Southwell",
                "rating": {
                    "pi": 0.32938496285638935,
                    "tau": 9.696282910341116
                },
                "weight": "11-13",
                "accuracy": 1.6225370153014296,
                "jockey": "Lee Edwards",
                "url": "/form/horse/Niblawi/IRE/2850458",
                "score": 0.051111653585121625,
                "skillObj": {
                    "mu": 29.072525124612945,
                    "sigma": 1.6225370153014296,
                    "maxSkill": 32.3175991552158,
                    "minSkill": 25.827451094010087,
                    "muHistory": [
                        {
                            "date": 20171206,
                            "skill": 27.398277079029054
                        },
                        {
                            "date": 20180109,
                            "skill": 25.86480872112649
                        },
                        {
                            "date": 20180225,
                            "skill": 27.951135892096133
                        },
                        {
                            "date": 20190304,
                            "skill": 29.43371614795756
                        },
                        {
                            "date": 20201203,
                            "skill": 30.671267827475116
                        },
                        {
                            "date": 20211208,
                            "skill": 30.663098714913435
                        },
                        {
                            "date": 20211226,
                            "skill": 30.397682751565608
                        },
                        {
                            "date": 20220214,
                            "skill": 29.43753966864802
                        },
                        {
                            "date": 20220321,
                            "skill": 29.072525124612945
                        }
                    ]
                },
                "trainer": "Adam West",
                "odds": "10/1",
                "skill": 29.43753966864802,
                "name": "Niblawi",
                "_id": "Niblawi_21-Mar-2022_15:55_Southwell",
                "position": 100,
                "age": "10",
                "oddsNumber": 10
            },
            {
                "weightNumber": 163,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:55_Southwell",
                "rating": {
                    "pi": 0.37660431090651486,
                    "tau": 10.806916975681617
                },
                "weight": "11-9",
                "equipment": "h",
                "accuracy": 1.5319909740778332,
                "jockey": "Jonathan England",
                "url": "/form/horse/Gennady/IRE/3049747",
                "score": 0.059629788490248345,
                "skillObj": {
                    "mu": 28.48621345639417,
                    "sigma": 1.5319909740778332,
                    "maxSkill": 31.55019540454984,
                    "minSkill": 25.422231508238504,
                    "muHistory": [
                        {
                            "date": 20190902,
                            "skill": 23.173886774776626
                        },
                        {
                            "date": 20190910,
                            "skill": 24.113330207722026
                        },
                        {
                            "date": 20190918,
                            "skill": 24.119872903973004
                        },
                        {
                            "date": 20191206,
                            "skill": 26.960617174128647
                        },
                        {
                            "date": 20200104,
                            "skill": 29.699909769766037
                        },
                        {
                            "date": 20200302,
                            "skill": 28.053917700444494
                        },
                        {
                            "date": 20200317,
                            "skill": 28.97606013085679
                        },
                        {
                            "date": 20220214,
                            "skill": 28.739070146059827
                        },
                        {
                            "date": 20220308,
                            "skill": 28.69568048668523
                        },
                        {
                            "date": 20220321,
                            "skill": 28.48621345639417
                        }
                    ]
                },
                "trainer": "S England",
                "odds": "7/1",
                "skill": 28.69568048668523,
                "name": "Gennady",
                "_id": "Gennady_21-Mar-2022_15:55_Southwell",
                "position": 100,
                "age": "8",
                "oddsNumber": 7
            },
            {
                "weightNumber": 168,
                "country": "FR",
                "raceId": "21-Mar-2022_15:55_Southwell",
                "rating": {
                    "pi": 0.77343728586498,
                    "tau": 21.609167355062777
                },
                "weight": "12-0",
                "accuracy": 1.1040315245717753,
                "jockey": "Sean Quinlan",
                "url": "/form/horse/Lignou/FR/3015487",
                "score": 0.052220983973577134,
                "skillObj": {
                    "mu": 27.87637398992454,
                    "sigma": 1.1040315245717753,
                    "maxSkill": 30.084437039068092,
                    "minSkill": 25.66831094078099,
                    "muHistory": [
                        {
                            "date": 20181117,
                            "skill": 22.060150972850124
                        },
                        {
                            "date": 20181231,
                            "skill": 27.687988202890327
                        },
                        {
                            "date": 20190127,
                            "skill": 29.37290678957299
                        },
                        {
                            "date": 20190224,
                            "skill": 26.734795087256185
                        },
                        {
                            "date": 20191008,
                            "skill": 26.006630976110692
                        },
                        {
                            "date": 20200919,
                            "skill": 26.508788588960677
                        },
                        {
                            "date": 20201003,
                            "skill": 27.425507176511594
                        },
                        {
                            "date": 20201020,
                            "skill": 26.65168620726056
                        },
                        {
                            "date": 20201031,
                            "skill": 28.597283547746457
                        },
                        {
                            "date": 20201114,
                            "skill": 27.947786298994135
                        },
                        {
                            "date": 20210403,
                            "skill": 29.18007309883411
                        },
                        {
                            "date": 20210422,
                            "skill": 29.12101840753778
                        },
                        {
                            "date": 20210509,
                            "skill": 28.73016581746692
                        },
                        {
                            "date": 20210607,
                            "skill": 28.516197653904154
                        },
                        {
                            "date": 20211120,
                            "skill": 28.153710476757
                        },
                        {
                            "date": 20211204,
                            "skill": 28.001810658295124
                        },
                        {
                            "date": 20211221,
                            "skill": 27.87525499998748
                        },
                        {
                            "date": 20220125,
                            "skill": 27.93913320444073
                        },
                        {
                            "date": 20220321,
                            "skill": 27.87637398992454
                        }
                    ]
                },
                "trainer": "J Candlish",
                "odds": "12/1",
                "skill": 27.93913320444073,
                "name": "Lignou",
                "_id": "Lignou_21-Mar-2022_15:55_Southwell",
                "position": 100,
                "age": "7",
                "oddsNumber": 12
            },
            {
                "weightNumber": 166,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:55_Southwell",
                "rating": {
                    "pi": 0.2593867412509853,
                    "tau": 7.065702779663267
                },
                "weight": "11-12",
                "equipment": "t",
                "accuracy": 1.7961149064089077,
                "jockey": "Adam Wedge",
                "url": "/form/horse/Irish-Odyssey/IRE/3013875",
                "score": 0.052893531872743677,
                "skillObj": {
                    "mu": 27.21044219852032,
                    "sigma": 1.7961149064089077,
                    "maxSkill": 30.802672011338135,
                    "minSkill": 23.618212385702503,
                    "muHistory": [
                        {
                            "date": 20191226,
                            "skill": 32.48162841502906
                        },
                        {
                            "date": 20200124,
                            "skill": 23.17768453620684
                        },
                        {
                            "date": 20200312,
                            "skill": 23.358819129322697
                        },
                        {
                            "date": 20201203,
                            "skill": 24.927082569853205
                        },
                        {
                            "date": 20210307,
                            "skill": 27.52438130060303
                        },
                        {
                            "date": 20210330,
                            "skill": 27.240030641452176
                        },
                        {
                            "date": 20220321,
                            "skill": 27.21044219852032
                        }
                    ]
                },
                "trainer": "N P Mulholland",
                "odds": "10/1",
                "skill": 27.240030641452176,
                "name": "Irish Odyssey",
                "_id": "Irish Odyssey_21-Mar-2022_15:55_Southwell",
                "position": 100,
                "age": "9",
                "oddsNumber": 10
            },
            {
                "weightNumber": 164,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:55_Southwell",
                "rating": {
                    "pi": 0.14135206701678624,
                    "tau": 3.70251699856278
                },
                "weight": "11-10",
                "accuracy": 2.2875642886935483,
                "jockey": "Harry Bannister",
                "url": "/form/horse/Brulure-Noire/IRE/3305557",
                "score": -1,
                "skillObj": {
                    "mu": 26.43617063469587,
                    "sigma": 2.2875642886935483,
                    "maxSkill": 31.011299212082967,
                    "minSkill": 21.861042057308772,
                    "muHistory": [
                        {
                            "date": 20211123,
                            "skill": 21.07514067979696
                        },
                        {
                            "date": 20211229,
                            "skill": 27.928409896795078
                        },
                        {
                            "date": 20220122,
                            "skill": 26.19358228502657
                        },
                        {
                            "date": 20220321,
                            "skill": 26.43617063469587
                        }
                    ]
                },
                "trainer": "Richard Bandey",
                "odds": "16/1",
                "skill": 26.19358228502657,
                "name": "Brulure Noire",
                "_id": "Brulure Noire_21-Mar-2022_15:55_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 16
            },
            {
                "weightNumber": 156,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:55_Southwell",
                "rating": {
                    "pi": 0.48833658542739083,
                    "tau": 12.750080757376116
                },
                "weight": "11-2",
                "accuracy": 1.365054249897761,
                "jockey": "K Brogan",
                "url": "/form/horse/Bartholomew-J/IRE/2934038",
                "score": 0.061432479463620945,
                "skillObj": {
                    "mu": 26.215197615751784,
                    "sigma": 1.365054249897761,
                    "maxSkill": 28.945306115547304,
                    "minSkill": 23.485089115956264,
                    "muHistory": [
                        {
                            "date": 20190101,
                            "skill": 20.481132892930408
                        },
                        {
                            "date": 20190318,
                            "skill": 21.032411119095876
                        },
                        {
                            "date": 20190421,
                            "skill": 22.437158930566103
                        },
                        {
                            "date": 20191205,
                            "skill": 20.892734518414635
                        },
                        {
                            "date": 20200714,
                            "skill": 23.748373544454825
                        },
                        {
                            "date": 20200810,
                            "skill": 24.891757333433993
                        },
                        {
                            "date": 20201016,
                            "skill": 24.544988298196003
                        },
                        {
                            "date": 20210901,
                            "skill": 25.16658782249257
                        },
                        {
                            "date": 20211028,
                            "skill": 25.442232340484896
                        },
                        {
                            "date": 20211109,
                            "skill": 25.069494749366243
                        },
                        {
                            "date": 20220210,
                            "skill": 26.109206514226823
                        },
                        {
                            "date": 20220321,
                            "skill": 26.215197615751784
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "Simon Pearce",
                "odds": "4/1",
                "skill": 26.109206514226823,
                "name": "Bartholomew J",
                "_id": "Bartholomew J_21-Mar-2022_15:55_Southwell",
                "position": 100,
                "age": "8",
                "oddsNumber": 4
            },
            {
                "weightNumber": 150,
                "raceId": "21-Mar-2022_15:55_Southwell",
                "rating": {
                    "pi": 0.1775180112357357,
                    "tau": 4.56597367959979
                },
                "weight": "10-10",
                "accuracy": 2.0932246849953438,
                "jockey": "Paul O'Brien",
                "url": "/form/horse/William-Cody/GB/3297632",
                "score": 0.045549082781069894,
                "skillObj": {
                    "mu": 26.024920568150822,
                    "sigma": 2.0932246849953438,
                    "maxSkill": 30.21136993814151,
                    "minSkill": 21.838471198160136,
                    "muHistory": [
                        {
                            "date": 20211029,
                            "skill": 22.67797768288914
                        },
                        {
                            "date": 20211124,
                            "skill": 24.808969523927598
                        },
                        {
                            "date": 20211215,
                            "skill": 24.937040410789972
                        },
                        {
                            "date": 20220117,
                            "skill": 25.721185404315893
                        },
                        {
                            "date": 20220321,
                            "skill": 26.024920568150822
                        }
                    ]
                },
                "trainer": "Mrs P Sly",
                "odds": "6/1",
                "skill": 25.721185404315893,
                "name": "William Cody",
                "_id": "William Cody_21-Mar-2022_15:55_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 6
            },
            {
                "weightNumber": 148,
                "country": "IRE",
                "raceId": "21-Mar-2022_15:55_Southwell",
                "rating": {
                    "pi": 0.10375680442642166,
                    "tau": 2.1186717955225385
                },
                "weight": "10-8",
                "equipment": "t",
                "accuracy": 2.54100951792983,
                "jockey": "Thomas Dowson",
                "url": "/form/horse/Chemical-Warfare/IRE/3291187",
                "score": 0.04585852884050625,
                "skillObj": {
                    "mu": 22.74027901047147,
                    "sigma": 2.54100951792983,
                    "maxSkill": 27.822298046331127,
                    "minSkill": 17.65825997461181,
                    "muHistory": [
                        {
                            "date": 20211006,
                            "skill": 23.923669859161198
                        },
                        {
                            "date": 20211030,
                            "skill": 20.546246506883826
                        },
                        {
                            "date": 20211123,
                            "skill": 20.419593753246115
                        },
                        {
                            "date": 20220321,
                            "skill": 22.74027901047147
                        }
                    ]
                },
                "trainer": "Tjade Collier",
                "odds": "12/1",
                "skill": 20.419593753246115,
                "name": "Chemical Warfare",
                "_id": "Chemical Warfare_21-Mar-2022_15:55_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 12
            },
            {
                "weightNumber": 153,
                "raceId": "21-Mar-2022_15:55_Southwell",
                "rating": {
                    "pi": 0.26986076794683933,
                    "tau": 5.1667894511282215
                },
                "weight": "10-13",
                "accuracy": 1.7662572760402029,
                "jockey": "Harriet Tucker",
                "url": "/form/horse/Large-Action/GB/3283453",
                "score": 0.04730748221881695,
                "skillObj": {
                    "mu": 20.51561801403951,
                    "sigma": 1.7662572760402029,
                    "maxSkill": 24.048132566119918,
                    "minSkill": 16.983103461959104,
                    "muHistory": [
                        {
                            "date": 20210321,
                            "skill": 25.659426479868706
                        },
                        {
                            "date": 20210403,
                            "skill": 24.19193749473919
                        },
                        {
                            "date": 20210501,
                            "skill": 22.38514546443719
                        },
                        {
                            "date": 20220127,
                            "skill": 21.16208749938852
                        },
                        {
                            "date": 20220216,
                            "skill": 20.772492204223752
                        },
                        {
                            "date": 20220301,
                            "skill": 19.14613039323316
                        },
                        {
                            "date": 20220321,
                            "skill": 20.51561801403951
                        }
                    ]
                },
                "jockeyClaiming": 7,
                "trainer": "R G Fell",
                "odds": "11/2",
                "skill": 19.14613039323316,
                "name": "Large Action",
                "_id": "Large Action_21-Mar-2022_15:55_Southwell",
                "position": 100,
                "age": "6",
                "oddsNumber": 5.5
            }
        ],
        "id": "#20220321#21-Mar-2022_15:55_Southwell",
        "classNumber": 4,
        "weather": "Sunny spells",
        "postNumber": 6,
        "predictedWinner": "Bartholomew J",
        "location": "Southwell",
        "winnerPrizeMoney": "£6,753",
        "skillWinnerOdds": 50,
        "distanceCategory": "2.5miler",
        "runners": 12,
        "raceText": "Follow AtTheRaces On Twitter Handicap Hurdle",
        "isHandicap": true,
        "type": "jumps",
        "tagVersion": 42
    },
    {
        "raceType": "chase",
        "distance": "3m 1f 30y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:25:28.242Z",
        "time": "16:05",
        "country": "GB",
        "class": "jumps_class_4",
        "skillWinner": "Max Dynamo",
        "going": "Good to soft-soft in places",
        "trackType": [
            "tight",
            "level"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 5056.619999999999,
        "experienceCategory": "standard",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 2.25,
        "_id": "21-Mar-2022_16:05_Wincanton",
        "horses": [
            {
                "weightNumber": 151,
                "raceId": "21-Mar-2022_16:05_Wincanton",
                "rating": {
                    "pi": 0.3532471950943018,
                    "tau": 11.780117939343436
                },
                "weight": "10-11",
                "equipment": "h",
                "accuracy": 1.579785286110596,
                "jockey": "J Nailor",
                "url": "/form/horse/Max-Dynamo/GB/2916301",
                "score": 0.055045525706958906,
                "skillObj": {
                    "mu": 32.95119111004615,
                    "sigma": 1.579785286110596,
                    "maxSkill": 36.110761682267345,
                    "minSkill": 29.79162053782496,
                    "muHistory": [
                        {
                            "date": 20200124,
                            "skill": 28.08459012592851
                        },
                        {
                            "date": 20200311,
                            "skill": 32.3619950614185
                        },
                        {
                            "date": 20210302,
                            "skill": 28.00129162672005
                        },
                        {
                            "date": 20210317,
                            "skill": 27.456701806592932
                        },
                        {
                            "date": 20210508,
                            "skill": 29.450058251601405
                        },
                        {
                            "date": 20210519,
                            "skill": 30.424193414873262
                        },
                        {
                            "date": 20210530,
                            "skill": 31.631126598252795
                        },
                        {
                            "date": 20220126,
                            "skill": 32.51601958583989
                        },
                        {
                            "date": 20220219,
                            "skill": 33.34808627765226
                        },
                        {
                            "date": 20220321,
                            "skill": 32.95119111004615
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "Miss E J Baker",
                "odds": "9/4",
                "skill": 33.34808627765226,
                "name": "Max Dynamo",
                "_id": "Max Dynamo_21-Mar-2022_16:05_Wincanton",
                "position": 100,
                "age": "12",
                "oddsNumber": 2.25
            },
            {
                "weightNumber": 167,
                "country": "FR",
                "raceId": "21-Mar-2022_16:05_Wincanton",
                "rating": {
                    "pi": 0.6852022259794812,
                    "tau": 22.351626561261952
                },
                "weight": "11-13",
                "equipment": "p",
                "accuracy": 1.1699352119113744,
                "jockey": "Brendan Powell",
                "url": "/form/horse/Coup-De-Pinceau/FR/2917176",
                "score": 0.05383894558598926,
                "skillObj": {
                    "mu": 32.45512816261921,
                    "sigma": 1.1699352119113744,
                    "maxSkill": 34.79499858644196,
                    "minSkill": 30.115257738796462,
                    "muHistory": [
                        {
                            "date": 20181106,
                            "skill": 33.747102500081226
                        },
                        {
                            "date": 20181205,
                            "skill": 35.85667541842778
                        },
                        {
                            "date": 20181215,
                            "skill": 34.646035677448005
                        },
                        {
                            "date": 20190216,
                            "skill": 32.210522730279536
                        },
                        {
                            "date": 20190328,
                            "skill": 33.90065337102946
                        },
                        {
                            "date": 20200312,
                            "skill": 32.29070352824353
                        },
                        {
                            "date": 20200720,
                            "skill": 31.159548436905286
                        },
                        {
                            "date": 20200907,
                            "skill": 32.374639214683114
                        },
                        {
                            "date": 20201007,
                            "skill": 32.073990055299234
                        },
                        {
                            "date": 20201216,
                            "skill": 32.46625056646278
                        },
                        {
                            "date": 20201229,
                            "skill": 32.397558864278025
                        },
                        {
                            "date": 20210114,
                            "skill": 32.438417280511025
                        },
                        {
                            "date": 20210315,
                            "skill": 32.977316423006336
                        },
                        {
                            "date": 20210418,
                            "skill": 33.26370715066582
                        },
                        {
                            "date": 20211024,
                            "skill": 33.1486775108686
                        },
                        {
                            "date": 20211106,
                            "skill": 32.88857843601914
                        },
                        {
                            "date": 20211216,
                            "skill": 32.942872604023066
                        },
                        {
                            "date": 20220122,
                            "skill": 32.620481536397236
                        },
                        {
                            "date": 20220321,
                            "skill": 32.45512816261921
                        }
                    ]
                },
                "trainer": "C L Tizzard",
                "odds": "7/2",
                "skill": 32.620481536397236,
                "name": "Coup De Pinceau",
                "_id": "Coup De Pinceau_21-Mar-2022_16:05_Wincanton",
                "position": 100,
                "age": "10",
                "oddsNumber": 3.5
            },
            {
                "weightNumber": 151,
                "country": "FR",
                "raceId": "21-Mar-2022_16:05_Wincanton",
                "rating": {
                    "pi": 0.8252887265691998,
                    "tau": 26.36450861540387
                },
                "weight": "10-11",
                "equipment": "t",
                "accuracy": 1.0724560987686205,
                "jockey": "Maj Charlie O'Shea",
                "url": "/form/horse/Keltus/FR/2766654",
                "score": -1,
                "skillObj": {
                    "mu": 31.8416545397293,
                    "sigma": 1.0724560987686205,
                    "maxSkill": 33.98656673726654,
                    "minSkill": 29.69674234219206,
                    "muHistory": [
                        {
                            "date": 20140929,
                            "skill": 28.64157675264406
                        },
                        {
                            "date": 20141101,
                            "skill": 28.14552114647968
                        },
                        {
                            "date": 20141129,
                            "skill": 32.57591120681117
                        },
                        {
                            "date": 20150310,
                            "skill": 30.061937376464527
                        },
                        {
                            "date": 20160430,
                            "skill": 31.333970830749397
                        },
                        {
                            "date": 20160510,
                            "skill": 31.602452851883445
                        },
                        {
                            "date": 20160604,
                            "skill": 32.58099333187247
                        },
                        {
                            "date": 20160717,
                            "skill": 32.81082704157358
                        },
                        {
                            "date": 20160831,
                            "skill": 32.144257709301336
                        },
                        {
                            "date": 20161014,
                            "skill": 33.50939380088884
                        },
                        {
                            "date": 20161022,
                            "skill": 34.2582566887411
                        },
                        {
                            "date": 20170422,
                            "skill": 33.4526861568994
                        },
                        {
                            "date": 20170528,
                            "skill": 33.597470565797906
                        },
                        {
                            "date": 20170702,
                            "skill": 33.418263875327334
                        },
                        {
                            "date": 20190414,
                            "skill": 33.48594427595904
                        },
                        {
                            "date": 20191114,
                            "skill": 32.77987982964632
                        },
                        {
                            "date": 20210404,
                            "skill": 32.48924070472738
                        },
                        {
                            "date": 20210418,
                            "skill": 32.93417233696112
                        },
                        {
                            "date": 20210430,
                            "skill": 32.586670024382045
                        },
                        {
                            "date": 20210513,
                            "skill": 32.27841318161881
                        },
                        {
                            "date": 20210528,
                            "skill": 32.76063160522525
                        },
                        {
                            "date": 20220123,
                            "skill": 32.42295860999117
                        },
                        {
                            "date": 20220219,
                            "skill": 31.945800017169176
                        },
                        {
                            "date": 20220321,
                            "skill": 31.8416545397293
                        }
                    ]
                },
                "jockeyClaiming": 7,
                "trainer": "J Scott",
                "odds": "20/1",
                "skill": 31.945800017169176,
                "name": "Keltus",
                "_id": "Keltus_21-Mar-2022_16:05_Wincanton",
                "position": 100,
                "age": "12",
                "oddsNumber": 20
            },
            {
                "weightNumber": 159,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:05_Wincanton",
                "rating": {
                    "pi": 0.7233492023973649,
                    "tau": 22.368341094744665
                },
                "weight": "11-5",
                "equipment": "p",
                "accuracy": 1.1406168797050695,
                "jockey": "J J Burke",
                "url": "/form/horse/Smugglers-Blues/IRE/2921485",
                "score": 0.04963242714844177,
                "skillObj": {
                    "mu": 30.88829735604301,
                    "sigma": 1.1406168797050695,
                    "maxSkill": 33.169531115453154,
                    "minSkill": 28.607063596632873,
                    "muHistory": [
                        {
                            "date": 20181207,
                            "skill": 28.771127378172558
                        },
                        {
                            "date": 20190128,
                            "skill": 26.66871074006568
                        },
                        {
                            "date": 20190301,
                            "skill": 25.109318104379696
                        },
                        {
                            "date": 20190426,
                            "skill": 27.677911855258117
                        },
                        {
                            "date": 20200204,
                            "skill": 27.477148657251753
                        },
                        {
                            "date": 20201017,
                            "skill": 27.89743779488208
                        },
                        {
                            "date": 20201109,
                            "skill": 29.23847394252278
                        },
                        {
                            "date": 20201207,
                            "skill": 29.790649449850406
                        },
                        {
                            "date": 20201226,
                            "skill": 30.216013846014782
                        },
                        {
                            "date": 20210319,
                            "skill": 30.58895117325564
                        },
                        {
                            "date": 20210403,
                            "skill": 31.261775263554195
                        },
                        {
                            "date": 20210510,
                            "skill": 30.44421609746012
                        },
                        {
                            "date": 20211008,
                            "skill": 30.39008041356886
                        },
                        {
                            "date": 20211103,
                            "skill": 30.430773944269752
                        },
                        {
                            "date": 20211205,
                            "skill": 30.35044829794879
                        },
                        {
                            "date": 20220123,
                            "skill": 31.079665029133057
                        },
                        {
                            "date": 20220217,
                            "skill": 30.923295443763873
                        },
                        {
                            "date": 20220321,
                            "skill": 30.88829735604301
                        }
                    ]
                },
                "trainer": "T R George",
                "skill": 30.923295443763873,
                "name": "Smuggler's Blues",
                "_id": "Smuggler's Blues_21-Mar-2022_16:05_Wincanton",
                "position": 100,
                "age": "10"
            },
            {
                "weightNumber": 148,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:05_Wincanton",
                "rating": {
                    "pi": 0.18348461477398242,
                    "tau": 5.364043174988778
                },
                "weight": "10-8",
                "equipment": "p",
                "accuracy": 2.077807886859938,
                "jockey": "T Scudamore",
                "url": "/form/horse/Tikk-Tock-Boom/IRE/2962075",
                "score": -1,
                "skillObj": {
                    "mu": 29.49471095157599,
                    "sigma": 2.077807886859938,
                    "maxSkill": 33.65032672529586,
                    "minSkill": 25.339095177856112,
                    "muHistory": [
                        {
                            "date": 20190410,
                            "skill": 31.195530451857948
                        },
                        {
                            "date": 20190417,
                            "skill": 28.699453566593537
                        },
                        {
                            "date": 20191212,
                            "skill": 29.757113876851964
                        },
                        {
                            "date": 20220208,
                            "skill": 29.234294012041513
                        },
                        {
                            "date": 20220321,
                            "skill": 29.49471095157599
                        }
                    ]
                },
                "trainer": "Ian Williams",
                "odds": "14/1",
                "skill": 29.234294012041513,
                "name": "Tikk Tock Boom",
                "_id": "Tikk Tock Boom_21-Mar-2022_16:05_Wincanton",
                "position": 100,
                "age": "10",
                "oddsNumber": 14
            },
            {
                "weightNumber": 151,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:05_Wincanton",
                "rating": {
                    "pi": 0.42088762357601117,
                    "tau": 11.98907542901059
                },
                "weight": "10-11",
                "equipment": "p",
                "accuracy": 1.461295298553803,
                "jockey": "David England",
                "url": "/form/horse/Light-Flicker/IRE/2963949",
                "score": -1,
                "skillObj": {
                    "mu": 28.7080995045512,
                    "sigma": 1.461295298553803,
                    "maxSkill": 31.630690101658807,
                    "minSkill": 25.785508907443592,
                    "muHistory": [
                        {
                            "date": 20180504,
                            "skill": 21.491855596900493
                        },
                        {
                            "date": 20200304,
                            "skill": 23.55309315604857
                        },
                        {
                            "date": 20201205,
                            "skill": 28.045263437500488
                        },
                        {
                            "date": 20201231,
                            "skill": 26.238206158084456
                        },
                        {
                            "date": 20210116,
                            "skill": 28.00700033295177
                        },
                        {
                            "date": 20210221,
                            "skill": 29.2712781288096
                        },
                        {
                            "date": 20211003,
                            "skill": 27.62246916399011
                        },
                        {
                            "date": 20211029,
                            "skill": 27.424230684484446
                        },
                        {
                            "date": 20211202,
                            "skill": 28.513290169533906
                        },
                        {
                            "date": 20211231,
                            "skill": 28.48521732985906
                        },
                        {
                            "date": 20220321,
                            "skill": 28.7080995045512
                        }
                    ]
                },
                "trainer": "Ryan Potter",
                "odds": "10/1",
                "skill": 28.48521732985906,
                "name": "Light Flicker",
                "_id": "Light Flicker_21-Mar-2022_16:05_Wincanton",
                "position": 100,
                "age": "10",
                "oddsNumber": 10
            },
            {
                "weightNumber": 165,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:05_Wincanton",
                "rating": {
                    "pi": 0.3198313519866437,
                    "tau": 9.023369038656966
                },
                "weight": "11-11",
                "accuracy": 1.6479057335358946,
                "jockey": "Charlie Deutsch",
                "url": "/form/horse/Brianstorm/IRE/2921499",
                "score": 0.04828430676138465,
                "skillObj": {
                    "mu": 28.547275617109094,
                    "sigma": 1.6479057335358946,
                    "maxSkill": 31.843087084180883,
                    "minSkill": 25.251464150037304,
                    "muHistory": [
                        {
                            "date": 20181221,
                            "skill": 17.595501143248544
                        },
                        {
                            "date": 20210101,
                            "skill": 23.636856553229656
                        },
                        {
                            "date": 20210110,
                            "skill": 27.396044396200317
                        },
                        {
                            "date": 20210129,
                            "skill": 26.73330853590614
                        },
                        {
                            "date": 20210302,
                            "skill": 25.392040697744797
                        },
                        {
                            "date": 20210320,
                            "skill": 27.626519502913442
                        },
                        {
                            "date": 20211031,
                            "skill": 27.256480744216784
                        },
                        {
                            "date": 20220208,
                            "skill": 28.212897149100588
                        },
                        {
                            "date": 20220321,
                            "skill": 28.547275617109094
                        }
                    ]
                },
                "trainer": "Miss V Williams",
                "odds": "10/3",
                "skill": 28.212897149100588,
                "name": "Brianstorm",
                "_id": "Brianstorm_21-Mar-2022_16:05_Wincanton",
                "position": 100,
                "age": "10",
                "oddsNumber": 3.3333333333333335
            },
            {
                "weightNumber": 166,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:05_Wincanton",
                "rating": {
                    "pi": 0.2973800263003692,
                    "tau": 8.320051316011021
                },
                "weight": "11-12",
                "equipment": "t",
                "accuracy": 1.7003231224118065,
                "jockey": "Jack Andrews",
                "url": "/form/horse/Broken-Quest/IRE/2949098",
                "score": -1,
                "skillObj": {
                    "mu": 28.36638939734812,
                    "sigma": 1.7003231224118065,
                    "maxSkill": 31.76703564217173,
                    "minSkill": 24.965743152524507,
                    "muHistory": [
                        {
                            "date": 20210304,
                            "skill": 34.87066474762796
                        },
                        {
                            "date": 20210324,
                            "skill": 28.00742704365011
                        },
                        {
                            "date": 20210421,
                            "skill": 27.784203825328426
                        },
                        {
                            "date": 20211031,
                            "skill": 27.124592465200532
                        },
                        {
                            "date": 20211122,
                            "skill": 28.94698540740022
                        },
                        {
                            "date": 20211215,
                            "skill": 27.947496502881396
                        },
                        {
                            "date": 20220106,
                            "skill": 29.100122444943253
                        },
                        {
                            "date": 20220205,
                            "skill": 27.97784175191154
                        },
                        {
                            "date": 20220321,
                            "skill": 28.36638939734812
                        }
                    ]
                },
                "jockeyClaiming": 5,
                "trainer": "David Dennis",
                "odds": "10/1",
                "skill": 27.97784175191154,
                "name": "Broken Quest",
                "_id": "Broken Quest_21-Mar-2022_16:05_Wincanton",
                "position": 100,
                "age": "10",
                "oddsNumber": 10
            }
        ],
        "id": "#20220321#21-Mar-2022_16:05_Wincanton",
        "classNumber": 4,
        "weather": "Sunny spells",
        "postNumber": 5,
        "predictedWinner": "Max Dynamo",
        "location": "Wincanton",
        "winnerPrizeMoney": "£7,515",
        "skillWinnerOdds": 2.25,
        "distanceCategory": "3miler",
        "runners": 8,
        "raceText": "Watch Irish Racing On RacingTV Veterans' Handicap Chase",
        "isHandicap": true,
        "type": "jumps",
        "tagVersion": 42
    },
    {
        "raceType": "chase",
        "distance": "3m 1f 152y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:25:07.033Z",
        "time": "16:15",
        "country": "GB",
        "class": "jumps_class_5",
        "skillWinner": "Flaminger",
        "going": "Good-good to soft in places",
        "trackType": [
            "tight",
            "undulating"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 5168.176799999999,
        "experienceCategory": "standard",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 2.25,
        "_id": "21-Mar-2022_16:15_Plumpton",
        "horses": [
            {
                "weightNumber": 166,
                "country": "FR",
                "raceId": "21-Mar-2022_16:15_Plumpton",
                "rating": {
                    "pi": 0.6026303638469087,
                    "tau": 18.23438859347456
                },
                "weight": "11-12",
                "equipment": "p",
                "accuracy": 1.2453604105304623,
                "jockey": "Joshua Moore",
                "url": "/form/horse/Flaminger/FR/3069548",
                "score": 0.046791866815484834,
                "skillObj": {
                    "mu": 29.91802663798464,
                    "sigma": 1.2453604105304623,
                    "maxSkill": 32.408747459045564,
                    "minSkill": 27.427305816923713,
                    "muHistory": [
                        {
                            "date": 20191202,
                            "skill": 29.994708772059198
                        },
                        {
                            "date": 20191216,
                            "skill": 33.443121603505524
                        },
                        {
                            "date": 20191226,
                            "skill": 35.57559881278168
                        },
                        {
                            "date": 20200113,
                            "skill": 32.61547771148221
                        },
                        {
                            "date": 20200228,
                            "skill": 32.55316597908011
                        },
                        {
                            "date": 20201003,
                            "skill": 33.8835459113373
                        },
                        {
                            "date": 20201031,
                            "skill": 33.33878281196013
                        },
                        {
                            "date": 20201120,
                            "skill": 33.03899697620607
                        },
                        {
                            "date": 20201216,
                            "skill": 32.02820128074875
                        },
                        {
                            "date": 20210301,
                            "skill": 32.253709732568744
                        },
                        {
                            "date": 20210327,
                            "skill": 31.717057464548613
                        },
                        {
                            "date": 20210412,
                            "skill": 30.83568891377409
                        },
                        {
                            "date": 20211207,
                            "skill": 30.5993760058884
                        },
                        {
                            "date": 20211226,
                            "skill": 30.398647649871332
                        },
                        {
                            "date": 20220119,
                            "skill": 30.4989251539298
                        },
                        {
                            "date": 20220228,
                            "skill": 30.2579984139445
                        },
                        {
                            "date": 20220321,
                            "skill": 29.91802663798464
                        }
                    ]
                },
                "trainer": "G L Moore",
                "odds": "3/1",
                "skill": 30.2579984139445,
                "name": "Flaminger",
                "_id": "Flaminger_21-Mar-2022_16:15_Plumpton",
                "position": 100,
                "age": "7",
                "oddsNumber": 3
            },
            {
                "weightNumber": 159,
                "country": "FR",
                "raceId": "21-Mar-2022_16:15_Plumpton",
                "rating": {
                    "pi": 0.6139675386316569,
                    "tau": 18.078948077973813
                },
                "weight": "11-5",
                "equipment": "t",
                "accuracy": 1.234457768319972,
                "jockey": "N F Houlihan",
                "url": "/form/horse/Tzar-De-Lelfe/FR/2802674",
                "score": 0.04230939789959922,
                "skillObj": {
                    "mu": 29.179370986675778,
                    "sigma": 1.234457768319972,
                    "maxSkill": 31.648286523315722,
                    "minSkill": 26.710455450035834,
                    "muHistory": [
                        {
                            "date": 20171114,
                            "skill": 29.508086819128124
                        },
                        {
                            "date": 20171205,
                            "skill": 24.1958160931543
                        },
                        {
                            "date": 20181210,
                            "skill": 26.006931040517838
                        },
                        {
                            "date": 20190115,
                            "skill": 27.874198508197036
                        },
                        {
                            "date": 20190225,
                            "skill": 29.05973962161698
                        },
                        {
                            "date": 20190321,
                            "skill": 30.06083212716002
                        },
                        {
                            "date": 20190421,
                            "skill": 30.064620653205708
                        },
                        {
                            "date": 20191202,
                            "skill": 31.201955651224814
                        },
                        {
                            "date": 20200120,
                            "skill": 31.377427863015154
                        },
                        {
                            "date": 20201021,
                            "skill": 30.617300580664214
                        },
                        {
                            "date": 20201116,
                            "skill": 30.323612298139807
                        },
                        {
                            "date": 20210301,
                            "skill": 30.36043196972779
                        },
                        {
                            "date": 20210404,
                            "skill": 29.945423680129455
                        },
                        {
                            "date": 20220119,
                            "skill": 29.76088421381957
                        },
                        {
                            "date": 20220228,
                            "skill": 29.44609761986143
                        },
                        {
                            "date": 20220321,
                            "skill": 29.179370986675778
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "R Rowe",
                "skill": 29.44609761986143,
                "name": "Tzar De L'elfe",
                "_id": "Tzar De L'elfe_21-Mar-2022_16:15_Plumpton",
                "position": 100,
                "age": "12"
            },
            {
                "weightNumber": 143,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:15_Plumpton",
                "rating": {
                    "pi": 1.0565901595448426,
                    "tau": 26.815310204309455
                },
                "weight": "10-3",
                "equipment": "p",
                "accuracy": 0.9563444435417507,
                "jockey": "Sean Houlihan",
                "url": "/form/horse/Auld-Sod/IRE/2975464",
                "score": -1,
                "skillObj": {
                    "mu": 25.42402662885497,
                    "sigma": 0.9563444435417507,
                    "maxSkill": 27.336715515938472,
                    "minSkill": 23.51133774177147,
                    "muHistory": [
                        {
                            "date": 20190509,
                            "skill": 27.78103244289152
                        },
                        {
                            "date": 20190601,
                            "skill": 28.182939568341098
                        },
                        {
                            "date": 20190610,
                            "skill": 25.066474774301962
                        },
                        {
                            "date": 20190620,
                            "skill": 25.643030921159415
                        },
                        {
                            "date": 20190713,
                            "skill": 25.635891509984102
                        },
                        {
                            "date": 20190730,
                            "skill": 24.67238780617254
                        },
                        {
                            "date": 20190801,
                            "skill": 23.143917884714654
                        },
                        {
                            "date": 20190814,
                            "skill": 23.46286513352197
                        },
                        {
                            "date": 20190821,
                            "skill": 22.6369576158068
                        },
                        {
                            "date": 20200818,
                            "skill": 23.900813562680725
                        },
                        {
                            "date": 20200902,
                            "skill": 24.401940882204844
                        },
                        {
                            "date": 20200922,
                            "skill": 24.467624331007933
                        },
                        {
                            "date": 20201015,
                            "skill": 23.816609393628955
                        },
                        {
                            "date": 20201101,
                            "skill": 24.363044519647048
                        },
                        {
                            "date": 20201123,
                            "skill": 24.47488035397779
                        },
                        {
                            "date": 20201215,
                            "skill": 24.852640672569855
                        },
                        {
                            "date": 20210403,
                            "skill": 24.987278463651283
                        },
                        {
                            "date": 20210416,
                            "skill": 25.132621771175906
                        },
                        {
                            "date": 20210603,
                            "skill": 25.720107733008724
                        },
                        {
                            "date": 20210615,
                            "skill": 25.521315572783333
                        },
                        {
                            "date": 20210713,
                            "skill": 25.574792993016406
                        },
                        {
                            "date": 20210819,
                            "skill": 25.276968427922856
                        },
                        {
                            "date": 20211018,
                            "skill": 25.62022587593455
                        },
                        {
                            "date": 20211101,
                            "skill": 25.748314356087935
                        },
                        {
                            "date": 20211114,
                            "skill": 25.62620297278465
                        },
                        {
                            "date": 20220309,
                            "skill": 25.379102731622016
                        },
                        {
                            "date": 20220321,
                            "skill": 25.42402662885497
                        }
                    ]
                },
                "trainer": "Mrs Cynthia Woods",
                "odds": "8/1",
                "skill": 25.379102731622016,
                "name": "Auld Sod",
                "_id": "Auld Sod_21-Mar-2022_16:15_Plumpton",
                "position": 100,
                "age": "9",
                "oddsNumber": 8
            },
            {
                "weightNumber": 157,
                "raceId": "21-Mar-2022_16:15_Plumpton",
                "rating": {
                    "pi": 0.37475648283414015,
                    "tau": 9.500438093771262
                },
                "weight": "11-3",
                "equipment": "v",
                "accuracy": 1.5453417958849094,
                "jockey": "Caoilin Quinn",
                "url": "/form/horse/Minella-Examiner/GB/3063787",
                "score": 0.0381780953379713,
                "skillObj": {
                    "mu": 25.476470026886897,
                    "sigma": 1.5453417958849094,
                    "maxSkill": 28.567153618656715,
                    "minSkill": 22.38578643511708,
                    "muHistory": [
                        {
                            "date": 20191212,
                            "skill": 19.717253855055233
                        },
                        {
                            "date": 20191226,
                            "skill": 19.879116352083532
                        },
                        {
                            "date": 20200206,
                            "skill": 26.00258592683477
                        },
                        {
                            "date": 20200228,
                            "skill": 27.962952832312325
                        },
                        {
                            "date": 20201001,
                            "skill": 27.512720439640763
                        },
                        {
                            "date": 20211212,
                            "skill": 26.59572699630211
                        },
                        {
                            "date": 20220110,
                            "skill": 25.855627213709628
                        },
                        {
                            "date": 20220210,
                            "skill": 25.350963969783997
                        },
                        {
                            "date": 20220321,
                            "skill": 25.476470026886897
                        }
                    ]
                },
                "jockeyClaiming": 7,
                "trainer": "W Greatrex",
                "odds": "9/2",
                "skill": 25.350963969783997,
                "name": "Minella Examiner",
                "_id": "Minella Examiner_21-Mar-2022_16:15_Plumpton",
                "position": 100,
                "age": "9",
                "oddsNumber": 4.5
            },
            {
                "weightNumber": 163,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:15_Plumpton",
                "rating": {
                    "pi": 0.06832646643771734,
                    "tau": 1.6837370583840845
                },
                "weight": "11-9",
                "accuracy": 2.9672864186452568,
                "jockey": "J E Moore",
                "url": "/form/horse/Call-Off-The-Dogs/IRE/3044621",
                "score": 0.05017341253129839,
                "skillObj": {
                    "mu": 25.431102182009383,
                    "sigma": 2.9672864186452568,
                    "maxSkill": 31.365675019299896,
                    "minSkill": 19.49652934471887,
                    "muHistory": [
                        {
                            "date": 20220217,
                            "skill": 15.810139601416997
                        },
                        {
                            "date": 20220309,
                            "skill": 24.64253086933578
                        },
                        {
                            "date": 20220321,
                            "skill": 25.431102182009383
                        }
                    ]
                },
                "trainer": "G L Moore",
                "odds": "9/4",
                "skill": 24.64253086933578,
                "name": "Call Off The Dogs",
                "_id": "Call Off The Dogs_21-Mar-2022_16:15_Plumpton",
                "position": 100,
                "age": "7",
                "oddsNumber": 2.25
            },
            {
                "weightNumber": 149,
                "country": "FR",
                "raceId": "21-Mar-2022_16:15_Plumpton",
                "rating": {
                    "pi": 0.02977994330925647,
                    "tau": 0.44771628682063125
                },
                "weight": "10-9",
                "equipment": "v",
                "accuracy": 3.640046804828798,
                "jockey": "Thomas Bellamy",
                "url": "/form/horse/Pour-Une-Raison/FR/3093494",
                "score": -1,
                "skillObj": {
                    "mu": 22.39641874711803,
                    "sigma": 3.640046804828798,
                    "maxSkill": 29.676512356775625,
                    "minSkill": 15.116325137460434,
                    "muHistory": [
                        {
                            "date": 20220120,
                            "skill": 15.034155108061205
                        },
                        {
                            "date": 20220321,
                            "skill": 22.39641874711803
                        }
                    ]
                },
                "trainer": "N R Mitchell",
                "odds": "8/1",
                "skill": 15.034155108061205,
                "name": "Pour Une Raison",
                "_id": "Pour Une Raison_21-Mar-2022_16:15_Plumpton",
                "position": 100,
                "age": "7",
                "oddsNumber": 8
            }
        ],
        "id": "#20220321#21-Mar-2022_16:15_Plumpton",
        "classNumber": 5,
        "weather": "Sunny spells",
        "postNumber": 5,
        "predictedWinner": "Call Off The Dogs",
        "location": "Plumpton",
        "winnerPrizeMoney": "£4,575",
        "skillWinnerOdds": 3,
        "distanceCategory": "3miler",
        "runners": 6,
        "raceText": "Watch Live Racing At Your Local Handicap Chase",
        "isHandicap": true,
        "type": "jumps",
        "tagVersion": 42
    },
    {
        "raceType": "hurdle",
        "distance": "3m 60y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:27:02.916Z",
        "time": "16:30",
        "country": "GB",
        "class": "jumps_class_5",
        "skillWinner": "Optimistic Bias",
        "going": "Good-good to soft in places",
        "trackType": [
            "galloping",
            "level"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 4882.883999999999,
        "experienceCategory": "standard",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 2.75,
        "_id": "21-Mar-2022_16:30_Southwell",
        "horses": [
            {
                "weightNumber": 162,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:30_Southwell",
                "rating": {
                    "pi": 0.6105481935152732,
                    "tau": 18.659807575991447
                },
                "weight": "11-8",
                "equipment": "b",
                "accuracy": 1.2314024055112645,
                "jockey": "Danny Burton",
                "url": "/form/horse/Optimistic-Bias/IRE/2860349",
                "score": 0.040768956308791605,
                "skillObj": {
                    "mu": 29.994644731813974,
                    "sigma": 1.2314024055112645,
                    "maxSkill": 32.4574495428365,
                    "minSkill": 27.531839920791445,
                    "muHistory": [
                        {
                            "date": 20150215,
                            "skill": 32.0986188433353
                        },
                        {
                            "date": 20150316,
                            "skill": 35.32488997716739
                        },
                        {
                            "date": 20150415,
                            "skill": 35.83150342653521
                        },
                        {
                            "date": 20151025,
                            "skill": 36.239880919421104
                        },
                        {
                            "date": 20151120,
                            "skill": 34.515590778990315
                        },
                        {
                            "date": 20160228,
                            "skill": 34.741397124772426
                        },
                        {
                            "date": 20160403,
                            "skill": 33.27213241209805
                        },
                        {
                            "date": 20160901,
                            "skill": 34.04957908135644
                        },
                        {
                            "date": 20161002,
                            "skill": 33.823788483996275
                        },
                        {
                            "date": 20181231,
                            "skill": 32.34812044523914
                        },
                        {
                            "date": 20211024,
                            "skill": 31.457480985643127
                        },
                        {
                            "date": 20211120,
                            "skill": 30.409408193730982
                        },
                        {
                            "date": 20211211,
                            "skill": 30.589178881580793
                        },
                        {
                            "date": 20220210,
                            "skill": 30.562382747472107
                        },
                        {
                            "date": 20220321,
                            "skill": 29.994644731813974
                        }
                    ]
                },
                "jockeyClaiming": 5,
                "trainer": "H J Evans",
                "odds": "15/2",
                "skill": 30.562382747472107,
                "name": "Optimistic Bias",
                "_id": "Optimistic Bias_21-Mar-2022_16:30_Southwell",
                "position": 100,
                "age": "13",
                "oddsNumber": 7.5
            },
            {
                "weightNumber": 166,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:30_Southwell",
                "rating": {
                    "pi": 0.2457564004130591,
                    "tau": 7.405962679554316
                },
                "weight": "11-12",
                "equipment": "p",
                "accuracy": 1.8365826806946475,
                "jockey": "Max Kendrick",
                "url": "/form/horse/Gibberwell/IRE/3184282",
                "score": 0.04211049731974074,
                "skillObj": {
                    "mu": 28.995670548879822,
                    "sigma": 1.8365826806946475,
                    "maxSkill": 32.66883591026912,
                    "minSkill": 25.322505187490528,
                    "muHistory": [
                        {
                            "date": 20200930,
                            "skill": 32.53431337989198
                        },
                        {
                            "date": 20201025,
                            "skill": 36.31505500318499
                        },
                        {
                            "date": 20201229,
                            "skill": 32.39502593947023
                        },
                        {
                            "date": 20210309,
                            "skill": 31.225769634884543
                        },
                        {
                            "date": 20211207,
                            "skill": 30.59422163756046
                        },
                        {
                            "date": 20220107,
                            "skill": 30.13538067414164
                        },
                        {
                            "date": 20220321,
                            "skill": 28.995670548879822
                        }
                    ]
                },
                "trainer": "Mr Jake Coulson",
                "odds": "12/1",
                "skill": 30.13538067414164,
                "name": "Gibberwell",
                "_id": "Gibberwell_21-Mar-2022_16:30_Southwell",
                "position": 100,
                "age": "6",
                "oddsNumber": 12
            },
            {
                "weightNumber": 162,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:30_Southwell",
                "rating": {
                    "pi": 0.28934600358431684,
                    "tau": 7.702664973050186
                },
                "weight": "11-8",
                "accuracy": 1.71737139833032,
                "jockey": "S Bowen",
                "url": "/form/horse/Hillview/IRE/3178350",
                "score": 0.04610763670115624,
                "skillObj": {
                    "mu": 26.215338637796382,
                    "sigma": 1.71737139833032,
                    "maxSkill": 29.65008143445702,
                    "minSkill": 22.780595841135742,
                    "muHistory": [
                        {
                            "date": 20210625,
                            "skill": 22.226206999601413
                        },
                        {
                            "date": 20210717,
                            "skill": 17.283543513935744
                        },
                        {
                            "date": 20210730,
                            "skill": 20.720337529793184
                        },
                        {
                            "date": 20210828,
                            "skill": 20.65293493459688
                        },
                        {
                            "date": 20210908,
                            "skill": 22.96680940897328
                        },
                        {
                            "date": 20210929,
                            "skill": 25.230890860940814
                        },
                        {
                            "date": 20211026,
                            "skill": 26.620948199153514
                        },
                        {
                            "date": 20220321,
                            "skill": 26.215338637796382
                        }
                    ]
                },
                "trainer": "G D Hanmer",
                "odds": "11/4",
                "skill": 26.620948199153514,
                "name": "Hillview",
                "_id": "Hillview_21-Mar-2022_16:30_Southwell",
                "position": 100,
                "age": "6",
                "oddsNumber": 2.75
            },
            {
                "weightNumber": 140,
                "raceId": "21-Mar-2022_16:30_Southwell",
                "rating": {
                    "pi": 0.768658431860096,
                    "tau": 20.208583747190794
                },
                "weight": "10-0",
                "equipment": "t",
                "accuracy": 1.1078955400709665,
                "jockey": "Lewis Stones",
                "url": "/form/horse/Ratoute-Yutty/GB/2958668",
                "score": -1,
                "skillObj": {
                    "mu": 26.08164208669354,
                    "sigma": 1.1078955400709665,
                    "maxSkill": 28.297433166835475,
                    "minSkill": 23.86585100655161,
                    "muHistory": [
                        {
                            "date": 20171126,
                            "skill": 36.569035327303176
                        },
                        {
                            "date": 20181123,
                            "skill": 34.34305555171935
                        },
                        {
                            "date": 20181215,
                            "skill": 32.9283432567787
                        },
                        {
                            "date": 20190118,
                            "skill": 32.57961196918175
                        },
                        {
                            "date": 20190301,
                            "skill": 31.62542568199248
                        },
                        {
                            "date": 20190414,
                            "skill": 31.84485706640786
                        },
                        {
                            "date": 20190517,
                            "skill": 32.276505113933844
                        },
                        {
                            "date": 20191009,
                            "skill": 30.355625136385417
                        },
                        {
                            "date": 20191226,
                            "skill": 29.83989052780895
                        },
                        {
                            "date": 20200116,
                            "skill": 29.88820910759487
                        },
                        {
                            "date": 20200707,
                            "skill": 28.894572374579905
                        },
                        {
                            "date": 20210119,
                            "skill": 28.214897119275278
                        },
                        {
                            "date": 20210301,
                            "skill": 27.80940566709091
                        },
                        {
                            "date": 20210323,
                            "skill": 26.877776558654002
                        },
                        {
                            "date": 20220114,
                            "skill": 26.4556438295661
                        },
                        {
                            "date": 20220117,
                            "skill": 26.742016708025012
                        },
                        {
                            "date": 20220209,
                            "skill": 26.436041687018875
                        },
                        {
                            "date": 20220228,
                            "skill": 26.29072018150836
                        },
                        {
                            "date": 20220321,
                            "skill": 26.08164208669354
                        }
                    ]
                },
                "jockeyClaiming": 5,
                "trainer": "Miss C Fryer",
                "odds": "25/1",
                "skill": 26.29072018150836,
                "name": "Ratoute Yutty",
                "_id": "Ratoute Yutty_21-Mar-2022_16:30_Southwell",
                "position": 100,
                "age": "9",
                "oddsNumber": 25
            },
            {
                "weightNumber": 158,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:30_Southwell",
                "rating": {
                    "pi": 0.46987793717554344,
                    "tau": 12.215149126319169
                },
                "weight": "11-4",
                "equipment": "p",
                "accuracy": 1.3868068878657072,
                "jockey": "Adam Wedge",
                "url": "/form/horse/Uisce-Ur/IRE/2919233",
                "score": 0.03854592578785355,
                "skillObj": {
                    "mu": 25.763727158511728,
                    "sigma": 1.3868068878657072,
                    "maxSkill": 28.53734093424314,
                    "minSkill": 22.990113382780315,
                    "muHistory": [
                        {
                            "date": 20190306,
                            "skill": 23.322484996042256
                        },
                        {
                            "date": 20190411,
                            "skill": 28.718492727021584
                        },
                        {
                            "date": 20190514,
                            "skill": 24.274114877908165
                        },
                        {
                            "date": 20210111,
                            "skill": 27.294230715255782
                        },
                        {
                            "date": 20210119,
                            "skill": 26.253769832669033
                        },
                        {
                            "date": 20210226,
                            "skill": 27.047894867271808
                        },
                        {
                            "date": 20210315,
                            "skill": 27.675023233203532
                        },
                        {
                            "date": 20211127,
                            "skill": 27.04664876771173
                        },
                        {
                            "date": 20211204,
                            "skill": 26.130128663533142
                        },
                        {
                            "date": 20220216,
                            "skill": 25.996430476699878
                        },
                        {
                            "date": 20220321,
                            "skill": 25.763727158511728
                        }
                    ]
                },
                "trainer": "L J Morgan",
                "odds": "8/1",
                "skill": 25.996430476699878,
                "name": "Uisce Ur",
                "_id": "Uisce Ur_21-Mar-2022_16:30_Southwell",
                "position": 100,
                "age": "10",
                "oddsNumber": 8
            },
            {
                "weightNumber": 156,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:30_Southwell",
                "rating": {
                    "pi": 0.25970737296687696,
                    "tau": 6.201605955159611
                },
                "weight": "11-2",
                "accuracy": 1.7960389668056618,
                "jockey": "Kielan Woods",
                "url": "/form/horse/Train-Hill/IRE/3202962",
                "score": 0.04378441154961347,
                "skillObj": {
                    "mu": 23.9303262797451,
                    "sigma": 1.7960389668056618,
                    "maxSkill": 27.522404213356424,
                    "minSkill": 20.338248346133774,
                    "muHistory": [
                        {
                            "date": 20201010,
                            "skill": 26.096104612626924
                        },
                        {
                            "date": 20201028,
                            "skill": 24.60667714099158
                        },
                        {
                            "date": 20210508,
                            "skill": 21.55171735989371
                        },
                        {
                            "date": 20210531,
                            "skill": 19.95478479624019
                        },
                        {
                            "date": 20210630,
                            "skill": 22.19250029399326
                        },
                        {
                            "date": 20210901,
                            "skill": 23.879206371051172
                        },
                        {
                            "date": 20220321,
                            "skill": 23.9303262797451
                        }
                    ]
                },
                "trainer": "C E Longsdon",
                "odds": "10/3",
                "skill": 23.879206371051172,
                "name": "Train Hill",
                "_id": "Train Hill_21-Mar-2022_16:30_Southwell",
                "position": 100,
                "age": "6",
                "oddsNumber": 3.3333333333333335
            },
            {
                "weightNumber": 145,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:30_Southwell",
                "rating": {
                    "pi": 0.5856255007682464,
                    "tau": 13.972713852055813
                },
                "weight": "10-5",
                "equipment": "t",
                "accuracy": 1.2553231477662319,
                "jockey": "Phillip Armson",
                "url": "/form/horse/Miss-M/IRE/2957901",
                "score": 0.04092846387928132,
                "skillObj": {
                    "mu": 23.878461695135666,
                    "sigma": 1.2553231477662319,
                    "maxSkill": 26.38910799066813,
                    "minSkill": 21.367815399603202,
                    "muHistory": [
                        {
                            "date": 20200810,
                            "skill": 36.45521724852553
                        },
                        {
                            "date": 20200824,
                            "skill": 39.14939313142266
                        },
                        {
                            "date": 20200904,
                            "skill": 30.36068978126422
                        },
                        {
                            "date": 20210323,
                            "skill": 25.730934869691772
                        },
                        {
                            "date": 20210421,
                            "skill": 25.861714020269407
                        },
                        {
                            "date": 20210513,
                            "skill": 25.872770381674574
                        },
                        {
                            "date": 20210831,
                            "skill": 23.904653210469863
                        },
                        {
                            "date": 20211109,
                            "skill": 23.86415985024948
                        },
                        {
                            "date": 20211121,
                            "skill": 23.48809869251405
                        },
                        {
                            "date": 20211207,
                            "skill": 23.388587967851105
                        },
                        {
                            "date": 20220110,
                            "skill": 23.565447361643482
                        },
                        {
                            "date": 20220122,
                            "skill": 23.9584109881419
                        },
                        {
                            "date": 20220207,
                            "skill": 23.607810644166435
                        },
                        {
                            "date": 20220310,
                            "skill": 23.85946963328247
                        },
                        {
                            "date": 20220321,
                            "skill": 23.878461695135666
                        }
                    ]
                },
                "jockeyClaiming": 7,
                "trainer": "D Pipe",
                "odds": "10/1",
                "skill": 23.85946963328247,
                "name": "Miss M",
                "_id": "Miss M_21-Mar-2022_16:30_Southwell",
                "position": 100,
                "age": "8",
                "oddsNumber": 10
            },
            {
                "weightNumber": 154,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:30_Southwell",
                "rating": {
                    "pi": 0.15551738744300794,
                    "tau": 3.63061141955692
                },
                "weight": "11-0",
                "accuracy": 2.199443380188602,
                "jockey": "Tabitha Worsley",
                "url": "/form/horse/Cloudy-Wednesday/IRE/3264687",
                "score": -1,
                "skillObj": {
                    "mu": 23.36054466112966,
                    "sigma": 2.199443380188602,
                    "maxSkill": 27.75943142150686,
                    "minSkill": 18.961657900752456,
                    "muHistory": [
                        {
                            "date": 20210214,
                            "skill": 21.92572755028611
                        },
                        {
                            "date": 20210305,
                            "skill": 22.751582935759874
                        },
                        {
                            "date": 20210309,
                            "skill": 23.34537301102374
                        },
                        {
                            "date": 20220321,
                            "skill": 23.36054466112966
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "Miss C Fryer",
                "odds": "25/1",
                "skill": 23.34537301102374,
                "name": "Cloudy Wednesday",
                "_id": "Cloudy Wednesday_21-Mar-2022_16:30_Southwell",
                "position": 100,
                "age": "6",
                "oddsNumber": 25
            },
            {
                "weightNumber": 149,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:30_Southwell",
                "rating": {
                    "pi": 0.0940138590579683,
                    "tau": 2.0500100787087003
                },
                "weight": "10-9",
                "equipment": "p",
                "accuracy": 2.6195387304526565,
                "jockey": "Craig Nichol",
                "url": "/form/horse/The-Questioner/IRE/3293203",
                "score": 0.037707967342751135,
                "skillObj": {
                    "mu": 22.53387321529343,
                    "sigma": 2.6195387304526565,
                    "maxSkill": 27.772950676198743,
                    "minSkill": 17.294795754388115,
                    "muHistory": [
                        {
                            "date": 20211229,
                            "skill": 21.76567596863059
                        },
                        {
                            "date": 20220211,
                            "skill": 21.805402940056723
                        },
                        {
                            "date": 20220321,
                            "skill": 22.53387321529343
                        }
                    ]
                },
                "trainer": "Oliver Greenall",
                "odds": "12/1",
                "skill": 21.805402940056723,
                "name": "The Questioner",
                "_id": "The Questioner_21-Mar-2022_16:30_Southwell",
                "position": 100,
                "age": "6",
                "oddsNumber": 12
            },
            {
                "weightNumber": 140,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:30_Southwell",
                "rating": {
                    "pi": 0.23145729035208037,
                    "tau": 4.679656432009437
                },
                "weight": "10-0",
                "accuracy": 1.8826445825904778,
                "jockey": "Benjamin Poste",
                "url": "/form/horse/Fitz-The-Brief/IRE/3300643",
                "score": -1,
                "skillObj": {
                    "mu": 20.838327252489336,
                    "sigma": 1.8826445825904778,
                    "maxSkill": 24.603616417670292,
                    "minSkill": 17.07303808730838,
                    "muHistory": [
                        {
                            "date": 20210920,
                            "skill": 23.676073061664603
                        },
                        {
                            "date": 20211003,
                            "skill": 20.289691255235677
                        },
                        {
                            "date": 20211021,
                            "skill": 20.23089254820175
                        },
                        {
                            "date": 20211109,
                            "skill": 21.103639429673567
                        },
                        {
                            "date": 20211202,
                            "skill": 20.218228706000122
                        },
                        {
                            "date": 20220321,
                            "skill": 20.838327252489336
                        }
                    ]
                },
                "trainer": "R Dickin",
                "odds": "20/1",
                "skill": 20.218228706000122,
                "name": "Fitz The Brief",
                "_id": "Fitz The Brief_21-Mar-2022_16:30_Southwell",
                "position": 100,
                "age": "6",
                "oddsNumber": 20
            },
            {
                "weightNumber": 149,
                "raceId": "21-Mar-2022_16:30_Southwell",
                "rating": {
                    "pi": 0.33753372851129476,
                    "tau": 6.771377988215504
                },
                "weight": "10-9",
                "equipment": "p",
                "accuracy": 1.6046981987771423,
                "jockey": "Miss L Bradstock",
                "url": "/form/horse/Bendy-Bow/GB/3095956",
                "score": -1,
                "skillObj": {
                    "mu": 20.575939346615595,
                    "sigma": 1.6046981987771423,
                    "maxSkill": 23.785335744169878,
                    "minSkill": 17.366542949061312,
                    "muHistory": [
                        {
                            "date": 20191211,
                            "skill": 27.40145469384326
                        },
                        {
                            "date": 20191228,
                            "skill": 23.477574250836557
                        },
                        {
                            "date": 20200312,
                            "skill": 18.990760560579957
                        },
                        {
                            "date": 20200708,
                            "skill": 19.8876113748253
                        },
                        {
                            "date": 20200808,
                            "skill": 19.106394183958198
                        },
                        {
                            "date": 20201021,
                            "skill": 19.227111388254137
                        },
                        {
                            "date": 20211226,
                            "skill": 20.47395866431311
                        },
                        {
                            "date": 20220207,
                            "skill": 20.06133733088223
                        },
                        {
                            "date": 20220321,
                            "skill": 20.575939346615595
                        }
                    ]
                },
                "jockeyClaiming": 7,
                "trainer": "M Bradstock",
                "odds": "16/1",
                "skill": 20.06133733088223,
                "name": "Bendy Bow",
                "_id": "Bendy Bow_21-Mar-2022_16:30_Southwell",
                "position": 100,
                "age": "7",
                "oddsNumber": 16
            },
            {
                "weightNumber": 150,
                "raceId": "21-Mar-2022_16:30_Southwell",
                "rating": {
                    "pi": 0.24865831710122427,
                    "tau": 4.9224285859377845
                },
                "weight": "10-10",
                "equipment": "t",
                "accuracy": 1.8265475306004544,
                "jockey": "Bryan Carver",
                "url": "/form/horse/Bunny-Boru/GB/3240026",
                "score": -1,
                "skillObj": {
                    "mu": 20.489316099876934,
                    "sigma": 1.8265475306004544,
                    "maxSkill": 24.142411161077842,
                    "minSkill": 16.836221038676026,
                    "muHistory": [
                        {
                            "date": 20201116,
                            "skill": 27.94879116919048
                        },
                        {
                            "date": 20201207,
                            "skill": 25.79027688351492
                        },
                        {
                            "date": 20210103,
                            "skill": 20.990956394354875
                        },
                        {
                            "date": 20210307,
                            "skill": 20.498391171248922
                        },
                        {
                            "date": 20211119,
                            "skill": 18.912190208642183
                        },
                        {
                            "date": 20211220,
                            "skill": 19.79595391508241
                        },
                        {
                            "date": 20220321,
                            "skill": 20.489316099876934
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "Mrs Lawney Hill",
                "odds": "20/1",
                "skill": 19.79595391508241,
                "name": "Bunny Boru",
                "_id": "Bunny Boru_21-Mar-2022_16:30_Southwell",
                "position": 100,
                "age": "8",
                "oddsNumber": 20
            },
            {
                "weightNumber": 140,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:30_Southwell",
                "rating": {
                    "pi": 0.13551148896225948,
                    "tau": 1.7225822573753031
                },
                "weight": "10-0",
                "equipment": "p",
                "accuracy": 2.317683872105002,
                "jockey": "Harry Reed",
                "url": "/form/horse/Jump-Over-The-Moon/IRE/3346585",
                "score": -1,
                "skillObj": {
                    "mu": 15.865137335742386,
                    "sigma": 2.317683872105002,
                    "maxSkill": 20.50050507995239,
                    "minSkill": 11.229769591532381,
                    "muHistory": [
                        {
                            "date": 20211102,
                            "skill": 13.022733182585645
                        },
                        {
                            "date": 20211214,
                            "skill": 13.667415389129406
                        },
                        {
                            "date": 20220110,
                            "skill": 12.711706369450708
                        },
                        {
                            "date": 20220321,
                            "skill": 15.865137335742386
                        }
                    ]
                },
                "trainer": "N P Mulholland",
                "odds": "14/1",
                "skill": 12.711706369450708,
                "name": "Jump Over The Moon",
                "_id": "Jump Over The Moon_21-Mar-2022_16:30_Southwell",
                "position": 100,
                "age": "5",
                "oddsNumber": 14
            }
        ],
        "id": "#20220321#21-Mar-2022_16:30_Southwell",
        "classNumber": 5,
        "weather": "Sunny spells",
        "postNumber": 7,
        "predictedWinner": "Hillview",
        "location": "Southwell",
        "winnerPrizeMoney": "£5,446",
        "skillWinnerOdds": 7.5,
        "distanceCategory": "3miler",
        "runners": 13,
        "raceText": "Watch Off The Fence On Attheraces.com Handicap Hurdle",
        "isHandicap": true,
        "type": "jumps",
        "tagVersion": 42
    },
    {
        "raceType": "hurdle",
        "distance": "1m 7f 50y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:25:19.767Z",
        "time": "16:40",
        "country": "GB",
        "class": "jumps_class_4",
        "skillWinner": "State Crown",
        "going": "Good to soft-soft in places",
        "trackType": [
            "tight",
            "level"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 3063.2359999999994,
        "experienceCategory": "standard",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 1.875,
        "_id": "21-Mar-2022_16:40_Wincanton",
        "horses": [
            {
                "weightNumber": 166,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:40_Wincanton",
                "rating": {
                    "pi": 0.42337072493109495,
                    "tau": 12.538367357962949
                },
                "weight": "11-12",
                "accuracy": 1.4618174774380162,
                "jockey": "Isabel Williams",
                "url": "/form/horse/State-Crown/IRE/3114480",
                "score": 0.0621869370930911,
                "skillObj": {
                    "mu": 29.259482376984522,
                    "sigma": 1.4618174774380162,
                    "maxSkill": 32.18311733186056,
                    "minSkill": 26.33584742210849,
                    "muHistory": [
                        {
                            "date": 20201112,
                            "skill": 31.28123654115208
                        },
                        {
                            "date": 20201128,
                            "skill": 33.64866003469456
                        },
                        {
                            "date": 20210103,
                            "skill": 31.867082530019452
                        },
                        {
                            "date": 20210123,
                            "skill": 29.058909251808654
                        },
                        {
                            "date": 20210324,
                            "skill": 27.593875618654497
                        },
                        {
                            "date": 20210413,
                            "skill": 28.207711153507258
                        },
                        {
                            "date": 20210611,
                            "skill": 27.397412552070115
                        },
                        {
                            "date": 20210831,
                            "skill": 28.444044920469338
                        },
                        {
                            "date": 20211008,
                            "skill": 29.45514400213143
                        },
                        {
                            "date": 20211114,
                            "skill": 29.615574766072008
                        },
                        {
                            "date": 20220321,
                            "skill": 29.259482376984522
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "Evan Williams",
                "odds": "11/2",
                "skill": 29.615574766072008,
                "name": "State Crown",
                "_id": "State Crown_21-Mar-2022_16:40_Wincanton",
                "position": 100,
                "age": "5",
                "oddsNumber": 5.5
            },
            {
                "weightNumber": 158,
                "raceId": "21-Mar-2022_16:40_Wincanton",
                "rating": {
                    "pi": 0.11650908798105788,
                    "tau": 3.4314874293800823
                },
                "weight": "11-4",
                "accuracy": 2.4836435705204614,
                "jockey": "Brendan Powell",
                "url": "/form/horse/Harlem-Soul/GB/3227622",
                "score": 0.06487815317524338,
                "skillObj": {
                    "mu": 28.540868368427628,
                    "sigma": 2.4836435705204614,
                    "maxSkill": 33.50815550946855,
                    "minSkill": 23.573581227386704,
                    "muHistory": [
                        {
                            "date": 20220203,
                            "skill": 25.300094517894994
                        },
                        {
                            "date": 20220217,
                            "skill": 25.824384008295112
                        },
                        {
                            "date": 20220302,
                            "skill": 29.45253017462445
                        },
                        {
                            "date": 20220321,
                            "skill": 28.540868368427628
                        }
                    ]
                },
                "trainer": "C L Tizzard",
                "odds": "15/8",
                "skill": 29.45253017462445,
                "name": "Harlem Soul",
                "_id": "Harlem Soul_21-Mar-2022_16:40_Wincanton",
                "position": 100,
                "age": "4",
                "oddsNumber": 1.875
            },
            {
                "weightNumber": 165,
                "country": "FR",
                "raceId": "21-Mar-2022_16:40_Wincanton",
                "rating": {
                    "pi": 0.08866387639487423,
                    "tau": 2.49757306491226
                },
                "weight": "11-11",
                "equipment": "h",
                "accuracy": 2.723399223802401,
                "jockey": "Mr Finn Lambert",
                "url": "/form/horse/Lord-Of-Cheshire/FR/3346217",
                "score": 0.06343267919407904,
                "skillObj": {
                    "mu": 27.58195185944647,
                    "sigma": 2.723399223802401,
                    "maxSkill": 33.02875030705127,
                    "minSkill": 22.135153411841667,
                    "muHistory": [
                        {
                            "date": 20211101,
                            "skill": 22.500527606298736
                        },
                        {
                            "date": 20220209,
                            "skill": 28.169003730324697
                        },
                        {
                            "date": 20220321,
                            "skill": 27.58195185944647
                        }
                    ]
                },
                "jockeyClaiming": 10,
                "trainer": "N A Twiston-Davies",
                "odds": "13/8",
                "skill": 28.169003730324697,
                "name": "Lord Of Cheshire",
                "_id": "Lord Of Cheshire_21-Mar-2022_16:40_Wincanton",
                "position": 100,
                "age": "5",
                "oddsNumber": 1.625
            },
            {
                "weightNumber": 156,
                "raceId": "21-Mar-2022_16:40_Wincanton",
                "rating": {
                    "pi": 0.3039424971846771,
                    "tau": 8.13226346257193
                },
                "weight": "11-2",
                "accuracy": 1.6920022627219398,
                "jockey": "Nick Scholfield",
                "url": "/form/horse/Smiths-Bay/GB/3008460",
                "score": 0.055792517971232594,
                "skillObj": {
                    "mu": 26.72995748082475,
                    "sigma": 1.6920022627219398,
                    "maxSkill": 30.11396200626863,
                    "minSkill": 23.345952955380874,
                    "muHistory": [
                        {
                            "date": 20190222,
                            "skill": 22.532107203572334
                        },
                        {
                            "date": 20190322,
                            "skill": 25.512329364251766
                        },
                        {
                            "date": 20190506,
                            "skill": 28.257608178168
                        },
                        {
                            "date": 20190614,
                            "skill": 29.557000532786798
                        },
                        {
                            "date": 20191205,
                            "skill": 30.22655924639148
                        },
                        {
                            "date": 20200107,
                            "skill": 28.268050493899686
                        },
                        {
                            "date": 20220120,
                            "skill": 28.418449854009374
                        },
                        {
                            "date": 20220204,
                            "skill": 26.755927643875093
                        },
                        {
                            "date": 20220321,
                            "skill": 26.72995748082475
                        }
                    ]
                },
                "trainer": "Miss Polly Gundry",
                "skill": 26.755927643875093,
                "name": "Smith's Bay",
                "_id": "Smith's Bay_21-Mar-2022_16:40_Wincanton",
                "position": 100,
                "age": "9"
            },
            {
                "weightNumber": 153,
                "country": "FR",
                "raceId": "21-Mar-2022_16:40_Wincanton",
                "rating": {
                    "pi": 0.4087765705851334,
                    "tau": 10.918048385384731
                },
                "weight": "10-13",
                "accuracy": 1.4854508234526795,
                "jockey": "T J O'Brien",
                "url": "/form/horse/Man-Of-Light/FR/3148305",
                "score": -1,
                "skillObj": {
                    "mu": 26.68202885578342,
                    "sigma": 1.4854508234526795,
                    "maxSkill": 29.652930502688783,
                    "minSkill": 23.71112720887806,
                    "muHistory": [
                        {
                            "date": 20210413,
                            "skill": 26.952098202670104
                        },
                        {
                            "date": 20210505,
                            "skill": 21.556998440806602
                        },
                        {
                            "date": 20210525,
                            "skill": 24.78643254717181
                        },
                        {
                            "date": 20210620,
                            "skill": 25.537946244110923
                        },
                        {
                            "date": 20210924,
                            "skill": 25.171841729242715
                        },
                        {
                            "date": 20211012,
                            "skill": 25.05470188625518
                        },
                        {
                            "date": 20211108,
                            "skill": 26.298134247080974
                        },
                        {
                            "date": 20211122,
                            "skill": 26.890144278471425
                        },
                        {
                            "date": 20220122,
                            "skill": 26.709085527471288
                        },
                        {
                            "date": 20220321,
                            "skill": 26.68202885578342
                        }
                    ]
                },
                "trainer": "P J Hobbs",
                "odds": "15/2",
                "skill": 26.709085527471288,
                "name": "Man Of Light",
                "_id": "Man Of Light_21-Mar-2022_16:40_Wincanton",
                "position": 100,
                "age": "5",
                "oddsNumber": 7.5
            },
            {
                "weightNumber": 149,
                "country": "FR",
                "raceId": "21-Mar-2022_16:40_Wincanton",
                "rating": {
                    "pi": 0.05210122491087979,
                    "tau": 1.2431062875952705
                },
                "weight": "10-9",
                "accuracy": 3.181838662391478,
                "jockey": "James Best",
                "url": "/form/horse/Gambie-Tiep/FR/3155151",
                "score": -1,
                "skillObj": {
                    "mu": 25.26461621766442,
                    "sigma": 3.181838662391478,
                    "maxSkill": 31.628293542447373,
                    "minSkill": 18.900938892881463,
                    "muHistory": [
                        {
                            "date": 20220108,
                            "skill": 23.85944456625788
                        },
                        {
                            "date": 20220321,
                            "skill": 25.26461621766442
                        }
                    ]
                },
                "trainer": "Robert Walford",
                "odds": "10/1",
                "skill": 23.85944456625788,
                "name": "Gambie Tiep",
                "_id": "Gambie Tiep_21-Mar-2022_16:40_Wincanton",
                "position": 100,
                "age": "6",
                "oddsNumber": 10
            },
            {
                "weightNumber": 141,
                "country": "IRE",
                "raceId": "21-Mar-2022_16:40_Wincanton",
                "rating": {
                    "pi": 0.08297093526489294,
                    "tau": 1.5736056989696343
                },
                "weight": "10-1",
                "accuracy": 2.7864283235759655,
                "jockey": "David Noonan",
                "url": "/form/horse/Moved-In-March/IRE/3277380",
                "score": -1,
                "skillObj": {
                    "mu": 22.031082749604007,
                    "sigma": 2.7864283235759655,
                    "maxSkill": 27.603939396755937,
                    "minSkill": 16.458226102452077,
                    "muHistory": [
                        {
                            "date": 20210325,
                            "skill": 12.119224185687898
                        },
                        {
                            "date": 20210411,
                            "skill": 18.9657461850435
                        },
                        {
                            "date": 20220321,
                            "skill": 22.031082749604007
                        }
                    ]
                },
                "trainer": "Maxwell Young",
                "odds": "33/1",
                "skill": 18.9657461850435,
                "name": "Moved In March",
                "_id": "Moved In March_21-Mar-2022_16:40_Wincanton",
                "position": 100,
                "age": "6",
                "oddsNumber": 33
            }
        ],
        "id": "#20220321#21-Mar-2022_16:40_Wincanton",
        "classNumber": 4,
        "weather": "Sunny spells",
        "postNumber": 6,
        "predictedWinner": "Harlem Soul",
        "location": "Wincanton",
        "winnerPrizeMoney": "£3,976",
        "skillWinnerOdds": 5.5,
        "distanceCategory": "2miler",
        "runners": 7,
        "raceText": "Get Daily Tips At racingtv.com Handicap Hurdle",
        "isHandicap": true,
        "type": "jumps",
        "tagVersion": 42
    },
    {
        "raceType": "hurdle",
        "distance": "2m 5f 82y",
        "dateNumber": 20220321,
        "lastModified": "2022-03-21T09:24:58.545Z",
        "time": "17:10",
        "country": "GB",
        "class": "jumps_class_5",
        "skillWinner": "Wetanwindy",
        "going": "Good to soft-soft in places",
        "trackType": [
            "tight",
            "level"
        ],
        "date": "21-Mar-2022",
        "distanceNumber": 4299.5008,
        "experienceCategory": "standard",
        "drawAdvantage": "None",
        "predictedWinnerOdds": 2.5,
        "_id": "21-Mar-2022_17:10_Wincanton",
        "horses": [
            {
                "weightNumber": 170,
                "raceId": "21-Mar-2022_17:10_Wincanton",
                "rating": {
                    "pi": 0.1746000015599361,
                    "tau": 4.863463331073743
                },
                "weight": "12-2",
                "accuracy": 2.1108406376610116,
                "jockey": "Mitchell Bastyan",
                "url": "/form/horse/Wetanwindy/GB/3160344",
                "score": 0.05375116522387546,
                "skillObj": {
                    "mu": 26.849423316621273,
                    "sigma": 2.1108406376610116,
                    "maxSkill": 31.071104591943296,
                    "minSkill": 22.62774204129925,
                    "muHistory": [
                        {
                            "date": 20220117,
                            "skill": 25.517786607810123
                        },
                        {
                            "date": 20220126,
                            "skill": 24.310209273486006
                        },
                        {
                            "date": 20220203,
                            "skill": 24.888612292778692
                        },
                        {
                            "date": 20220310,
                            "skill": 27.85488709978178
                        },
                        {
                            "date": 20220321,
                            "skill": 26.849423316621273
                        }
                    ]
                },
                "trainer": "M F Harris",
                "odds": "5/2",
                "skill": 27.85488709978178,
                "name": "Wetanwindy",
                "_id": "Wetanwindy_21-Mar-2022_17:10_Wincanton",
                "position": 100,
                "age": "7",
                "oddsNumber": 2.5
            },
            {
                "weightNumber": 164,
                "raceId": "21-Mar-2022_17:10_Wincanton",
                "rating": {
                    "pi": 0.2320689001612697,
                    "tau": 6.333995369515346
                },
                "weight": "11-10",
                "equipment": "t",
                "accuracy": 1.8798284646858803,
                "jockey": "Charlie Deutsch",
                "url": "/form/horse/Lazy-Sunday/GB/3152556",
                "score": 0.04350043281710068,
                "skillObj": {
                    "mu": 26.55241304168844,
                    "sigma": 1.8798284646858803,
                    "maxSkill": 30.3120699710602,
                    "minSkill": 22.792756112316678,
                    "muHistory": [
                        {
                            "date": 20211102,
                            "skill": 26.269697337160746
                        },
                        {
                            "date": 20211121,
                            "skill": 26.630275891609546
                        },
                        {
                            "date": 20211209,
                            "skill": 27.8286013869892
                        },
                        {
                            "date": 20211231,
                            "skill": 25.63181995166329
                        },
                        {
                            "date": 20220207,
                            "skill": 27.293598431817948
                        },
                        {
                            "date": 20220321,
                            "skill": 26.55241304168844
                        }
                    ]
                },
                "trainer": "R Mitford-slade",
                "odds": "7/1",
                "skill": 27.293598431817948,
                "name": "Lazy Sunday",
                "_id": "Lazy Sunday_21-Mar-2022_17:10_Wincanton",
                "position": 100,
                "age": "8",
                "oddsNumber": 7
            },
            {
                "weightNumber": 166,
                "country": "FR",
                "raceId": "21-Mar-2022_17:10_Wincanton",
                "rating": {
                    "pi": 0.54038100371559,
                    "tau": 14.447763384866272
                },
                "weight": "11-12",
                "accuracy": 1.3032942572351986,
                "jockey": "G Sheehan",
                "url": "/form/horse/Megaudais-Speed/FR/3065456",
                "score": 0.04958985937228867,
                "skillObj": {
                    "mu": 26.449867958735638,
                    "sigma": 1.3032942572351986,
                    "maxSkill": 29.056456473206033,
                    "minSkill": 23.843279444265242,
                    "muHistory": [
                        {
                            "date": 20181220,
                            "skill": 20.209351732437316
                        },
                        {
                            "date": 20190318,
                            "skill": 23.34557421368367
                        },
                        {
                            "date": 20191113,
                            "skill": 24.4571856985295
                        },
                        {
                            "date": 20191206,
                            "skill": 22.027609461428646
                        },
                        {
                            "date": 20210220,
                            "skill": 24.709962957986956
                        },
                        {
                            "date": 20210323,
                            "skill": 24.45103110055451
                        },
                        {
                            "date": 20210410,
                            "skill": 25.773733701457445
                        },
                        {
                            "date": 20211026,
                            "skill": 24.93325249679463
                        },
                        {
                            "date": 20211112,
                            "skill": 25.282044365551506
                        },
                        {
                            "date": 20220204,
                            "skill": 25.807987531738245
                        },
                        {
                            "date": 20220219,
                            "skill": 26.393413392258715
                        },
                        {
                            "date": 20220310,
                            "skill": 26.736253283378428
                        },
                        {
                            "date": 20220321,
                            "skill": 26.449867958735638
                        }
                    ]
                },
                "trainer": "Mrs L J Young",
                "odds": "6/1",
                "skill": 26.736253283378428,
                "name": "Megaudais Speed",
                "_id": "Megaudais Speed_21-Mar-2022_17:10_Wincanton",
                "position": 100,
                "age": "10",
                "oddsNumber": 6
            },
            {
                "weightNumber": 152,
                "country": "IRE",
                "raceId": "21-Mar-2022_17:10_Wincanton",
                "rating": {
                    "pi": 2.0863300336414383,
                    "tau": 52.86940028463084
                },
                "weight": "10-12",
                "equipment": "p",
                "accuracy": 0.6888385059685761,
                "jockey": "Mr Peter Summers",
                "url": "/form/horse/Catchin-Time/IRE/2757856",
                "score": -1,
                "skillObj": {
                    "mu": 25.28777682338721,
                    "sigma": 0.6888385059685761,
                    "maxSkill": 26.66545383532436,
                    "minSkill": 23.910099811450056,
                    "muHistory": [
                        {
                            "date": 20130101,
                            "skill": 21.65087627353399
                        },
                        {
                            "date": 20131017,
                            "skill": 22.40376310688156
                        },
                        {
                            "date": 20131117,
                            "skill": 19.691131951429934
                        },
                        {
                            "date": 20131205,
                            "skill": 16.936190543100285
                        },
                        {
                            "date": 20140105,
                            "skill": 18.146292179963574
                        },
                        {
                            "date": 20140130,
                            "skill": 18.19587110875855
                        },
                        {
                            "date": 20140414,
                            "skill": 19.70698587076188
                        },
                        {
                            "date": 20140422,
                            "skill": 21.373037718141408
                        },
                        {
                            "date": 20140509,
                            "skill": 21.16044040625107
                        },
                        {
                            "date": 20140610,
                            "skill": 21.088726367842753
                        },
                        {
                            "date": 20140711,
                            "skill": 21.21741518370791
                        },
                        {
                            "date": 20140721,
                            "skill": 21.128186031788402
                        },
                        {
                            "date": 20140829,
                            "skill": 21.085556478217047
                        },
                        {
                            "date": 20141210,
                            "skill": 21.31183793804838
                        },
                        {
                            "date": 20141226,
                            "skill": 21.48186761643441
                        },
                        {
                            "date": 20150128,
                            "skill": 22.160208694836395
                        },
                        {
                            "date": 20150209,
                            "skill": 22.812631615525888
                        },
                        {
                            "date": 20150216,
                            "skill": 23.19069486845407
                        },
                        {
                            "date": 20150413,
                            "skill": 22.83343340089063
                        },
                        {
                            "date": 20150430,
                            "skill": 22.60930569023283
                        },
                        {
                            "date": 20151027,
                            "skill": 22.464169941850578
                        },
                        {
                            "date": 20151116,
                            "skill": 22.046120020484718
                        },
                        {
                            "date": 20151211,
                            "skill": 22.227438729589952
                        },
                        {
                            "date": 20151231,
                            "skill": 22.84132042389912
                        },
                        {
                            "date": 20160107,
                            "skill": 23.08457827987662
                        },
                        {
                            "date": 20160126,
                            "skill": 23.251930809584238
                        },
                        {
                            "date": 20160213,
                            "skill": 23.768068306133593
                        },
                        {
                            "date": 20160303,
                            "skill": 24.07043893975222
                        },
                        {
                            "date": 20160330,
                            "skill": 24.525358247295664
                        },
                        {
                            "date": 20160409,
                            "skill": 24.327409214959488
                        },
                        {
                            "date": 20161210,
                            "skill": 23.939082610136413
                        },
                        {
                            "date": 20161221,
                            "skill": 23.920976580389034
                        },
                        {
                            "date": 20170102,
                            "skill": 23.989825845561697
                        },
                        {
                            "date": 20170116,
                            "skill": 24.243447303534676
                        },
                        {
                            "date": 20170211,
                            "skill": 24.684877368931254
                        },
                        {
                            "date": 20170225,
                            "skill": 24.613044319895625
                        },
                        {
                            "date": 20170309,
                            "skill": 24.807011551152033
                        },
                        {
                            "date": 20171203,
                            "skill": 24.836638486359238
                        },
                        {
                            "date": 20171230,
                            "skill": 24.816439139611024
                        },
                        {
                            "date": 20180123,
                            "skill": 24.58648376338124
                        },
                        {
                            "date": 20180210,
                            "skill": 24.435847785888406
                        },
                        {
                            "date": 20180308,
                            "skill": 24.566092513425428
                        },
                        {
                            "date": 20180329,
                            "skill": 24.63515419961615
                        },
                        {
                            "date": 20180407,
                            "skill": 24.79404989945045
                        },
                        {
                            "date": 20180510,
                            "skill": 24.98901557016174
                        },
                        {
                            "date": 20180527,
                            "skill": 25.210566387599606
                        },
                        {
                            "date": 20180606,
                            "skill": 25.39171142372439
                        },
                        {
                            "date": 20181115,
                            "skill": 25.481550624265708
                        },
                        {
                            "date": 20181125,
                            "skill": 25.6057653539967
                        },
                        {
                            "date": 20181214,
                            "skill": 25.62986820880113
                        },
                        {
                            "date": 20190105,
                            "skill": 25.700092469528432
                        },
                        {
                            "date": 20190120,
                            "skill": 25.473774772944974
                        },
                        {
                            "date": 20190225,
                            "skill": 25.60107621828974
                        },
                        {
                            "date": 20190409,
                            "skill": 25.531691575942986
                        },
                        {
                            "date": 20190509,
                            "skill": 25.450098882811115
                        },
                        {
                            "date": 20190607,
                            "skill": 25.295032764993273
                        },
                        {
                            "date": 20190713,
                            "skill": 25.297145373349736
                        },
                        {
                            "date": 20201126,
                            "skill": 25.130040426926758
                        },
                        {
                            "date": 20210329,
                            "skill": 25.41640961627525
                        },
                        {
                            "date": 20210418,
                            "skill": 25.435647731285286
                        },
                        {
                            "date": 20210524,
                            "skill": 25.60994855490723
                        },
                        {
                            "date": 20210625,
                            "skill": 25.563214401253116
                        },
                        {
                            "date": 20210630,
                            "skill": 25.491632517813617
                        },
                        {
                            "date": 20211230,
                            "skill": 25.34086143233708
                        },
                        {
                            "date": 20220321,
                            "skill": 25.28777682338721
                        }
                    ]
                },
                "jockeyClaiming": 7,
                "trainer": "Miss L Hurley",
                "odds": "33/1",
                "skill": 25.34086143233708,
                "name": "Catchin Time",
                "_id": "Catchin Time_21-Mar-2022_17:10_Wincanton",
                "position": 100,
                "age": "14",
                "oddsNumber": 33
            },
            {
                "weightNumber": 159,
                "raceId": "21-Mar-2022_17:10_Wincanton",
                "rating": {
                    "pi": 0.24410546199350197,
                    "tau": 5.817516400925812
                },
                "weight": "11-5",
                "accuracy": 1.842750446729341,
                "jockey": "Stan Sheppard",
                "url": "/form/horse/Roger-Rarebit/GB/3257503",
                "score": 0.04859587038224716,
                "skillObj": {
                    "mu": 23.809171023567473,
                    "sigma": 1.842750446729341,
                    "maxSkill": 27.494671917026153,
                    "minSkill": 20.123670130108792,
                    "muHistory": [
                        {
                            "date": 20211029,
                            "skill": 19.62945266720867
                        },
                        {
                            "date": 20211115,
                            "skill": 20.370018688326674
                        },
                        {
                            "date": 20211207,
                            "skill": 21.955266962335813
                        },
                        {
                            "date": 20220106,
                            "skill": 22.249708504026763
                        },
                        {
                            "date": 20220216,
                            "skill": 23.831979642801574
                        },
                        {
                            "date": 20220321,
                            "skill": 23.809171023567473
                        }
                    ]
                },
                "trainer": "Tom Lacey",
                "odds": "4/1",
                "skill": 23.831979642801574,
                "name": "Roger Rarebit",
                "_id": "Roger Rarebit_21-Mar-2022_17:10_Wincanton",
                "position": 100,
                "age": "5",
                "oddsNumber": 4
            },
            {
                "weightNumber": 163,
                "country": "IRE",
                "raceId": "21-Mar-2022_17:10_Wincanton",
                "rating": {
                    "pi": 0.31561680241683937,
                    "tau": 7.465963620308701
                },
                "weight": "11-9",
                "accuracy": 1.6526664884683442,
                "jockey": "Ben Godfrey",
                "url": "/form/horse/Caspers-Court/IRE/3018923",
                "score": -1,
                "skillObj": {
                    "mu": 23.623846050521625,
                    "sigma": 1.6526664884683442,
                    "maxSkill": 26.929179027458314,
                    "minSkill": 20.318513073584935,
                    "muHistory": [
                        {
                            "date": 20190101,
                            "skill": 21.69057473817749
                        },
                        {
                            "date": 20190204,
                            "skill": 24.20566342300627
                        },
                        {
                            "date": 20190307,
                            "skill": 23.384359076246398
                        },
                        {
                            "date": 20191128,
                            "skill": 22.614185080582907
                        },
                        {
                            "date": 20200126,
                            "skill": 21.0587854683241
                        },
                        {
                            "date": 20201020,
                            "skill": 23.027993444731262
                        },
                        {
                            "date": 20201111,
                            "skill": 23.655152587371763
                        },
                        {
                            "date": 20220321,
                            "skill": 23.623846050521625
                        }
                    ]
                },
                "jockeyClaiming": 3,
                "trainer": "Kayley Woollacott",
                "odds": "20/1",
                "skill": 23.655152587371763,
                "name": "Caspers Court",
                "_id": "Caspers Court_21-Mar-2022_17:10_Wincanton",
                "position": 100,
                "age": "8",
                "oddsNumber": 20
            },
            {
                "weightNumber": 147,
                "raceId": "21-Mar-2022_17:10_Wincanton",
                "rating": {
                    "pi": 0.1359553563989575,
                    "tau": 3.1714609241525893
                },
                "weight": "10-7",
                "equipment": "t",
                "accuracy": 2.3113339304471507,
                "jockey": "Mr T Durrell",
                "url": "/form/horse/Night-In-Manhattan/GB/3281984",
                "score": 0.04054480498566941,
                "skillObj": {
                    "mu": 23.381994412189325,
                    "sigma": 2.3113339304471507,
                    "maxSkill": 28.004662273083625,
                    "minSkill": 18.759326551295025,
                    "muHistory": [
                        {
                            "date": 20210308,
                            "skill": 22.55449005151536
                        },
                        {
                            "date": 20211020,
                            "skill": 23.903528690160854
                        },
                        {
                            "date": 20211217,
                            "skill": 23.32722305435336
                        },
                        {
                            "date": 20220321,
                            "skill": 23.381994412189325
                        }
                    ]
                },
                "jockeyClaiming": 7,
                "trainer": "D Skelton",
                "odds": "6/1",
                "skill": 23.32722305435336,
                "name": "Night In Manhattan",
                "_id": "Night In Manhattan_21-Mar-2022_17:10_Wincanton",
                "position": 100,
                "age": "6",
                "oddsNumber": 6
            },
            {
                "weightNumber": 155,
                "raceId": "21-Mar-2022_17:10_Wincanton",
                "rating": {
                    "pi": 0.3154017226421372,
                    "tau": 7.106720766705495
                },
                "weight": "11-1",
                "accuracy": 1.653560123073875,
                "jockey": "Alan Johns",
                "url": "/form/horse/Isle-Of-Aron/GB/3160322",
                "score": 0.04815874682434226,
                "skillObj": {
                    "mu": 22.705360381852877,
                    "sigma": 1.653560123073875,
                    "maxSkill": 26.012480628000628,
                    "minSkill": 19.398240135705127,
                    "muHistory": [
                        {
                            "date": 20210223,
                            "skill": 18.030636482531573
                        },
                        {
                            "date": 20210323,
                            "skill": 19.038073450883218
                        },
                        {
                            "date": 20210405,
                            "skill": 19.5970218822798
                        },
                        {
                            "date": 20210504,
                            "skill": 22.49499907983352
                        },
                        {
                            "date": 20210527,
                            "skill": 23.00966769358835
                        },
                        {
                            "date": 20211019,
                            "skill": 22.032961620146448
                        },
                        {
                            "date": 20211124,
                            "skill": 22.53228266216212
                        },
                        {
                            "date": 20220321,
                            "skill": 22.705360381852877
                        }
                    ]
                },
                "trainer": "Tim Vaughan",
                "odds": "12/1",
                "skill": 22.53228266216212,
                "name": "Isle Of Aron",
                "_id": "Isle Of Aron_21-Mar-2022_17:10_Wincanton",
                "position": 100,
                "age": "6",
                "oddsNumber": 12
            },
            {
                "weightNumber": 154,
                "country": "FR",
                "raceId": "21-Mar-2022_17:10_Wincanton",
                "rating": {
                    "pi": 0.20083021730223632,
                    "tau": 4.256693869274319
                },
                "weight": "11-0",
                "accuracy": 1.9958443387395186,
                "jockey": "Brendan Powell",
                "url": "/form/horse/Farceur-De-Maulne/FR/3238620",
                "score": -1,
                "skillObj": {
                    "mu": 21.65820848291267,
                    "sigma": 1.9958443387395186,
                    "maxSkill": 25.649897160391706,
                    "minSkill": 17.666519805433634,
                    "muHistory": [
                        {
                            "date": 20211110,
                            "skill": 21.99055081463355
                        },
                        {
                            "date": 20211202,
                            "skill": 21.352093952745896
                        },
                        {
                            "date": 20211214,
                            "skill": 20.74870815630808
                        },
                        {
                            "date": 20220227,
                            "skill": 21.195485054264882
                        },
                        {
                            "date": 20220321,
                            "skill": 21.65820848291267
                        }
                    ]
                },
                "trainer": "Richard Hawker",
                "odds": "33/1",
                "skill": 21.195485054264882,
                "name": "Farceur De Maulne",
                "_id": "Farceur De Maulne_21-Mar-2022_17:10_Wincanton",
                "position": 100,
                "age": "7",
                "oddsNumber": 33
            },
            {
                "weightNumber": 166,
                "country": "IRE",
                "raceId": "21-Mar-2022_17:10_Wincanton",
                "rating": {
                    "pi": 0.22666956835268068,
                    "tau": 4.716007513730957
                },
                "weight": "11-12",
                "equipment": "p",
                "accuracy": 1.8982293429908532,
                "jockey": "Kieren Buckley",
                "url": "/form/horse/Novus-Aditus/IRE/3064960",
                "score": 0.04506370865657236,
                "skillObj": {
                    "mu": 21.372404414518755,
                    "sigma": 1.8982293429908532,
                    "maxSkill": 25.16886310050046,
                    "minSkill": 17.57594572853705,
                    "muHistory": [
                        {
                            "date": 20190828,
                            "skill": 17.310997267513518
                        },
                        {
                            "date": 20191002,
                            "skill": 18.69095567363757
                        },
                        {
                            "date": 20191230,
                            "skill": 21.30314477999242
                        },
                        {
                            "date": 20211226,
                            "skill": 20.328806924953287
                        },
                        {
                            "date": 20220303,
                            "skill": 20.805649157072583
                        },
                        {
                            "date": 20220321,
                            "skill": 21.372404414518755
                        }
                    ]
                },
                "jockeyClaiming": 5,
                "trainer": "N J Hawke",
                "odds": "8/1",
                "skill": 20.805649157072583,
                "name": "Novus Aditus",
                "_id": "Novus Aditus_21-Mar-2022_17:10_Wincanton",
                "position": 100,
                "age": "6",
                "oddsNumber": 8
            },
            {
                "weightNumber": 147,
                "country": "IRE",
                "raceId": "21-Mar-2022_17:10_Wincanton",
                "rating": {
                    "pi": 0.1806080831464418,
                    "tau": 3.6092136224503135
                },
                "weight": "10-7",
                "accuracy": 2.083187393829736,
                "jockey": "David Noonan",
                "url": "/form/horse/My-Rockstar/IRE/3231709",
                "score": -1,
                "skillObj": {
                    "mu": 20.77259875411159,
                    "sigma": 2.083187393829736,
                    "maxSkill": 24.938973541771063,
                    "minSkill": 16.60622396645212,
                    "muHistory": [
                        {
                            "date": 20210730,
                            "skill": 21.77966737859148
                        },
                        {
                            "date": 20211230,
                            "skill": 19.390341773002145
                        },
                        {
                            "date": 20220120,
                            "skill": 18.908598248617512
                        },
                        {
                            "date": 20220207,
                            "skill": 19.98367713987567
                        },
                        {
                            "date": 20220321,
                            "skill": 20.77259875411159
                        }
                    ]
                },
                "trainer": "Mrs H E Rees",
                "odds": "33/1",
                "skill": 19.98367713987567,
                "name": "My Rockstar",
                "_id": "My Rockstar_21-Mar-2022_17:10_Wincanton",
                "position": 100,
                "age": "6",
                "oddsNumber": 33
            },
            {
                "weightNumber": 143,
                "country": "IRE",
                "raceId": "21-Mar-2022_17:10_Wincanton",
                "rating": {
                    "pi": 0.5325710484660287,
                    "tau": 10.35992197725197
                },
                "weight": "10-3",
                "equipment": "v",
                "accuracy": 1.3115283854930766,
                "jockey": "David Prichard",
                "url": "/form/horse/Comeragh-Lad/IRE/3082992",
                "score": -1,
                "skillObj": {
                    "mu": 19.830632823955195,
                    "sigma": 1.3115283854930766,
                    "maxSkill": 22.45368959494135,
                    "minSkill": 17.207576052969042,
                    "muHistory": [
                        {
                            "date": 20190321,
                            "skill": 19.434941535200455
                        },
                        {
                            "date": 20190405,
                            "skill": 16.036433403509193
                        },
                        {
                            "date": 20201008,
                            "skill": 15.311019917850604
                        },
                        {
                            "date": 20201028,
                            "skill": 17.074257762643697
                        },
                        {
                            "date": 20201122,
                            "skill": 19.476085152667284
                        },
                        {
                            "date": 20201217,
                            "skill": 19.2640456988197
                        },
                        {
                            "date": 20210413,
                            "skill": 19.580830808376543
                        },
                        {
                            "date": 20210512,
                            "skill": 19.863242815035637
                        },
                        {
                            "date": 20211102,
                            "skill": 19.00085238580107
                        },
                        {
                            "date": 20211115,
                            "skill": 19.519721772453813
                        },
                        {
                            "date": 20220314,
                            "skill": 19.452657081326123
                        },
                        {
                            "date": 20220321,
                            "skill": 19.830632823955195
                        }
                    ]
                },
                "jockeyClaiming": 5,
                "trainer": "Ryan Chapman",
                "odds": "33/1",
                "skill": 19.452657081326123,
                "name": "Comeragh Lad",
                "_id": "Comeragh Lad_21-Mar-2022_17:10_Wincanton",
                "position": 100,
                "age": "8",
                "oddsNumber": 33
            }
        ],
        "id": "#20220321#21-Mar-2022_17:10_Wincanton",
        "classNumber": 5,
        "weather": "Sunny spells",
        "postNumber": 7,
        "predictedWinner": "Wetanwindy",
        "location": "Wincanton",
        "winnerPrizeMoney": "£2,941",
        "skillWinnerOdds": 2.5,
        "distanceCategory": "2.5miler",
        "runners": 12,
        "raceText": "Racing TV On Sky 426 Handicap Hurdle",
        "isHandicap": true,
        "type": "jumps",
        "tagVersion": 42
    }
]
